/**
 * Sync nav boot — <head>, no defer.
 * Mount #sa-fixed-nav once into #header-component.
 * Page scroll lives in #sa-content-scroll (below header) — never move SCRIPT nodes.
 */
(function () {
  if (window.__saNavBoot) return;
  window.__saNavBoot = 1;

  /* Shopify /challenge|/password: mount full nav, but never build scroll-shell */
  var saBootPath = (location.pathname || "/").replace(/\/$/, "") || "/";
  var SA_SYSTEM = /^\/(challenge|password)$/i.test(saBootPath);
  if (SA_SYSTEM) {
    try {
      /* Do NOT claim sa-nav-placed until #sa-fixed-nav is actually mounted */
      document.documentElement.classList.add(
        "sa-system-page",
        "sa-paint-ready",
        "sa-header-ready"
      );
      document.documentElement.setAttribute("data-sa-challenge", "1");
      /* Captcha is not a store route — never fake Contact/Home as active */
      document.documentElement.removeAttribute("data-sa-nav");
    } catch (_sys) {}
  }

  /* Lock theme icon tokens on :root BEFORE body paints — stops Tinker --button-size / --icon-size CLS */
  try {
    var root = document.documentElement;
    root.style.setProperty("--icon-size", "22px");
    root.style.setProperty("--icon-size-2xs", "22px");
    root.style.setProperty("--icon-size-xs", "22px");
    root.style.setProperty("--icon-size-sm", "22px");
    root.style.setProperty("--icon-size-md", "22px");
    root.style.setProperty("--button-size", "44px");
  } catch (_vars) {}

  /*
   * Early glyph swap in SYNC boot (not deferred icons.js).
   * Deferred polish swapping theme SVG (viewBox 14/20) for SA (24) caused an optical size jump.
   */
  var SA_EARLY_ICONS = {
    search:
      '<svg class="sa-icon-svg" viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden="true" focusable="false">' +
      '<circle cx="11" cy="11" r="6" stroke="currentColor" stroke-width="1.5"/>' +
      '<path d="M15.75 15.75L20 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
      "</svg>",
    bag:
      '<svg class="sa-icon-svg sa-icon-svg--bag" viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true" focusable="false" style="opacity: 1 !important; visibility: visible !important; display: block !important; width: 22px !important; height: 22px !important;">' +
      '<path d="M6 7.75h12l-.85 11.1A1.6 1.6 0 0 1 15.57 20.5H8.43a1.6 1.6 0 0 1-1.58-1.65L6 7.75Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
      '<path d="M9.25 7.75V6.55a2.75 2.75 0 0 1 5.5 0v1.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
      "</svg>",
    menu:
      '<svg class="sa-icon-svg sa-icon-svg--menu" viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="M4.5 7h15M4.5 12h15M4.5 17h15" stroke="currentColor" stroke-width="1.85" stroke-linecap="round"/>' +
      "</svg>",
    user:
      '<svg class="sa-icon-svg" viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden="true" focusable="false">' +
      '<circle cx="12" cy="8.75" r="3.35" stroke="currentColor" stroke-width="1.6"/>' +
      '<path d="M5.75 18.75c1.4-2.45 3.55-3.7 6.25-3.7s4.85 1.25 6.25 3.7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
      "</svg>",
  };

  function saEarlySwapHost(host, kind) {
    if (!host || !SA_EARLY_ICONS[kind]) return;
    if (host.getAttribute("data-sa-icon") === kind && host.querySelector(".sa-icon-svg")) {
    return;
    }
    var wrap =
      host.querySelector(":scope > .svg-wrapper, .header-drawer-icon--open, .svg-wrapper") || null;
    if (wrap) {
      wrap.innerHTML = SA_EARLY_ICONS[kind];
      wrap.style.setProperty("width", "44px", "important");
      wrap.style.setProperty("height", "44px", "important");
      wrap.style.setProperty("display", "inline-flex", "important");
      wrap.style.setProperty("align-items", "center", "important");
      wrap.style.setProperty("justify-content", "center", "important");
      wrap.style.setProperty("transition", "none", "important");
    } else {
      var svg = host.querySelector("svg");
      if (svg && svg.parentNode) {
        var tmp = document.createElement("span");
        tmp.innerHTML = SA_EARLY_ICONS[kind];
        if (tmp.firstChild) svg.parentNode.replaceChild(tmp.firstChild, svg);
      }
    }
    host.setAttribute("data-sa-icon", kind);
    host.style.setProperty("width", "44px", "important");
    host.style.setProperty("height", "44px", "important");
    host.style.setProperty("min-width", "44px", "important");
    host.style.setProperty("transition", "none", "important");
    var glyph = host.querySelector("svg, .sa-icon-svg");
    if (glyph) {
      var size = kind === "bag" ? "24px" : "22px";
      glyph.style.setProperty("width", size, "important");
      glyph.style.setProperty("height", size, "important");
    }
  }

  function saEarlyPolishIcons() {
    try {
      var h =
        document.querySelector("#header-component") ||
        document.querySelector("header-component") ||
        document;
      h.querySelectorAll(
        "search-button, .header__icon--search, summary.header__icon--search, a.header__icon--search, .header-search",
      ).forEach(function (el) {
        if (el.closest && el.closest("[data-sa-search-dupe]")) return;
        saEarlySwapHost(el, "search");
      });
      h.querySelectorAll("cart-icon, .header__icon--cart, a.header__icon--cart").forEach(function (el) {
        saEarlySwapHost(el, "bag");
      });
      /* Profile: inject ONE login glyph on outermost host only — nested
       * account-button + .header__icon--account was creating a duplicate peek. */
      (function earlyAccount() {
        if (window.__saIsAccountUiOpen && window.__saIsAccountUiOpen()) return;
        if (Date.now() < (window.__saAccountUiLockUntil || 0)) return;
        var nodes = h.querySelectorAll(
          "account-button, .account-button, .header__icon--account, a.header__icon--account",
        );
        var hosts = [];
        var seen = [];
        for (var ai = 0; ai < nodes.length; ai++) {
          var n = nodes[ai];
          var outer =
            (n.closest && n.closest("account-button, [data-sa-login-fallback]")) || n;
          if (seen.indexOf(outer) !== -1) continue;
          seen.push(outer);
          hosts.push(outer);
        }
        if (!hosts.length) return;
        var el = hosts[0];
        var saEl = el.querySelector("shopify-account");
        var signedIn = false;
        try {
          if (window.__saIsShopifySignedIn) signedIn = !!window.__saIsShopifySignedIn(saEl);
          else if (saEl && saEl.shadowRoot) {
            var sr = saEl.shadowRoot;
            if (sr.querySelector("img")) signedIn = true;
            else {
              var avs = sr.querySelectorAll('[class*="avatar"], [part*="avatar"], button');
              for (var si = 0; si < avs.length; si++) {
                var at = (avs[si].textContent || "").replace(/\s+/g, "").trim();
                if (at.length === 1 && /[A-Za-z0-9]/.test(at)) {
                  signedIn = true;
                  break;
                }
                if (!avs[si].querySelector("svg, img")) continue;
                var bg = window.getComputedStyle(avs[si]).backgroundColor || "";
                var mm = bg.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/);
                if (mm && !(+mm[1] > 245 && +mm[2] > 245 && +mm[3] > 245)) {
                  signedIn = true;
                  break;
                }
              }
            }
          }
        } catch (_si) {}

        /* Liquid head already knows customer — don't flip to signed-out / login
         * while shopify-account shadow is still mounting. */
        var liquidKnownIn =
          document.documentElement.getAttribute("data-sa-customer") === "1" ||
          (document.documentElement.classList.contains("sa-account-signed-in") &&
            !document.documentElement.classList.contains("sa-account-signed-out"));
        if (!signedIn && liquidKnownIn) {
          signedIn = true;
        }

        /* Strip ALL login outlines when signed-in (was stacking on avatar) */
        var allLogin = el.querySelectorAll("[data-sa-login-icon], .sa-login-icon");
        if (signedIn) {
          for (var ri = 0; ri < allLogin.length; ri++) {
            try {
              allLogin[ri].remove();
            } catch (_rm) {}
          }
          for (var hi = 1; hi < hosts.length; hi++) {
            var extras = hosts[hi].querySelectorAll("[data-sa-login-icon], .sa-login-icon");
            for (var ei = 0; ei < extras.length; ei++) {
              try {
                extras[ei].remove();
              } catch (_re) {}
            }
          }
          if (saEl) {
            saEl.style.removeProperty("position");
            saEl.style.removeProperty("inset");
            saEl.style.removeProperty("opacity");
            saEl.style.removeProperty("z-index");
            saEl.style.removeProperty("width");
            saEl.style.removeProperty("height");
            saEl.style.removeProperty("background");
            saEl.style.setProperty("display", "inline-flex", "important");
            saEl.style.setProperty("opacity", "1", "important");
          }
          el.classList.add("sa-icon-host", "sa-icon-host--account");
          el.classList.remove("sa-icon-host--user");
          el.setAttribute("data-sa-icon", "shopify-account");
          document.documentElement.classList.add("sa-account-signed-in", "sa-has-shopify-account");
          document.documentElement.classList.remove("sa-account-signed-out");
          return;
        }

        /* Remove any nested/extra login icons from duplicate hosts */
        for (var hj = 1; hj < hosts.length; hj++) {
          var ex2 = hosts[hj].querySelectorAll("[data-sa-login-icon], .sa-login-icon");
          for (var ej = 0; ej < ex2.length; ej++) {
            try {
              ex2[ej].remove();
            } catch (_re2) {}
          }
        }
        var icon = el.querySelector(":scope > [data-sa-login-icon], :scope > .sa-login-icon");
        if (!icon) {
          icon = document.createElement("span");
          icon.className = "sa-login-icon sa-icon-inject";
          icon.setAttribute("aria-hidden", "true");
          icon.innerHTML = SA_EARLY_ICONS.user;
          icon.setAttribute("data-sa-login-icon", "1");
          if (saEl && saEl.parentNode === el) el.insertBefore(icon, saEl);
          else el.insertBefore(icon, el.firstChild);
        }
        /* Hide theme glyphs immediately — don't wait for deferred polishAccount */
        var themeNodes = el.querySelectorAll(
          ":scope > .svg-wrapper, :scope > svg:not(.sa-icon-svg), .account-button__icon",
        );
        for (var ti = 0; ti < themeNodes.length; ti++) {
          if (icon.contains(themeNodes[ti])) continue;
          themeNodes[ti].style.setProperty("display", "none", "important");
          themeNodes[ti].style.setProperty("opacity", "1", "important");
          themeNodes[ti].style.setProperty("width", "0", "important");
          themeNodes[ti].style.setProperty("height", "0", "important");
        }
        if (saEl) {
          /* Never opacity:0 — that made Shopify dismiss the account panel */
          saEl.style.setProperty("opacity", "1", "important");
          saEl.style.setProperty("position", "absolute", "important");
          saEl.style.setProperty("inset", "0", "important");
          saEl.style.setProperty("width", "100%", "important");
          saEl.style.setProperty("height", "100%", "important");
          saEl.style.setProperty("z-index", "2", "important");
          saEl.style.setProperty("pointer-events", "auto", "important");
          saEl.style.setProperty("cursor", "pointer", "important");
          saEl.style.setProperty("background", "transparent", "important");
          saEl.style.removeProperty("color");
        }
        el.setAttribute("data-sa-icon", "user");
        el.classList.add("sa-icon-host", "sa-icon-host--user");
        el.classList.remove("sa-icon-host--account");
        el.style.setProperty("position", "relative", "important");
        el.style.setProperty("display", "inline-flex", "important");
        el.style.setProperty("align-items", "center", "important");
        el.style.setProperty("justify-content", "center", "important");
        el.style.setProperty("width", "44px", "important");
        el.style.setProperty("height", "44px", "important");
        el.style.setProperty("min-width", "44px", "important");
        el.style.setProperty("overflow", "visible", "important");
        icon.style.setProperty("display", "inline-flex", "important");
        icon.style.setProperty("align-items", "center", "important");
        icon.style.setProperty("justify-content", "center", "important");
        /* Full 44 host cover — absolute so ::before↔inject never flex-shifts */
        icon.style.setProperty("width", "44px", "important");
        icon.style.setProperty("height", "44px", "important");
        icon.style.setProperty("flex", "0 0 44px", "important");
        icon.style.setProperty("position", "absolute", "important");
        icon.style.setProperty("left", "0", "important");
        icon.style.setProperty("top", "0", "important");
        icon.style.setProperty("z-index", "6", "important");
        icon.style.setProperty("pointer-events", "none", "important");
        icon.style.setProperty("color", "#0f172a", "important");
        icon.style.setProperty("opacity", "1", "important");
        icon.style.setProperty("background", "transparent", "important");
        icon.style.setProperty("border-radius", "999px", "important");
        var coverSvg = icon.querySelector("svg");
        if (coverSvg) {
          coverSvg.style.setProperty("width", "22px", "important");
          coverSvg.style.setProperty("height", "22px", "important");
        }
        document.documentElement.classList.add("sa-account-signed-out", "sa-has-shopify-account");
        document.documentElement.classList.remove("sa-account-signed-in");
      })();
      document
        .querySelectorAll("summary.header__icon--menu, button.header__icon--menu, .header__icon--menu")
        .forEach(function (el) {
          var openWrap = el.querySelector(".header-drawer-icon--open");
          if (openWrap) {
            if (openWrap.getAttribute("data-sa-icon") !== "menu" || !openWrap.querySelector(".sa-icon-svg")) {
              openWrap.innerHTML = SA_EARLY_ICONS.menu;
              openWrap.setAttribute("data-sa-icon", "menu");
            }
            openWrap.style.setProperty("width", "44px", "important");
            openWrap.style.setProperty("height", "44px", "important");
            openWrap.style.setProperty("display", "inline-flex", "important");
            openWrap.style.setProperty("align-items", "center", "important");
            openWrap.style.setProperty("justify-content", "center", "important");
            var g = openWrap.querySelector("svg");
            if (g) {
              g.style.setProperty("width", "22px", "important");
              g.style.setProperty("height", "22px", "important");
            }
            el.setAttribute("data-sa-icon", "menu");
          } else {
            saEarlySwapHost(el, "menu");
          }
        });
      document.documentElement.classList.add("sa-icons-ready");
    } catch (_ep) {
      document.documentElement.classList.add("sa-icons-ready");
    }
  }

  function saWatchActionsEarlyPolish() {
    var actions =
      document.querySelector("#header-component header-actions, header-component header-actions, header-actions, .header-actions");
    if (!actions || actions.getAttribute("data-sa-early-watch") === "1") return;
    actions.setAttribute("data-sa-early-watch", "1");
    var polishTimer = 0;
    try {
      var mo = new MutationObserver(function () {
        if (window.__saIsAccountUiOpen && window.__saIsAccountUiOpen()) return;
        if (Date.now() < (window.__saAccountUiLockUntil || 0)) return;
        /* Debounce — sync polish on every childList mutation froze the tab */
        if (polishTimer) return;
        polishTimer = window.setTimeout(function () {
          polishTimer = 0;
          try {
        saEarlyPolishIcons();
          } catch (_p) {}
        }, 120);
      });
      mo.observe(actions, { childList: true, subtree: true });
    } catch (_w) {}
    saEarlyPolishIcons();
  }

  window.__saEarlyPolishIcons = saEarlyPolishIcons;
  window.__saWatchActionsEarlyPolish = saWatchActionsEarlyPolish;
  /* Remove any leftover chrome-hold from older builds */
  var legacyHold = document.getElementById("sa-chrome-hold");
  if (legacyHold && legacyHold.parentNode) legacyHold.parentNode.removeChild(legacyHold);

  /* Keep scroll lock across boot — removing it reintroduces document scrollbar + icon CLS */
  var broken = document.getElementById("sa-scroll-shell");
  if (broken && broken.parentNode) {
    var bp = broken.parentNode;
    while (broken.firstChild) bp.insertBefore(broken.firstChild, broken);
    broken.remove();
  }

  if (!document.getElementById("sa-nav-boot-css")) {
    var css =
      "html{height:100%!important;margin:0!important;padding:0!important;overflow:hidden!important;scrollbar-gutter:auto!important}" +
      ":is(#header-group,.shopify-section-group-header-group){display:flex!important;flex-direction:column!important;flex:0 0 auto!important;z-index:250!important;opacity:1!important;visibility:visible!important;transform:none!important;gap:0!important;margin:0!important;padding:0!important}" +
      ":is(#header-group,.shopify-section-group-header-group)>.shopify-section{flex:0 0 auto!important;min-height:0!important;margin:0!important;padding:0!important;border:0!important;opacity:1!important;visibility:visible!important;transform:none!important}" +
      ":is(#header-group,.shopify-section-group-header-group) :is(.section,.section-wrapper,.section-content-wrapper,.spacing-style){--padding-block-start:0px!important;--padding-block-end:0px!important;--section-top-offset:0px!important;margin:0!important;padding:0!important;min-height:0!important}" +
      ":is(#header-group,.shopify-section-group-header-group)>.shopify-section:has(:is(.announcement-bar,announcement-bar,.header-announcements)){background:#0f172a!important;--color:#fff!important;--color-rgb:255 255 255!important;--color-foreground:#fff!important;--color-foreground-rgb:255 255 255!important}" +
      ".announcement-bar,announcement-bar,aside.announcement-bar,.header-announcements,[data-testid=announcement-bar],announcement-bar-component{--color:#fff!important;--color-rgb:255 255 255!important;--color-foreground:#fff!important;--color-foreground-rgb:255 255 255!important;color:#fff!important;animation:none!important;transition:none!important;transform:none!important;opacity:1!important;visibility:visible!important;margin:0!important;box-sizing:border-box!important;display:flex!important;align-items:center!important;justify-content:center!important;min-height:2.25rem!important;height:2.25rem!important;max-height:2.25rem!important;padding-block:.5rem!important;padding-inline:1rem!important;border:0!important;overflow:hidden!important;line-height:1.2!important;font-size:.9rem!important}" +
      ".announcement-bar *,announcement-bar *,.header-announcements *,announcement-bar-component *,.announcement-bar__text,.announcement-bar__link,.announcement-bar__message,.announcement-bar__slide{color:#fff!important;-webkit-text-fill-color:#fff!important;animation:none!important;transition:none!important;transform:none!important;opacity:1!important;visibility:visible!important;line-height:1.2!important;font-size:.9rem!important}" +
      ":is(#MainContent,main,#sa-content-scroll,#footer-group,.shopify-section-group-footer-group){margin:0!important;padding:0!important}" +
      ".shopify-section:has(.selfabout-page),.shopify-section:has(.selfabout-page) :is(.section,.section-wrapper,.section-content-wrapper,.spacing-style){--padding-block-start:0px!important;--padding-block-end:0px!important;--section-top-offset:0px!important;margin:0!important;padding:0!important;min-height:0!important}" +
      "#sa-fixed-nav.sa-fixed-nav,#sa-fixed-nav.sa-fixed-nav a{animation:none!important;transition:none!important}" +
      "html.sa-paint-ready.sa-nav-motion #sa-fixed-nav.sa-fixed-nav>li>a{transition:color 160ms ease!important}" +
      "html.sa-paint-ready.sa-nav-motion #sa-fixed-nav.sa-fixed-nav>li>a::after{transition:transform 200ms ease!important}" +
      "body{height:100%!important;max-height:100dvh!important;margin:0!important;padding:0!important;overflow:hidden!important;position:static!important}" +
      "body::-webkit-scrollbar{display:none!important;width:0!important}" +
      "@media (max-width:899px){html,body{scrollbar-width:thin!important;scrollbar-color:rgba(4,120,87,.72) transparent!important}body::-webkit-scrollbar{display:block!important;width:8px!important}body::-webkit-scrollbar-thumb{background:rgba(4,120,87,.72)!important;border-radius:999px!important}html.sa-menu-open,html.sa-menu-open body{overflow:hidden!important}}" +
      /* Horizon wraps chrome+main in .page-wrapper — THAT is the flex column, not body */
      ".page-wrapper{display:flex!important;flex-direction:column!important;height:100%!important;max-height:100dvh!important;min-height:0!important;overflow:hidden!important;width:100%!important}" +
      "html>#sa-fixed-nav,body>#sa-fixed-nav{display:none!important;visibility:visible!important;opacity:1!important;pointer-events:none!important}" +
      /* Desktop shell: header is a non-scrolling flex sibling. Mobile document-scroll needs sticky. */
      "@media (min-width:900px){:is(#header-group,.shopify-section-group-header-group){flex:0 0 auto!important;position:relative!important;top:auto!important;left:auto!important;right:auto!important;width:100%!important;z-index:250!important;opacity:1!important;visibility:visible!important;transform:none!important}.page-wrapper{padding-top:0!important}}" +
      /* Mobile: NEVER allow Horizon display:contents on #header-group — it drops
         position:fixed, leaving in-flow header + page-wrapper padding = white gap after load */
      "@media (max-width:899px){" +
      "html,html.sa-content-scroll,html.sa-content-scroll body,body{height:auto!important;max-height:none!important;overflow-x:hidden!important;overflow-y:auto!important}" +
      "html.sa-content-scroll .page-wrapper,.page-wrapper{height:auto!important;max-height:none!important;overflow:visible!important;padding-top:var(--sa-chrome-h,56px)!important}" +
      ":is(#header-group,.shopify-section-group-header-group),#header-group:has(#header-component[sticky]),#header-group:has(header-component[sticky]){display:flex!important;flex-direction:column!important;flex:0 0 auto!important;position:fixed!important;top:0!important;left:0!important;right:0!important;width:100%!important;z-index:250!important;opacity:1!important;visibility:visible!important;transform:none!important;background:#fff!important;height:auto!important;min-height:0!important;margin:0!important;padding:0!important}" +
      ":is(#header-group,.shopify-section-group-header-group) :is(sticky-header,.header-wrapper,.shopify-section-header-sticky){display:block!important;height:auto!important;min-height:0!important;max-height:none!important;padding:0!important;margin:0!important}" +
      ":is(#MainContent,main){margin-top:0!important;padding-top:0!important}" +
      "}" +
      "#header-group{order:-1!important}" +
      "#sa-content-scroll{flex:1 1 0%!important;min-height:0!important;width:100%!important;overflow-x:hidden!important;overflow-y:auto!important;overscroll-behavior:none!important;overscroll-behavior-y:none!important;background-color:#f3f1ec!important;scrollbar-width:thin;scrollbar-gutter:stable!important;scrollbar-color:rgba(4,120,87,.72) #e8e4dc;-webkit-overflow-scrolling:touch;order:1!important}" +
      "html.sa-pdp .page-wrapper,html.has-sa-product .page-wrapper{overflow:hidden!important;height:100%!important;max-height:100dvh!important}" +
      "html.sa-pdp #sa-content-scroll,html.has-sa-product #sa-content-scroll{flex:1 1 0%!important;min-height:0!important;overflow-x:hidden!important;overflow-y:auto!important}" +
      "#sa-content-scroll>:is(#MainContent,main){background-color:#fffcf8!important}" +
      "#sa-content-scroll>:is(#footer-group,.shopify-section-group-footer-group,footer){background-color:#0a1018!important}" +
      /* Never hide #MainContent on challenge/password — captcha lives there */
      "html:not(.sa-paint-ready):not([data-sa-challenge=\"1\"]):not(.sa-system-page) #MainContent{visibility:visible!important;opacity:1!important;pointer-events:none!important}" +
      "html:not(.sa-paint-ready):not([data-sa-challenge=\"1\"]) :is([data-selfabout-affinity],.selfabout-affinity,[data-selfabout-product],.selfabout-product,[data-selfabout-bundle],[data-selfabout-product-reviews],.selfabout-page:not(.selfabout-site-footer),[data-selfabout-home-trust],.selfabout-home-trust,[data-selfabout-collection],.selfabout-collection,[data-selfabout-about],[data-selfabout-contact],.sa-ct,.sa-ab){visibility:visible!important;opacity:1!important;pointer-events:none!important}" +
      "html:not(.sa-paint-ready):not([data-sa-challenge=\"1\"]) :is(#footer-group,.shopify-section-group-footer-group,footer,.footer,.selfabout-site-footer,[data-selfabout-site-footer],.selfabout-site-footer__logo,.selfabout-site-footer__logo-img,.selfabout-site-footer__brand){visibility:visible!important;opacity:1!important;pointer-events:none!important}" +
      /* Hero first-paint — absolute media, no max-height (CTAs must not clip) */
      ".selfabout-home-hero{position:relative!important;display:flex!important;flex-direction:column!important;justify-content:flex-end!important;align-items:stretch!important;isolation:isolate;min-height:clamp(420px,56vh,640px)!important;max-height:none!important;overflow:hidden!important;background:#0b1220!important}" +
      ".selfabout-home-hero__media,.selfabout-home-hero__fallback{position:absolute!important;inset:0!important;overflow:hidden!important}" +
      ".selfabout-home-hero__img{display:block!important;width:100%!important;height:100%!important;object-fit:cover!important;object-position:62% center!important}" +
      ".selfabout-home-hero__content{position:relative!important;z-index:2!important;margin-top:auto!important;padding:clamp(28px,4vw,48px) clamp(20px,5vw,56px) clamp(28px,4vw,48px)!important}" +
      "@media (max-width:899px){.selfabout-home-hero{justify-content:flex-end!important;min-height:min(46vh,400px)!important}.selfabout-home-hero__content{position:relative!important;inset:auto!important;display:block!important;width:auto!important;height:auto!important;margin:0!important;margin-top:auto!important;margin-bottom:0!important;padding:28px 16px!important;box-sizing:border-box!important}}" +
      /* Trust/metrics/marquee critical — never cream-page plain text */
      ".selfabout-home-trust,[data-selfabout-home-trust]{background:#0f172a!important;color:#fff!important;overflow:hidden!important}" +
      ".selfabout-home-trust__metrics{display:grid!important;gap:0!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;margin:0 auto!important;max-width:1120px!important;padding:22px clamp(20px,4vw,32px) 8px!important}" +
      ".selfabout-home-trust__metric{border-right:1px solid rgba(255,255,255,.1)!important;padding:8px 18px!important;text-align:center!important}" +
      ".selfabout-home-trust__metric:last-child{border-right:0!important}" +
      ".selfabout-home-trust__metric strong{color:#bbf7d5!important;display:block!important;font-family:var(--sa-font-display,Georgia,serif)!important;font-size:clamp(1.25rem,2.5vw,1.55rem)!important;font-weight:800!important;letter-spacing:-.01em!important;margin-bottom:5px!important;position:relative!important}" +
      /* Never show shimmer pill over real SSR count — critical color:!important fought transparent text */
      ".selfabout-home-trust__metric strong.is-loading::after{content:none!important;display:none!important;width:0!important;height:0!important;opacity:1!important}" +
      ".selfabout-home-trust__metric span{color:rgba(255,255,255,.94)!important;display:block!important;font-size:.86rem!important;font-weight:500!important}" +
      ".selfabout-home-trust-marquee{overflow:hidden!important;color:#fff!important;padding:14px 0!important;border-block:1px solid rgba(110,231,183,.18)}" +
      ".selfabout-home-trust-marquee__track,.selfabout-home-trust-marquee__group{display:flex!important;align-items:center!important}" +
      ".selfabout-home-trust-marquee__track{width:max-content!important}" +
      ".selfabout-home-trust-marquee__group{gap:18px!important;padding-inline:10px!important;white-space:nowrap!important}" +
      ".selfabout-home-trust-marquee__group span{color:rgba(255,255,255,.88)!important;font-size:.84rem!important;font-weight:650!important;letter-spacing:.08em!important;text-transform:uppercase!important}" +
      ".selfabout-home-trust-marquee__sr{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important}" +
      /* Logo always visible — never opacity:0 (that caused load hide/flash) */
      "html.sa-paint-ready :is(#sa-content-scroll,#MainContent,main){visibility:visible!important;opacity:1!important;pointer-events:auto!important}" +
      "html.sa-paint-ready:not([data-selfabout-search-page]) :is(#footer-group,.shopify-section-group-footer-group,.footer,.selfabout-site-footer)," +
      "html.sa-paint-ready.sa-search-polished :is(#footer-group,.shopify-section-group-footer-group,.footer,.selfabout-site-footer){" +
      "visibility:visible!important;opacity:1!important;pointer-events:auto!important}" +
      "html.sa-paint-ready:not([data-selfabout-search-page]) :is(.selfabout-site-footer__logo,.selfabout-site-footer__logo-img,.selfabout-site-footer__brand)," +
      "html.sa-paint-ready.sa-search-polished :is(.selfabout-site-footer__logo,.selfabout-site-footer__logo-img,.selfabout-site-footer__brand){" +
      "visibility:visible!important;opacity:1!important}" +
      /* Search load: keep custom footer fully dark until SA search UI mounts */
      "html[data-selfabout-search-page]:not(.sa-search-polished) :is(#footer-group,.shopify-section-group-footer-group,footer,.footer,.selfabout-site-footer,[data-selfabout-site-footer],.selfabout-site-footer *){" +
      "display:none!important;opacity:0!important;visibility:hidden!important;pointer-events:none!important;" +
      "height:0!important;max-height:0!important;overflow:hidden!important;margin:0!important;padding:0!important;border:0!important}" +
      "html[data-selfabout-search-page]:not(.sa-search-polished) #MainContent," +
      "html[data-selfabout-search-page]:not(.sa-search-polished) #sa-content-scroll{" +
      "min-height:70vh!important}" +
      /* visibility only — opacity:inherit beat card hover .img--alt rules (ID specificity) */
      "html.sa-paint-ready #sa-content-scroll *{visibility:inherit}" +
      ":is(#header-component,header-component) :is(.header-logo,[data-testid=header-logo],.header-logo__image-container,a.header__heading-link,.sa-brand-logo-host,img.sa-brand-logo){opacity:1!important;visibility:visible!important}" +
      "#sa-content-scroll::-webkit-scrollbar{width:10px!important;height:10px!important}" +
      "#sa-content-scroll::-webkit-scrollbar-track{background:#e8e4dc!important;border-radius:999px!important;margin-block:8px!important}" +
      "#sa-content-scroll::-webkit-scrollbar-thumb{background:linear-gradient(180deg,#059669,#047857)!important;border:2px solid #e8e4dc!important;border-radius:999px!important;background-clip:padding-box!important;min-height:32px!important}" +
      "#sa-content-scroll::-webkit-scrollbar-thumb:hover{background:linear-gradient(180deg,#10b981,#047857)!important;background-clip:padding-box!important}" +
      /* Announcement section must stay in chrome flex column */
      "#header-group>.shopify-section,#header-group>header,:is(.shopify-section-group-header-group)>.shopify-section{display:block!important;flex:0 0 auto!important;min-height:0!important;opacity:1!important;visibility:visible!important}" +
      "#header-group .header-announcements,announcement-bar,.announcement-bar,[data-testid=announcement-bar],announcement-bar-component{display:flex!important;align-items:center!important;justify-content:center!important;opacity:1!important;visibility:visible!important;min-height:2.25rem!important;height:2.25rem!important;max-height:2.25rem!important;overflow:hidden!important}" +
      ":is(sticky-header,sticky-header.is-sticky,.header-section,.header-wrapper,.shopify-section-header-sticky){position:relative!important;top:auto!important;inset:auto!important;transform:none!important;height:auto!important;min-height:0!important;opacity:1!important;visibility:visible!important}" +
      ".shopify-section-header-sticky.shopify-section-header-hidden,sticky-header.shopify-section-header-hidden,.header-wrapper.shopify-section-header-hidden{transform:none!important;visibility:visible!important;opacity:1!important}" +
      /* One search only — kill left/center search from first paint (no left flash) */
      ":is(#header-component,header-component) .header__column--left :is(search-button,.header__icon--search,summary.header__icon--search,a.header__icon--search,.header-search),[data-sa-search-dupe]{display:none!important;width:0!important;height:0!important;min-width:0!important;margin:0!important;padding:0!important;overflow:hidden!important;opacity:1!important;visibility:visible!important;pointer-events:none!important}" +
      ":is(#header-component,header-component) .header__column--center :is(search-button,.header__icon--search,summary.header__icon--search,a.header__icon--search,.header-search,[data-testid=header-search]){display:none!important;width:0!important;height:0!important;overflow:hidden!important;opacity:1!important;visibility:visible!important;pointer-events:none!important}" +
      ":is(#header-component,header-component) header-actions :is(search-button,.header__icon--search,summary.header__icon--search,a.header__icon--search,.header-search){display:inline-flex!important;opacity:1!important;visibility:visible!important;pointer-events:auto!important;cursor:pointer!important}" +
      ":is(#header-component,header-component) header-actions :is(account-button,.account-button,.header__icon--account,cart-icon,.header__icon--cart){pointer-events:auto!important;cursor:pointer!important}" +
      ":is(#footer-group,.shopify-section-group-footer-group,footer,.footer,.selfabout-site-footer,[data-selfabout-site-footer]){position:relative!important;top:auto!important;bottom:auto!important;inset:auto!important;transform:none!important}" +
      ":is(#header-component,header-component){box-sizing:border-box!important;padding:0!important;padding-block:0!important;border-bottom:1px solid rgba(15,23,42,.06)!important;box-shadow:0 1px 0 rgba(255,255,255,.8) inset!important}" +
      "@media (min-width:900px){" +
      ":is(#header-component,header-component) #sa-fixed-nav.sa-fixed-nav{display:flex!important;opacity:1!important;visibility:visible!important;align-items:center!important;justify-content:center!important;gap:clamp(.45rem,1vw,.85rem)!important;list-style:none!important;margin:0!important;padding:0!important;height:28px!important;min-height:28px!important;max-height:28px!important}" +
      ":is(#header-component,header-component) .header__column--center{min-height:66px!important;height:66px!important;max-height:66px!important;opacity:1!important;visibility:visible!important;padding-block:0!important;align-items:center!important}" +
      ":is(#header-group,.shopify-section-group-header-group,.header-section,.header-wrapper,#header-component,header-component){width:100%!important;max-width:none!important;overflow:visible!important}" +
      ":is(#header-component,header-component){display:block!important;height:66px!important;max-height:66px!important;min-height:66px!important}" +
      ":is(#header-component,header-component) :is(.header__row,.header__row--top,[class*=header__row]:not(.header__navigation-bar-row)){display:block!important;height:66px!important;min-height:66px!important;width:100%!important;max-width:none!important;margin-inline:0!important;padding-inline:0!important;padding-block:0!important;position:relative!important;box-sizing:border-box!important}" +
      ":is(#header-component,header-component) :is(.header__row,.header__row--top).section--page-width,:is(#header-component,header-component) .section--page-width{max-width:none!important;width:100%!important;padding-inline:0!important}" +
      ":is(#header-component,header-component) .header__columns{display:grid!important;grid-template-areas:\"left center right\"!important;grid-template-columns:minmax(0,1fr) auto minmax(0,1fr)!important;align-items:center!important;column-gap:clamp(1.25rem,2.5vw,2.5rem)!important;width:100%!important;max-width:none!important;height:66px!important;min-height:66px!important;margin-inline:0!important;padding-inline:clamp(1.5rem,4vw,3.5rem)!important;padding-block:0!important;box-sizing:border-box!important;--header-left:minmax(0,1fr)!important;--header-center:auto!important;--header-right:minmax(0,1fr)!important;--header-template-columns:minmax(0,1fr) auto minmax(0,1fr)!important}" +
      ":is(#header-component,header-component) .header__column--left,:is(#header-component,header-component) .header__column:has(.header-logo){grid-area:left!important;display:flex!important;align-items:center!important;justify-content:flex-start!important;justify-self:stretch!important;z-index:8!important}" +
      ":is(#header-component,header-component) .header__column--center,:is(#header-component,header-component) .header__column:has(#sa-fixed-nav){grid-area:center!important;display:flex!important;align-items:center!important;justify-content:center!important;justify-self:center!important;min-width:0!important;max-width:none!important;overflow:visible!important;z-index:5!important}" +
      ":is(#header-component,header-component) .header__column--right,:is(#header-component,header-component) .header__column:has(header-actions),:is(#header-component,header-component) .header__column:has(.header-actions){grid-area:right!important;display:flex!important;align-items:center!important;justify-content:flex-end!important;justify-self:stretch!important;gap:.35rem!important;position:relative!important;min-width:calc(3 * 44px + 2 * .35rem)!important;z-index:8!important}" +
      /* Pin cluster to column right — search reparent was shifting cartR by ~22px (debug C) */
      ":is(#header-component,header-component) .header__column--right{display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;align-items:center!important;justify-content:flex-end!important;align-self:center!important;height:44px!important;max-height:44px!important}" +
      ":is(#header-component,header-component) .header__column--right>:is(header-actions,.header-actions,.header__icons){position:static!important;right:auto!important;top:auto!important;bottom:auto!important;height:44px!important;margin:0!important;transform:none!important;margin-inline-start:0!important;display:inline-flex!important;align-items:center!important;justify-content:flex-end!important;opacity:1!important;visibility:visible!important;gap:.35rem!important;flex-shrink:0!important;z-index:2!important}" +
      ":is(#header-component,header-component) .header__column--right>:is(search-button,.header__icon--search,.header-search,[data-testid=header-search]){position:static!important;right:auto!important;top:auto!important;bottom:auto!important;height:44px!important;width:44px!important;margin:0!important;transform:none!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;z-index:2!important}" +

      ":is(#header-component,header-component) .header__column--right{gap:.35rem!important}" +
      ":is(#header-component,header-component) .header__column--right:has(>:is(search-button,.header__icon--search,.header-search,[data-testid=header-search]))>:is(header-actions,.header-actions,.header__icons){min-width:calc(2 * 44px + .35rem)!important;width:auto!important;max-width:none!important}" +
      ":is(#header-component,header-component) :is(header-actions,.header-actions,.header__icons):has(>:is(search-button,.header__icon--search,.header-search,[data-testid=header-search])){min-width:calc(3 * 44px + 2 * .35rem)!important;width:auto!important;max-width:none!important}" +
      ":is(#header-component,header-component) :is(header-actions,.header-actions,.header__icons):not(:has(>:is(search-button,.header__icon--search,.header-search,[data-testid=header-search]))){min-width:calc(2 * 44px + .35rem)!important;width:auto!important;max-width:none!important}" +
      ":is(#header-component,header-component) :is(.header-search,search-button,.header__icon--search,[data-testid=header-search],.header__icon--account,.header__icon--cart,cart-icon,.account-button){display:inline-flex!important;opacity:1!important;visibility:visible!important}" +
      ":is(#header-component,header-component) .header__column--left :is(header-actions,.header-actions,.header__icons){position:static!important}" +
      /* Theme menu never interim-visible — swap was the left↔right jump */
      ":is(#header-component,header-component) :is(overflow-list,header-menu,.header__inline-menu,nav.header__inline-menu),[slot=overflow],.overflow-list__button,.overflow-menu{display:none!important;visibility:visible!important;pointer-events:none!important}" +
      /* Sticky chrome shells must NOT steal clicks over page content
         (contact Name under navbar: hit was header__row, not the input).
         Only interactive descendants receive events. */
      ":is(#header-group,.shopify-section-group-header-group),:is(#header-group,.shopify-section-group-header-group) :is(#header-component,header-component,.header-section,.header-wrapper,.header__columns,.header__column,.header__column--left,.header__column--center,.header__column--right,.header__row,header-actions,.header-actions,.header__icons,#sa-fixed-nav,#sa-fixed-nav>li,header-drawer,details.menu-drawer-container,.menu-drawer-container){pointer-events:none!important}" +
      ":is(#header-group,.shopify-section-group-header-group) :is(a,button,summary,input,select,textarea,[role=button],account-button,.account-button,cart-icon,search-button,shopify-account,.header-drawer-icon,summary.header__icon--menu,button.header__icon--menu,.header__icon--menu,.header-actions__action,.header__icon--search,.header__icon--cart,.header__icon--account,.announcement-bar a,announcement-bar a){pointer-events:auto!important}" +
      ":is(#header-group,.shopify-section-group-header-group) :is(.menu-drawer,.menu-drawer__navigation,.menu-drawer__inner-container,.menu-drawer__backdrop){pointer-events:auto!important}" +
      /* Closed collections panel must NEVER steal clicks over page content */
      "#sa-fixed-nav .sa-col-panel,#sa-fixed-nav .sa-shop-panel{pointer-events:none!important}" +
      "#sa-fixed-nav .sa-nav-has-panel.is-open>.sa-col-panel,#sa-fixed-nav .sa-nav-has-panel.is-open>.sa-shop-panel{pointer-events:auto!important}" +
      /* Close desktop-only block BEFORE drawer CSS — drawer rules were trapped in
         min-width:900px so mobile open never applied (mobile drawer fix). */
      "}" +
      /* Theme header-menu must not size tracks on any breakpoint */
      ":is(#header-component,header-component) :is(overflow-list,header-menu,.header__inline-menu,nav.header__inline-menu),[slot=overflow],.overflow-list__button,.overflow-menu{display:none!important;visibility:visible!important;pointer-events:none!important;position:absolute!important;width:0!important;height:0!important;max-width:0!important;max-height:0!important;min-width:0!important;min-height:0!important;overflow:hidden!important}:is(#header-component,header-component) .header__column--center > :is(header-menu,HEADER-MENU,overflow-list,.header__inline-menu,nav.header__inline-menu,[slot=overflow],.overflow-menu){display:none!important;visibility:hidden!important;pointer-events:none!important;position:absolute!important;width:0!important;height:0!important;overflow:hidden!important}" +
      /* Do NOT force position:relative on header-drawer — breaks fixed drawer panel stacking */
      /* Mobile: one row — hamburger | centered logo | 3 icons (debug: center h=66 pushed sides to row2 / clipped) */
      "@media (max-width:899px){:is(#header-component,header-component){overflow:visible!important}" +
      ":is(#header-group,.shopify-section-group-header-group) summary.header__icon--menu,button.header__icon--menu,.header__icon--menu{pointer-events:auto!important;z-index:30!important;position:relative!important;color:#0f172a!important}:is(#header-component,header-component) .header__column--left,:is(#header-component,header-component) .header__column--right,:is(#header-component,header-component) :is(header-actions,.header-actions){pointer-events:auto!important;z-index:20!important}" +
      ":is(#header-component,header-component) .header__columns{display:flex!important;flex-wrap:nowrap!important;align-items:center!important;justify-content:space-between!important;column-gap:.35rem!important;height:56px!important;max-height:56px!important;min-height:56px!important;width:100%!important;grid-template-columns:none!important;grid-template-areas:none!important;grid-template-rows:none!important}" +
      ":is(#header-component,header-component) .header__column--left{order:1!important;flex:0 0 44px!important;width:44px!important;min-width:44px!important;max-width:44px!important;display:flex!important;align-items:center!important;justify-content:flex-start!important;height:56px!important;max-height:56px!important;min-height:0!important;overflow:visible!important;position:relative!important;top:auto!important;gap:0!important;grid-area:auto!important}" +
      ":is(#header-component,header-component) .header__column--center,:is(#header-component,header-component) .header__column:has(#sa-fixed-nav){order:2!important;flex:1 1 auto!important;display:flex!important;align-items:center!important;justify-content:center!important;height:56px!important;max-height:56px!important;min-height:0!important;min-width:0!important;max-width:none!important;width:auto!important;overflow:visible!important;padding:0!important;top:auto!important;grid-area:auto!important}" +
      ":is(#header-component,header-component) .header__columns > :is(.header-logo,[data-testid=header-logo],.header-logo__image-container,a.header__heading-link,.sa-brand-logo-host),:is(#header-component,header-component) .header__column--center :is(.header-logo,[data-testid=header-logo],.header-logo__image-container,a.header__heading-link,.sa-brand-logo-host),:is(#header-component,header-component) .header__column--left :is(.header-logo,a.header-logo,.sa-brand-logo-host){order:2!important;flex:1 1 auto!important;display:flex!important;align-items:center!important;justify-content:center!important;opacity:1!important;visibility:visible!important;pointer-events:auto!important;position:relative!important;width:auto!important;min-width:0!important;height:auto!important;max-height:2rem!important;overflow:visible!important;z-index:5!important;margin:0!important;--header-logo-display:block!important;--header-logo-inverse-display:none!important}" +
      ":is(#header-component,header-component) .header-logo .header-logo__image-container--inverse{display:none!important}" +
      ":is(#header-component,header-component) .header-logo .header-logo__image-container--original,:is(#header-component,header-component) .header-logo :is(.header-logo__image-container--original,.header-logo__image-container,img,a){display:block!important;opacity:1!important;visibility:visible!important}" +
      ":is(#header-component,header-component) :is(img.sa-brand-logo,img.header-logo__image){display:block!important;width:auto!important;height:1.85rem!important;max-height:1.85rem!important;object-fit:contain!important;opacity:1!important;visibility:visible!important}" +
      ":is(#header-component,header-component) .header__column--right,:is(#header-component,header-component) .header__column:has(header-actions),:is(#header-component,header-component) .header__column:has(.header-actions){order:3!important;flex:0 0 calc(3 * 44px + .5rem)!important;width:calc(3 * 44px + .5rem)!important;min-width:calc(3 * 44px + .5rem)!important;display:flex!important;align-items:center!important;justify-content:flex-end!important;height:56px!important;max-height:56px!important;min-height:0!important;overflow:visible!important;position:relative!important;top:auto!important;grid-area:auto!important}" +
      ":is(#header-component,header-component) .header__column--right>:is(header-actions,.header-actions,.header__icons){position:static!important;right:auto!important;top:auto!important;bottom:auto!important;height:44px!important;margin:0!important;transform:none!important;display:inline-flex!important;align-items:center!important;gap:.25rem!important;min-width:calc(3 * 44px + .5rem)!important;opacity:1!important;visibility:visible!important}" +
      ":is(#header-component,header-component) .header__column--right>:is(search-button,.header__icon--search,.header-search,[data-testid=header-search]){position:absolute!important;right:calc(2 * 44px + .5rem)!important;top:6px!important;bottom:auto!important;height:44px!important;margin-block:0!important;transform:none!important;margin:0!important;opacity:1!important;visibility:visible!important}" +
      "html.sa-menu-open :is(#header-component,header-component) .header__column--right,html:has(details.menu-drawer-container.menu-open) :is(#header-component,header-component) .header__column--right{height:56px!important;max-height:56px!important}}" +
      /* Ghost layer: [open] without .menu-open shows opacity:0 backdrop that still captures clicks */
      "details.menu-drawer-container:not(.menu-open)>.menu-drawer__backdrop,details.menu-drawer-container[open]:not(.menu-open)>.menu-drawer__backdrop{opacity:0!important;pointer-events:none!important;visibility:hidden!important}" +
      /* Keep transform off-screen while closing — NEVER visibility:hidden here or close
         animation hard-cuts (close animation fix). */
      "details.menu-drawer-container[open]:not(.menu-open)>.menu-drawer{transform:translate3d(-104%,0,0)!important;pointer-events:none!important}" +
      "html{--drawer-animation-speed:280ms;--sa-drawer-dur:280ms;--sa-drawer-dur-out:240ms;--sa-drawer-ease:cubic-bezier(.16,1,.3,1);--sa-drawer-ease-out:cubic-bezier(.16,1,.3,1)}" +
      "html.sa-drawer-animating body>.menu-drawer[data-sa-portaled=\"1\"],html.sa-drawer-animating details.menu-drawer-container.menu-open>.menu-drawer{overflow:hidden!important;box-shadow:none!important;will-change:transform!important;pointer-events:none!important}" +
      "html.sa-drawer-animating body>.menu-drawer__backdrop[data-sa-portaled=\"1\"]{will-change:opacity!important;pointer-events:none!important}" +
      "html.sa-drawer-animating #sa-fixed-drawer.sa-fixed-nav--drawer>li>a,html.sa-drawer-animating .menu-drawer>.menu-drawer__close-button,html.sa-drawer-animating .menu-drawer>.close-button.menu-drawer__close-button{animation:none!important;transition:none!important}" +
      "html.sa-menu-open #sa-fixed-drawer.sa-fixed-nav--drawer>li>a,body>.menu-drawer[data-sa-portaled=\"1\"] #sa-fixed-drawer.sa-fixed-nav--drawer>li>a,details.menu-open #sa-fixed-drawer.sa-fixed-nav--drawer>li>a{animation:none!important;animation-delay:0s!important}" +
      "html.sa-menu-open .menu-drawer>.menu-drawer__close-button,body>.menu-drawer[data-sa-portaled=\"1\"]>.menu-drawer__close-button,details.menu-open .menu-drawer>.menu-drawer__close-button{animation:none!important}" +
      ":is(#header-component,header-component) :is(summary.header__icon--menu,summary.header__icon--summary,.header__icon--menu){touch-action:manipulation!important;-webkit-tap-highlight-color:transparent}" +
      "details.menu-drawer-container>.menu-drawer{position:fixed!important;inset:0 auto 0 0!important;top:0!important;left:0!important;height:100dvh!important;max-height:100dvh!important;transform:translate3d(-100%,0,0) translateZ(0)!important;visibility:hidden;opacity:1!important;will-change:transform;backface-visibility:hidden;-webkit-backface-visibility:hidden;perspective:1000px;box-shadow:none;transition:transform var(--sa-drawer-dur,280ms) var(--sa-drawer-ease-out,cubic-bezier(.16,1,.3,1)),visibility 0s linear var(--sa-drawer-dur-out,240ms)!important}" +
      "details.menu-drawer-container>.menu-drawer__backdrop{opacity:1!important;transition:opacity var(--sa-drawer-dur-out,240ms) var(--sa-drawer-ease-out,cubic-bezier(.16,1,.3,1))!important}" +
      "details.menu-drawer-container.menu-open>.menu-drawer{transform:translate3d(0,0,0) translateZ(0)!important;visibility:visible!important;opacity:1!important;pointer-events:auto!important;display:flex!important;flex-direction:column!important;z-index:2147483646!important;background:#fff!important;box-shadow:12px 0 40px rgba(15,23,42,.12)!important;transition:transform var(--sa-drawer-dur,280ms) var(--sa-drawer-ease,cubic-bezier(.16,1,.3,1)),visibility 0s linear 0s!important}" +
      "details.menu-drawer-container.menu-open>.menu-drawer__backdrop{opacity:1!important;pointer-events:auto!important;visibility:visible!important;z-index:2147483645!important;transition:opacity calc(var(--sa-drawer-dur,280ms)*.85) var(--sa-drawer-ease,cubic-bezier(.16,1,.3,1))!important}" +
      "body:has(>.menu-drawer[data-sa-portaled=\"1\"]) details.menu-drawer-container .menu-drawer:not([data-sa-portaled=\"1\"]),body:has(>.menu-drawer[data-sa-portaled=\"1\"]) details.menu-drawer-container>.menu-drawer{display:none!important;visibility:visible!important;pointer-events:none!important;opacity:1!important;transform:translate3d(-100%,0,0)!important;z-index:-1!important}" +
      "body:has(>.menu-drawer__backdrop[data-sa-portaled=\"1\"]) details.menu-drawer-container .menu-drawer__backdrop:not([data-sa-portaled=\"1\"]){display:none!important;visibility:visible!important;pointer-events:none!important;opacity:1!important}" +
      /* Sticky PLP: unlock overflow; FULL viewport overlay ABOVE chrome
         (z-index stacking fix). */
      "html.sa-menu-open .page-wrapper,html.sa-menu-open :is(#header-group,.shopify-section-group-header-group),html.sa-menu-open :is(#header-component,header-component,.header-section,.header-wrapper,header-drawer,.header__columns,.header__column,.header__row){overflow:visible!important;contain:none!important;clip-path:none!important}" +
      "html.sa-menu-open :is(#header-group,.shopify-section-group-header-group),html.sa-menu-open :is(#header-component,header-component,.header-section,.header-wrapper),html:has(details.menu-drawer-container.menu-open) :is(#header-group,.shopify-section-group-header-group){z-index:0!important;isolation:auto!important}" +
      "html.sa-menu-open body>.menu-drawer[data-sa-portaled=\"1\"]{position:fixed!important;inset:0 auto 0 0!important;top:0!important;left:0!important;right:auto!important;margin:0!important;height:100dvh!important;max-height:100dvh!important;width:min(82vw,20rem)!important;max-width:min(82vw,20rem)!important;transform:translate3d(0,0,0) translateZ(0)!important;visibility:visible!important;opacity:1!important;pointer-events:auto!important;display:flex!important;flex-direction:column!important;z-index:2147483646!important;background:#fff!important;box-shadow:12px 0 40px rgba(15,23,42,.12),2px 0 0 rgba(15,23,42,.04)!important;overflow:auto!important;will-change:transform;backface-visibility:hidden;-webkit-backface-visibility:hidden;transition:transform var(--sa-drawer-dur,280ms) var(--sa-drawer-ease,cubic-bezier(.16,1,.3,1))!important}" +
      "html:not(.sa-menu-open) body>.menu-drawer[data-sa-portaled=\"1\"]{position:fixed!important;inset:0 auto 0 0!important;top:0!important;left:0!important;right:auto!important;margin:0!important;height:100dvh!important;width:min(82vw,20rem)!important;transform:translate3d(-100%,0,0) translateZ(0)!important;visibility:visible!important;pointer-events:none!important;z-index:2147483646!important;transition:transform var(--sa-drawer-dur-out,240ms) var(--sa-drawer-ease-out,cubic-bezier(.16,1,.3,1))!important}" +
      "html.sa-menu-open body>.menu-drawer__backdrop[data-sa-portaled=\"1\"]{position:fixed!important;inset:0!important;width:100vw!important;height:100dvh!important;max-width:none!important;margin:0!important;opacity:1!important;visibility:visible!important;pointer-events:auto!important;z-index:2147483645!important;background:rgba(15,23,42,.42)!important;will-change:opacity;transition:opacity calc(var(--sa-drawer-dur,280ms)*.85) var(--sa-drawer-ease,cubic-bezier(.16,1,.3,1))!important}" +
      "html:not(.sa-menu-open) body>.menu-drawer__backdrop[data-sa-portaled=\"1\"]{position:fixed!important;inset:0!important;width:100vw!important;height:100dvh!important;opacity:0!important;visibility:hidden!important;pointer-events:none!important;z-index:2147483645!important;background:transparent!important;transition:opacity var(--sa-drawer-dur-out,240ms) var(--sa-drawer-ease-out,cubic-bezier(.16,1,.3,1))!important}" +
      "html.sa-menu-open body>.selfabout-collection__toolbar.is-pinned{display:none!important;opacity:1!important;pointer-events:none!important;visibility:visible!important}" +
      "body>.menu-drawer[data-sa-portaled=\"1\"] .menu-drawer__close-button,body>.menu-drawer[data-sa-portaled=\"1\"] .menu-drawer__close,details.menu-drawer-container.menu-open>.menu-drawer .menu-drawer__close-button,details.menu-drawer-container.menu-open>.menu-drawer .menu-drawer__close{position:sticky!important;top:0!important;align-self:flex-end!important;margin:0!important;z-index:5!important;background:#fff!important}" +
      "@media (prefers-reduced-motion:reduce){html{--sa-drawer-dur:1ms;--drawer-animation-speed:1ms}details.menu-drawer-container>.menu-drawer,details.menu-drawer-container>/* backdrop_clean */details.menu-drawer-container.menu-open>.menu-drawer,details.menu-drawer-container.menu-open>.menu-drawer__backdrop{transition-duration:1ms!important;transition-delay:0s!important}}" +
      /* Hide Shopify Inbox Chat while menu open (was painting over drawer) */
      "html.sa-menu-open :is(shopify-chat,#ShopifyChat,#shopify-chat,#dummy-chat-button-iframe),html:has(details.menu-drawer-container.menu-open) :is(shopify-chat,#ShopifyChat,#shopify-chat,#dummy-chat-button-iframe),html.sa-menu-open iframe[name=dummy-chat-button-iframe],html:has(details.menu-drawer-container.menu-open) iframe[name=dummy-chat-button-iframe],html.sa-plp-overlay-open :is(shopify-chat,#ShopifyChat,#shopify-chat,#dummy-chat-button-iframe),html.sa-plp-overlay-open iframe[name=dummy-chat-button-iframe],html:has(.selfabout-collection__filters.is-open) :is(shopify-chat,#ShopifyChat,#shopify-chat,#dummy-chat-button-iframe),html:has(.selfabout-collection__qv.is-open) :is(shopify-chat,#ShopifyChat,#shopify-chat,#dummy-chat-button-iframe),html:has(.selfabout-collection__filters.is-open) iframe[name=dummy-chat-button-iframe],html:has(.selfabout-collection__qv.is-open) iframe[name=dummy-chat-button-iframe]{opacity:1!important;visibility:visible!important;pointer-events:none!important}" +
      "html.sa-menu-open .sa-wa,html:has(details.menu-drawer-container.menu-open) .sa-wa,html.sa-plp-overlay-open .sa-wa,html.sa-plp-overlay-open #sa-wa,html:has(.selfabout-collection__filters.is-open) .sa-wa,html:has(.selfabout-collection__qv.is-open) .sa-wa{opacity:1!important;visibility:visible!important;pointer-events:none!important}" +
      "@media (min-width:900px){" +
      ":is(#header-component,header-component) .header__underlay,:is(#header-component,header-component) .header__underlay *,:is(#header-component,header-component) [class*=underlay]{height:0!important;max-height:0!important;overflow:hidden!important;pointer-events:none!important;visibility:visible!important}" +
      ":is(#header-component,header-component) .header__navigation-bar-row{display:none!important;height:0!important;min-height:0!important;max-height:0!important;overflow:hidden!important;padding:0!important;margin:0!important;border:0!important}" +
      ":is(#header-component,header-component) :is(.header-logo,[data-testid=header-logo],.header-logo__image-container){line-height:1!important;white-space:nowrap!important;min-width:7.6rem!important;min-height:1em!important;animation:none!important;transition:none!important}" +
      "html:not(.sa-has-brand-logo) :is(#header-component,header-component) :is(.header-logo,[data-testid=header-logo],.header-logo__image-container){font-family:Georgia,\"Times New Roman\",Times,serif!important;font-size:clamp(1.35rem,1.6vw,1.65rem)!important;letter-spacing:-.02em!important;color:#0f172a!important}" +
      "html.sa-has-brand-logo :is(#header-component,header-component) :is(.header-logo,[data-testid=header-logo],.header-logo__image-container,.sa-brand-logo-host):has(img.sa-brand-logo),html.sa-has-brand-logo :is(#header-component,header-component) :is(.header-logo,[data-testid=header-logo],.header-logo__image-container,.sa-brand-logo-host):has(img.header-logo__image){font-size:0!important;color:transparent!important;letter-spacing:0!important;line-height:0!important}" +
      ":is(#header-component,header-component) :is(.header-logo,.sa-brand-logo-host,a.header__heading-link){overflow:visible!important;min-height:1.85rem!important}" +
      ":is(#header-component,header-component) :is(header-actions,.header-actions,.header__icons){flex-shrink:0!important;opacity:1!important;visibility:visible!important}" +
      ":is(#header-component,header-component) .header__column--right:has(>:is(search-button,.header__icon--search,.header-search,[data-testid=header-search]))>:is(header-actions,.header-actions,.header__icons){min-width:calc(2 * 44px + .35rem)!important;width:auto!important;max-width:none!important}" +
      ":is(#header-component,header-component) :is(header-actions,.header-actions,.header__icons):has(>:is(search-button,.header__icon--search,.header-search,[data-testid=header-search])){min-width:calc(3 * 44px + 2 * .35rem)!important;width:auto!important;max-width:none!important}" +
      ":is(#header-component,header-component) #sa-fixed-nav.sa-fixed-nav{display:flex!important;position:relative!important;top:auto!important;left:auto!important;right:auto!important;bottom:auto!important;transform:none!important;width:auto!important;max-width:none!important;min-width:0!important;flex-wrap:nowrap;align-items:center;justify-content:center;gap:clamp(.45rem,1vw,.85rem);overflow:visible!important;list-style:none;margin:0!important;padding:0!important;z-index:2;font-family:\"Plus Jakarta Sans\",\"Segoe UI\",system-ui,sans-serif!important;font-size:14px!important;font-weight:500!important;font-synthesis:none!important;line-height:1!important;letter-spacing:.028em;opacity:1!important;visibility:visible!important;pointer-events:auto!important;height:28px!important;min-height:28px!important;max-height:28px!important}" +
      ":is(#header-component,header-component) #sa-fixed-nav.sa-fixed-nav>li{display:flex!important;align-items:center!important;height:28px!important;min-height:28px!important;max-height:28px!important}" +
      ":is(#header-component,header-component) #sa-fixed-nav.sa-fixed-nav>li>a{pointer-events:auto!important;cursor:pointer!important;opacity:1!important;visibility:visible!important;font-weight:500!important;font-size:14px!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;height:28px!important;min-height:28px!important;max-height:28px!important;padding:0 10px!important;line-height:1!important;box-sizing:border-box!important}" +
      ":is(#header-component,header-component,header,.menu-drawer,menu-drawer) a[href*=\"/pages/shipping\"],:is(#header-component,header-component,header,.menu-drawer,menu-drawer) a[href*=\"/pages/support\"],#sa-fixed-nav a[data-sa-nav-key=shipping],#sa-fixed-nav a[data-sa-nav-key=support],#sa-fixed-drawer a[data-sa-nav-key=shipping],#sa-fixed-drawer a[data-sa-nav-key=support],:is(#header-component,header-component) li:has(>a[href*=\"/pages/shipping\"]),:is(#header-component,header-component) li:has(>a[href*=\"/pages/support\"]){display:none!important}" +
      "}" +
      /* Match Tinker: host+wrapper=44px (--button-size), glyph=22px — never shrink .svg-wrapper to 22 */
      ":is(#header-component,header-component),:root,html{--icon-size:22px!important;--icon-size-2xs:22px!important;--icon-size-xs:22px!important;--icon-size-sm:22px!important;--icon-size-md:22px!important;--button-size:44px!important;--icon-stroke-width:1.6!important}" +
      /* No opacity gate — hide→show felt like a size jump */
      ":is(#header-component,header-component) :is(header-actions,.header-actions,.header__icons) :is(.header-actions__action,search-button,.header__icon--search,summary.header__icon--search,a.header__icon--search,.header-search,.header__icon--account,.account-button,account-button,.header__icon--cart,cart-icon,.sa-login-fallback){box-sizing:border-box!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;width:44px!important;min-width:44px!important;max-width:44px!important;height:44px!important;max-height:44px!important;padding:0!important;margin:0!important;overflow:visible!important;transform:none!important;transition:none!important}" +
      ":is(#header-component,header-component) :is(cart-icon,.header__icon--cart,a.header__icon--cart){overflow:visible!important;position:relative!important}" +
      ":is(#header-component,header-component) :is(cart-icon,.header__icon--cart)::before{content:\"\"!important;display:block!important;position:absolute!important;inset:0!important;width:44px!important;height:44px!important;background:center/24px 24px no-repeat url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M6 7.75h12l-.85 11.1A1.6 1.6 0 0 1 15.57 20.5H8.43a1.6 1.6 0 0 1-1.58-1.65L6 7.75Z' stroke='%230f172a' stroke-width='1.7' stroke-linejoin='round'/%3E%3Cpath d='M9.25 7.75V6.55a2.75 2.75 0 0 1 5.5 0v1.2' stroke='%230f172a' stroke-width='1.7' stroke-linecap='round'/%3E%3C/svg%3E\")!important;opacity:1!important;visibility:visible!important;pointer-events:none!important;z-index:1!important}" +
      ":is(#header-component,header-component) cart-icon .cart-bubble__text-count{transform:none!important;padding:0!important;padding-inline:0!important;margin:0!important;text-align:center!important;display:flex!important;align-items:center!important;justify-content:center!important;width:100%!important;height:100%!important;line-height:1!important}" +
      ":is(#header-component,header-component) .header__column--center > :is(header-menu,HEADER-MENU,overflow-list,.header__inline-menu){display:none!important;visibility:visible!important;width:0!important;height:0!important;overflow:hidden!important;pointer-events:none!important}" +
      ":is(#header-component,header-component) :is(header-actions,.header-actions,.header__icons) :is(account-button,.account-button,.header__icon--account,.header-actions__action:has(>shopify-account),.header-actions__action:has(>account-button)){overflow:visible!important}" +
      ":is(#header-component,header-component) :is(header-actions,.header-actions,.header__icons) .svg-wrapper{box-sizing:border-box!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;max-width:44px!important;max-height:44px!important;margin:0!important;padding:0!important;transform:none!important;transition:none!important}" +
      ":is(#header-component,header-component) :is(header-actions,.header-actions,.header__icons) :is(svg,.sa-icon-svg){box-sizing:border-box!important;display:block!important;width:22px!important;height:22px!important;min-width:22px!important;min-height:22px!important;max-width:22px!important;max-height:22px!important;transform:none!important;transition:none!important}" +
      "html.sa-account-signed-out :is(#header-component,header-component) :is(header-actions,.header-actions,.header__icons) :is(.sa-login-icon svg,[data-sa-login-icon] svg){box-sizing:border-box!important;width:22px!important;height:22px!important;min-width:22px!important;min-height:22px!important;max-width:22px!important;max-height:22px!important}" +
      /* Profile: ONE glyph — theme SVG hidden from first frame; ::before / inject cover.
       * overflow:visible so the account panel is not clipped/auto-hidden. */
      ":is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account){overflow:visible!important;position:relative!important;align-items:center!important;justify-content:center!important}" +
      ":is(#header-component,header-component) :is(header-actions,.header-actions,.header__icons) :is(account-button,.account-button,.header__icon--account,.header-actions__action:has(shopify-account),.header-actions__action:has(account-button)){overflow:visible!important}" +
      ":is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account)>shopify-account{opacity:1!important;position:absolute!important;inset:0!important;width:100%!important;height:100%!important;z-index:2!important;pointer-events:auto!important;cursor:pointer!important;overflow:visible!important;background:transparent!important;background-color:transparent!important}" +
      "html.sa-account-signed-out :is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account)>[data-sa-login-icon],html.sa-account-signed-out :is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account)>.sa-login-icon{position:absolute!important;left:0!important;top:0!important;z-index:6!important;pointer-events:none!important;opacity:1!important;color:#0f172a!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;background:transparent!important;border-radius:999px!important}" +
      "html.sa-account-signed-out :is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account)>[data-sa-login-icon] svg,html.sa-account-signed-out :is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account)>.sa-login-icon svg{width:22px!important;height:22px!important;min-width:22px!important;min-height:22px!important;max-width:22px!important;max-height:22px!important}" +
      "html.sa-account-signed-in :is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account)>[data-sa-login-icon],html.sa-account-signed-in :is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account)>.sa-login-icon,html.sa-account-signed-in :is(#header-component,header-component) [data-sa-login-icon],html.sa-account-signed-in :is(#header-component,header-component) .sa-login-icon{display:none!important;opacity:1!important;visibility:visible!important;width:0!important;height:0!important;pointer-events:none!important;position:absolute!important;overflow:hidden!important}" +
      /* Hide theme profile SVG always — was force-opacity:1 until inject = blink */
      ":is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account)>:is(.svg-wrapper,svg:not(.sa-icon-svg),.icon,.account-button__icon){display:none!important;width:0!important;height:0!important;opacity:1!important;visibility:visible!important;overflow:hidden!important;position:absolute!important;pointer-events:none!important;z-index:-1!important}" +
      "html:not(.sa-account-signed-in) :is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account)::before{content:\"\"!important;display:block!important;position:absolute!important;left:0!important;top:0!important;width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;border-radius:999px!important;background-color:transparent!important;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='8.75' r='3.35' stroke='%230f172a' stroke-width='1.6'/%3E%3Cpath d='M5.75 18.75c1.4-2.45 3.55-3.7 6.25-3.7s4.85 1.25 6.25 3.7' stroke='%230f172a' stroke-width='1.6' stroke-linecap='round'/%3E%3C/svg%3E\")!important;background-repeat:no-repeat!important;background-position:center!important;background-size:22px 22px!important;opacity:1!important;pointer-events:none!important;z-index:6!important;transition:none!important}" +
      "html.sa-account-signed-in :is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account)::before{content:none!important;display:none!important;opacity:1!important}" +
      ":is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account):hover," +
      ":is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account):focus-visible{background:rgba(4,120,87,.12)!important;background-color:rgba(4,120,87,.12)!important;border-radius:999px!important;color:#047857!important}" +
      /* Wash ABOVE shopify-account (z2), BELOW glyph (z6) — matches cart/search strength */ +
      ":is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account)::after{content:\"\"!important;position:absolute!important;inset:0!important;border-radius:999px!important;background:transparent!important;pointer-events:none!important;z-index:4!important;transition:background-color 160ms ease!important}" +
      ":is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account):hover::after," +
      ":is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account):focus-visible::after{background:rgba(4,120,87,.12)!important;background-color:rgba(4,120,87,.12)!important}" +
      "html.sa-account-signed-in :is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account)>shopify-account{z-index:3!important;background:transparent!important}" +
      "html.sa-account-signed-in :is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account):hover::after," +
      "html.sa-account-signed-in :is(#header-component,header-component) :is(account-button,.account-button,.header__icon--account):focus-visible::after{z-index:5!important;background:rgba(4,120,87,.12)!important}" +
      ":is(#header-component,header-component) :is(summary.header__icon--search,summary.header-search){list-style:none!important}" +
      ":is(#header-component,header-component) :is(summary.header__icon--search,summary.header-search)::-webkit-details-marker,:is(#header-component,header-component) :is(summary.header__icon--search,summary.header-search)::marker{display:none!important;content:none!important;font-size:0!important}" +
      ":is(#header-component,header-component) :is(summary.header__icon--search,summary.header-search)::after{content:none!important;display:none!important;border:0!important;width:0!important;height:0!important}" +
      ":is(#header-component,header-component) :is(search-button,.header__icon--search,summary.header__icon--search,.header-search):hover{background:rgba(4,120,87,.12)!important;background-color:rgba(4,120,87,.12)!important;border-radius:999px!important}" +
      ":is(#header-component,header-component) :is(cart-icon,.header__icon--cart,a.header__icon--cart):hover{background:rgba(4,120,87,.12)!important;background-color:rgba(4,120,87,.12)!important;border-radius:999px!important}" +
      ":is(#header-component,header-component) :is(details:has(>summary.header__icon--search),details.header__search,details-modal.header__search){background:transparent!important}" +
      ":is(#header-component,header-component) :is(search-button,.header__icon--search,summary.header__icon--search,.header-search) :is(.svg-wrapper,.icon){background:transparent!important;border-radius:999px!important;box-shadow:none!important}" +
      "html:not(.sa-account-signed-in) :is(#header-component,header-component) :is(account-button,.account-button)>shopify-account{color:transparent!important;-webkit-text-fill-color:transparent!important;background:transparent!important;background-color:transparent!important}" +
      "html:not(.sa-account-signed-in) :is(#header-component,header-component) :is(account-button,.account-button)>:is([data-sa-login-icon],.sa-login-icon){position:absolute!important;left:0!important;top:0!important;z-index:6!important}" +
      /* Search/cart placeholders until .sa-icon-svg exists (no blank frame on nav) */ +
      ":is(#header-component,header-component) :is(search-button,.header__icon--search,.header-search,cart-icon,.header__icon--cart,a.header__icon--cart,account-button,.account-button,.header__icon--account){opacity:1!important;visibility:visible!important;transition:none!important}" +
      ":is(#header-component,header-component) :is(search-button,.header__icon--search,.header-search):not(:has(.sa-icon-svg))::before{content:\"\"!important;display:block!important;width:44px!important;height:44px!important;background:center/22px 22px no-repeat url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='11' cy='11' r='6' stroke='%230f172a' stroke-width='1.6'/%3E%3Cpath d='M15.75 15.75L20 20' stroke='%230f172a' stroke-width='1.6' stroke-linecap='round'/%3E%3C/svg%3E\")!important;opacity:1!important}" +
      ":is(#header-component,header-component) :is(search-button,.header__icon--search,.header-search):has(.sa-icon-svg)::before{content:none!important;display:none!important}" +
      ":is(#header-component,header-component) :is(search-button,.header__icon--search,.header-search):not(:has(.sa-icon-svg)) :is(svg,.icon):not(.sa-icon-svg){opacity:1!important;width:0!important;height:0!important;visibility:visible!important;position:absolute!important}" +
      ":is(#header-component,header-component) cart-icon :is(.svg-wrapper,svg):not(.cart-bubble){opacity:1!important;visibility:visible!important;display:inline-block!important;width:22px!important;height:22px!important}" +
      "#sa-mobile-logo{display:none!important;opacity:1!important;visibility:visible!important;pointer-events:auto!important}" +
      "@media (max-width:899px){" +
      ":is(#header-component,header-component) .header__columns{position:relative!important}" +
      "#sa-mobile-logo{display:inline-flex!important;align-items:center!important;justify-content:center!important;" +
      "position:absolute!important;left:50%!important;top:50%!important;right:auto!important;bottom:auto!important;" +
      "transform:translate(-50%,-50%)!important;margin:0!important;padding:0!important;" +
      "height:1.85rem!important;max-width:min(7.25rem,42vw)!important;width:max-content!important;" +
      "z-index:6!important;opacity:1!important;visibility:visible!important;pointer-events:auto!important}" +
      "#sa-mobile-logo img{display:block!important;height:1.85rem!important;max-height:1.85rem!important;" +
      "max-width:min(7.25rem,42vw)!important;width:auto!important;object-fit:contain!important;" +
      "opacity:1!important;visibility:visible!important}" +
      "@media (max-width:899px){:is(#header-group,.shopify-section-group-header-group){position:fixed!important;top:0!important;left:0!important;right:0!important;width:100%!important;z-index:250!important;background:#fff!important}}" +
      "@media (min-width:900px){:is(#header-group,.shopify-section-group-header-group){position:relative!important;top:auto!important}}" +
      /* Kill stuck focus/tap blue wash on icon rail after drawer close — never kill :hover circle */
      ":is(#header-component,header-component) :is(.header__column--right,header-actions,.header-actions,.header__icons," +
      "search-button,.header__icon--search,.header-search,.sa-search-fallback,account-button,.account-button," +
      ".header__icon--account,cart-icon,.header__icon--cart,.header-actions__action,.sa-header-action-btn," +
      "search-button button,.action__cart-btn):not(:hover):not(:focus-visible){background:transparent!important;background-color:transparent!important;" +
      "-webkit-tap-highlight-color:transparent!important;outline:none!important;box-shadow:none!important}" +
      ":is(#header-component,header-component) :is(.header__column--right,header-actions,.header-actions):focus," +
      ":is(#header-component,header-component) :is(.header__column--right,header-actions,.header-actions):focus-within{" +
      "background:transparent!important;background-color:transparent!important;outline:none!important;box-shadow:none!important}" +
      /* Circular hover wash — search / profile / cart */
      ":is(#header-component,header-component) :is(search-button,.header__icon--search,summary.header__icon--search,.header-search," +
      "account-button,.account-button,.header__icon--account,cart-icon,.header__icon--cart,a.header__icon--cart," +
      ".header-actions__action,.sa-header-action-btn){border-radius:999px!important}" +
      ":is(#header-component,header-component) :is(search-button,.header__icon--search,summary.header__icon--search,.header-search," +
      "account-button,.account-button,.header__icon--account,cart-icon,.header__icon--cart,a.header__icon--cart," +
      ".header-actions__action:has(>search-button),.header-actions__action:has(>account-button),.header-actions__action:has(>cart-icon)," +
      ".sa-header-action-btn):hover," +
      ":is(#header-component,header-component) :is(search-button,.header__icon--search,summary.header__icon--search,.header-search," +
      "account-button,.account-button,.header__icon--account,cart-icon,.header__icon--cart,a.header__icon--cart," +
      ".sa-header-action-btn):focus-visible{" +
      "background:rgba(4,120,87,.12)!important;background-color:rgba(4,120,87,.12)!important;border-radius:999px!important;" +
      "box-shadow:none!important;outline:none!important}" +
      "}" +
      "shopify-account .sa-account-signed-out,shopify-account [slot=\"signed-out-avatar\"]{display:none!important;opacity:1!important;width:0!important;height:0!important;overflow:hidden!important;pointer-events:none!important}" +
      "html.sa-account-signed-in :is(#header-component,header-component) :is(account-button,.account-button)>shopify-account{opacity:1!important;position:relative!important;inset:auto!important;width:44px!important;height:44px!important;z-index:2!important}" +
      ":is(#header-component,header-component) :is(header-actions,.header-actions) .svg-wrapper>svg{width:22px!important;height:22px!important;max-width:22px!important;max-height:22px!important}" +
      /* Nuclear: summary close glyph never paints unless we re-attach it when menu-open */
      ":is(#header-component,header-component) summary.header__icon--menu>.header-drawer-icon--close,:is(#header-component,header-component) .header__icon--menu>.header-drawer-icon--close{display:none!important;width:0!important;height:0!important;overflow:hidden!important;opacity:1!important;visibility:visible!important;pointer-events:none!important;position:absolute!important;clip:rect(0,0,0,0)!important}" +
      /* Beat Tinker .header__icon--summary .header-drawer-icon{width:var(--icon-size-xs)} BEFORE polish — always 44/22 */
      ":is(#header-component,header-component) :is(.header__icon--menu,.header__icon--summary) .header-drawer-icon,:is(#header-component,header-component) :is(.header__icon--menu,.header__icon--summary) .header-drawer-icon--open{box-sizing:border-box!important;width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;max-width:44px!important;max-height:44px!important;margin:0!important;padding:0!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;transform:none!important;transition:none!important}" +
      ":is(#header-component,header-component) :is(.header__icon--menu,.header__icon--summary) .header-drawer-icon :is(svg,.sa-icon-svg){width:22px!important;height:22px!important;max-width:22px!important;max-height:22px!important;display:block!important;transform:none!important;transition:none!important}" +
      /* Hamburger host: 44 hit / 22 glyph — same as theme button model */
      "@media (max-width:899px){:is(#header-component,header-component) :is(summary.header__icon--menu,button.header__icon--menu,.header__icon--menu,.menu-drawer-container>summary){box-sizing:border-box!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;width:44px!important;min-width:44px!important;height:44px!important;max-height:44px!important;margin:0!important;padding:0!important;overflow:hidden!important;transform:none!important;transition:none!important}:is(#header-component,header-component) :is(summary.header__icon--menu,button.header__icon--menu,.header__icon--menu) .header-drawer-icon--open{width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;max-width:44px!important;max-height:44px!important;margin:0!important;padding:0!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;transform:none!important;transition:none!important}:is(#header-component,header-component) .header__icon--menu .header-drawer-icon--open :is(svg,.sa-icon-svg){width:22px!important;height:22px!important;max-width:22px!important;max-height:22px!important;display:block!important;transform:none!important;transition:none!important}}" +
      /* Desktop: hide hamburger */
      "@media (min-width:900px){:is(#header-component,header-component) :is(.header__drawer,header-drawer,.menu-drawer-container,.header__icon--menu,button.header__icon--menu,summary.header__icon--menu,button[aria-controls*=menu-drawer],button[aria-controls*=MenuDrawer],.header__drawer__button,.menu-drawer__button){display:none!important;width:0!important;min-width:0!important;margin:0!important;padding:0!important;overflow:hidden!important}}" +
      /* Mobile: nav drawer chrome */
      "@media (max-width:899px){" +
      "#sa-fixed-nav.sa-fixed-nav,#sa-fixed-nav[data-sa-mobile-hide]{display:none!important;visibility:visible!important;pointer-events:none!important}" +
      ":is(#header-component,header-component){height:56px!important;max-height:56px!important;min-height:56px!important}" +
      /* Full-bleed from first paint — match theme critical (CLS: page-width gutters) */ +
      ":is(#header-component,header-component) :is(.header__row,.header__row--top){--page-margin:0px!important;--full-page-grid-with-margins:minmax(0,1fr)!important;display:block!important;grid-template-columns:none!important;height:56px!important;min-height:56px!important;max-height:56px!important;width:100%!important;max-width:none!important;margin:0!important;margin-inline:0!important;padding-inline:.7rem!important;padding-block:0!important;box-sizing:border-box!important}" +
      ":is(#header-component,header-component) :is(.header__row,.header__row--top)>*{grid-column:auto!important;width:100%!important;max-width:none!important}" +
      ":is(#header-component,header-component) .header__columns{height:56px!important;min-height:56px!important;max-height:56px!important;width:100%!important;max-width:none!important;margin:0!important;padding-inline:0!important;padding-block:0!important;box-sizing:border-box!important}" +
      "html.sa-has-brand-logo :is(#header-component,header-component) img.sa-brand-logo{height:1.85rem!important;max-height:1.85rem!important;max-width:min(7.25rem,42vw)!important;width:auto!important}" +
      "html.sa-has-brand-logo :is(#header-component,header-component) :is(.sa-brand-logo-host,a.header__heading-link,.header-logo){max-height:2.25rem!important;min-height:1.85rem!important;overflow:visible!important;padding-block:0!important}" +
      ":is(#header-component,header-component) .header__column--left,:is(#header-component,header-component) .header__column:has(.header__icon--menu),:is(#header-component,header-component) :is(header-drawer,.menu-drawer-container){padding-inline-start:0!important;margin-inline-start:0!important;gap:.15rem!important}" +
      /* Keep hamburger glyph when open — no summary X under the finger (panel has right close) */
      ":is(#header-component,header-component) details:is([open],.menu-open) .header__icon--menu .header-drawer-icon--open{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:44px!important;height:44px!important;opacity:1!important;visibility:visible!important;pointer-events:none!important}" +
      /* No left summary X — drawer panel already has close on the right */
      ":is(#header-component,header-component) details:is([open],.menu-open) .header__icon--menu .header-drawer-icon--close,:is(#header-component,header-component) details:is([open],.menu-open) summary.header__icon--menu>.header-drawer-icon--close{display:none!important;width:0!important;height:0!important;overflow:hidden!important;opacity:1!important;visibility:visible!important;pointer-events:none!important;position:absolute!important;clip:rect(0,0,0,0)!important}" +
      ":is(#header-component,header-component) .header-drawer-icon--open{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:44px!important;height:44px!important;opacity:1!important;visibility:visible!important}" +
      "}" +
      "#sa-fixed-nav>li>a{color:rgba(15,23,42,.62)!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;font-family:\"Plus Jakarta Sans\",\"Segoe UI\",system-ui,sans-serif!important;font-size:14px!important;font-weight:500!important;font-synthesis:none!important;letter-spacing:.028em;padding:0 10px!important;height:28px!important;min-height:28px!important;max-height:28px!important;line-height:1!important;box-sizing:border-box!important;text-decoration:none!important;white-space:nowrap;border:0!important;border-bottom:0!important;box-shadow:none!important;position:relative;max-width:none!important;min-width:0!important;opacity:1!important;visibility:visible!important;transition:none!important}" +
      "#sa-fixed-nav>li{flex:0 0 auto!important;flex-shrink:0!important;max-width:none!important;min-width:max-content!important;overflow:visible!important}" +
      '#sa-fixed-nav>li>a[data-sa-nav-key="home"]{min-width:0!important}' +
      '#sa-fixed-nav>li>a[data-sa-nav-key="shop"]{min-width:0!important}' +
      '#sa-fixed-nav>li>a[data-sa-nav-key="bundles"]{min-width:0!important}' +
      '#sa-fixed-nav>li>a[data-sa-nav-key="collections"]{display:inline-block!important;opacity:1!important;visibility:visible!important;max-width:none!important;min-width:0!important;width:auto!important}' +
      '#sa-fixed-nav>li>a[data-sa-nav-key="about"]{min-width:0!important}' +
      '#sa-fixed-nav>li>a[data-sa-nav-key="contact"]{min-width:0!important}' +
      "#sa-fixed-nav>li>a::before{content:none!important;display:none!important}" +
      "#sa-fixed-nav>li>a::after{content:\"\"!important;display:block!important;position:absolute!important;left:.7em!important;right:.7em!important;bottom:.1em!important;height:1.5px!important;border-radius:999px!important;background:#059669!important;transform:scaleX(0)!important;transform-origin:center!important;pointer-events:none!important}" +
      "#sa-fixed-nav .sa-col-panel a::before,#sa-fixed-nav .sa-col-panel a::after{content:none!important;display:none!important}" +
      "#sa-fixed-nav>li>a:hover,#sa-fixed-nav>li>a:focus-visible{color:#059669!important;outline:none}" +
      "#sa-fixed-nav>li>a:hover::after,#sa-fixed-nav>li>a:focus-visible::after,#sa-fixed-nav>li>a.selfabout-nav-active::after,#sa-fixed-nav>li>a[aria-current=page]::after{transform:scaleX(1)!important}" +
      'html[data-sa-nav="home"] #sa-fixed-nav>li>a[data-sa-nav-key="home"]::after,html[data-sa-nav="shop"] #sa-fixed-nav>li>a[data-sa-nav-key="shop"]::after,html[data-sa-nav="bundles"] #sa-fixed-nav>li>a[data-sa-nav-key="bundles"]::after,html[data-sa-nav="collections"] #sa-fixed-nav>li>a[data-sa-nav-key="collections"]::after,html[data-sa-nav="about"] #sa-fixed-nav>li>a[data-sa-nav-key="about"]::after,html[data-sa-nav="contact"] #sa-fixed-nav>li>a[data-sa-nav-key="contact"]::after{transform:scaleX(1)!important}' +
      'html[data-sa-nav="home"] #sa-fixed-nav>li>a[data-sa-nav-key="home"],html[data-sa-nav="shop"] #sa-fixed-nav>li>a[data-sa-nav-key="shop"],html.sa-pdp[data-sa-nav="shop"] #sa-fixed-nav>li>a[data-sa-nav-key="shop"],html[data-sa-nav="bundles"] #sa-fixed-nav>li>a[data-sa-nav-key="bundles"],html.sa-pdp[data-sa-nav="bundles"] #sa-fixed-nav>li>a[data-sa-nav-key="bundles"],html[data-sa-nav="collections"] #sa-fixed-nav>li>a[data-sa-nav-key="collections"],html[data-sa-nav="about"] #sa-fixed-nav>li>a[data-sa-nav-key="about"],html[data-sa-nav="shipping"] #sa-fixed-nav>li>a[data-sa-nav-key="shipping"],html[data-sa-nav="contact"] #sa-fixed-nav>li>a[data-sa-nav-key="contact"],html[data-sa-nav="support"] #sa-fixed-nav>li>a[data-sa-nav-key="support"],#sa-fixed-nav>li>a.selfabout-nav-active,#sa-fixed-nav>li>a[aria-current=page]{color:#059669!important;font-weight:500!important}' +
      'html[data-sa-nav="home"] #sa-fixed-nav>li>a[data-sa-nav-key="home"]:hover,html[data-sa-nav="shop"] #sa-fixed-nav>li>a[data-sa-nav-key="shop"]:hover,html.sa-pdp[data-sa-nav="shop"] #sa-fixed-nav>li>a[data-sa-nav-key="shop"]:hover,html[data-sa-nav="bundles"] #sa-fixed-nav>li>a[data-sa-nav-key="bundles"]:hover,html.sa-pdp[data-sa-nav="bundles"] #sa-fixed-nav>li>a[data-sa-nav-key="bundles"]:hover,html[data-sa-nav="collections"] #sa-fixed-nav>li>a[data-sa-nav-key="collections"]:hover,html[data-sa-nav="about"] #sa-fixed-nav>li>a[data-sa-nav-key="about"]:hover,html[data-sa-nav="shipping"] #sa-fixed-nav>li>a[data-sa-nav-key="shipping"]:hover,html[data-sa-nav="support"] #sa-fixed-nav>li>a[data-sa-nav-key="support"]:hover,html[data-sa-nav="contact"] #sa-fixed-nav>li>a[data-sa-nav-key="contact"]:hover,#sa-fixed-nav>li>a.selfabout-nav-active:hover{color:#047857!important}' +
      "@media (prefers-reduced-motion:reduce){#sa-fixed-nav>li>a,#sa-fixed-nav>li>a::after{transition:none!important;transform:none!important}#sa-fixed-nav>li>a.selfabout-nav-active::after,#sa-fixed-nav>li>a[aria-current=page]::after{transform:none!important;opacity:1!important;height:1.5px!important;background:#059669!important}}" +
      /* Challenge/password: keep hamburger fully on-screen (was clipped left) */
      "html.sa-system-page :is(#header-component,header-component) :is(.header__row,.header__row--top,.header__columns),html[data-sa-challenge=\"1\"] :is(#header-component,header-component) :is(.header__row,.header__row--top,.header__columns){padding-inline-start:max(.75rem,env(safe-area-inset-left,0px))!important;padding-inline-end:max(.75rem,env(safe-area-inset-right,0px))!important;overflow:visible!important}" +
      "html.sa-system-page :is(#header-component,header-component) .header__column--left,html[data-sa-challenge=\"1\"] :is(#header-component,header-component) .header__column--left,html.sa-system-page :is(#header-component,header-component) :is(header-drawer,.menu-drawer-container),html[data-sa-challenge=\"1\"] :is(#header-component,header-component) :is(header-drawer,.menu-drawer-container){overflow:visible!important;min-width:44px!important;padding-inline-start:0!important;margin-inline-start:0!important;margin-left:0!important;transform:none!important}" +
      "html.sa-system-page :is(#header-component,header-component) :is(summary.header__icon--menu,button.header__icon--menu,.header__icon--menu),html[data-sa-challenge=\"1\"] :is(#header-component,header-component) :is(summary.header__icon--menu,button.header__icon--menu,.header__icon--menu){overflow:visible!important;margin:0!important;margin-inline-start:0!important;margin-left:0!important;transform:none!important;left:auto!important;inset-inline-start:auto!important;position:relative!important}" +
      "html.sa-system-page :is(#header-component,header-component) :is(.header-drawer-icon--open,.header-drawer-icon),html[data-sa-challenge=\"1\"] :is(#header-component,header-component) :is(.header-drawer-icon--open,.header-drawer-icon){overflow:visible!important}" +
      /* Challenge open: full fixed portaled drawer. Closed: hide only PORTALED overlays
         (never display:none every .menu-drawer — that + click-after-preventDefault killed hamburger on touch). */
      "html.sa-system-page.sa-menu-open body>.menu-drawer[data-sa-portaled=\"1\"],html[data-sa-challenge=\"1\"].sa-menu-open body>.menu-drawer[data-sa-portaled=\"1\"],html.sa-system-page.sa-menu-open details.menu-drawer-container.menu-open>.menu-drawer:not([data-sa-drawer-stub]),html[data-sa-challenge=\"1\"].sa-menu-open details.menu-drawer-container.menu-open>.menu-drawer:not([data-sa-drawer-stub]){position:fixed!important;inset:0 auto 0 0!important;top:0!important;left:0!important;right:auto!important;margin:0!important;width:min(82vw,20rem)!important;max-width:min(82vw,20rem)!important;height:100dvh!important;max-height:100dvh!important;display:flex!important;flex-direction:column!important;background:#fff!important;transform:translate3d(0,0,0)!important;visibility:visible!important;opacity:1!important;pointer-events:auto!important;overflow-x:hidden!important;overflow-y:auto!important;z-index:2147483646!important;box-shadow:12px 0 40px rgba(15,23,42,.12)!important}" +
      "html.sa-system-page.sa-menu-open body>.menu-drawer__backdrop[data-sa-portaled=\"1\"],html[data-sa-challenge=\"1\"].sa-menu-open body>.menu-drawer__backdrop[data-sa-portaled=\"1\"]{display:block!important;position:fixed!important;inset:0!important;width:100vw!important;height:100dvh!important;margin:0!important;opacity:1!important;visibility:visible!important;pointer-events:auto!important;z-index:2147483645!important;background:rgba(15,23,42,.42)!important}" +
      "html.sa-system-page:not(.sa-menu-open) body>.menu-drawer[data-sa-portaled=\"1\"],html[data-sa-challenge=\"1\"]:not(.sa-menu-open) body>.menu-drawer[data-sa-portaled=\"1\"]{visibility:visible!important;opacity:1!important;pointer-events:none!important;transform:translate3d(-100%,0,0)!important}" +
      "html.sa-system-page:not(.sa-menu-open) body>.menu-drawer__backdrop[data-sa-portaled=\"1\"],html[data-sa-challenge=\"1\"]:not(.sa-menu-open) body>.menu-drawer__backdrop[data-sa-portaled=\"1\"]{visibility:hidden!important;opacity:0!important;pointer-events:none!important}" +
      "html.sa-system-page:not(.sa-menu-open) /* backdrop_clean */html[data-sa-challenge=\"1\"]:not(.sa-menu-open) .menu-drawer__backdrop{pointer-events:none!important;opacity:1!important;visibility:visible!important}" +
      "html.sa-system-page :is(#sa-bottom-nav,.sa-bottom-nav),html[data-sa-challenge=\"1\"] :is(#sa-bottom-nav,.sa-bottom-nav){display:none!important;pointer-events:none!important;visibility:visible!important}" +
      "html.sa-system-page .menu-drawer>.menu-drawer__close-button,html.sa-system-page .menu-drawer>.close-button.menu-drawer__close-button,html[data-sa-challenge=\"1\"] .menu-drawer>.menu-drawer__close-button,html[data-sa-challenge=\"1\"] .menu-drawer>.close-button.menu-drawer__close-button{align-self:flex-end!important;margin:.55rem .75rem .35rem auto!important;margin-inline-start:auto!important;position:sticky!important;top:0!important;z-index:5!important;background:rgba(15,23,42,.04)!important;border:0!important;border-radius:999px!important;width:40px!important;height:40px!important;min-width:40px!important}" +
      /* Captcha clickable when menu closed */
      "html.sa-system-page:not(.sa-menu-open) :is(#MainContent,main),html[data-sa-challenge=\"1\"]:not(.sa-menu-open) :is(#MainContent,main){position:relative!important;z-index:20!important;pointer-events:auto!important}" +
      "html.sa-system-page:not(.sa-menu-open) .shopify-challenge__container,html[data-sa-challenge=\"1\"]:not(.sa-menu-open) .shopify-challenge__container{position:relative!important;z-index:21!important;isolation:isolate!important;pointer-events:auto!important}" +
      "html.sa-system-page:not(.sa-menu-open) .shopify-challenge__container iframe,html[data-sa-challenge=\"1\"]:not(.sa-menu-open) .shopify-challenge__container iframe,html.sa-system-page:not(.sa-menu-open) .h-captcha,html[data-sa-challenge=\"1\"]:not(.sa-menu-open) .h-captcha{pointer-events:auto!important;position:relative!important;z-index:22!important}" +
      "html.sa-system-page :is(predictive-search-component,.predictive-search,dialog.search-modal,#search-modal,search-modal,.search-modal),html[data-sa-challenge=\"1\"] :is(predictive-search-component,.predictive-search,dialog.search-modal,#search-modal,search-modal,.search-modal){display:none!important;pointer-events:none!important;visibility:visible!important}" +
      "html.sa-system-page .menu-drawer:has(#sa-fixed-drawer) .menu-drawer__navigation>:is(ul,nav,div):not(#sa-fixed-drawer):not(.sa-drawer-discover):not(.sa-drawer-cols-wrap),html[data-sa-challenge=\"1\"] .menu-drawer:has(#sa-fixed-drawer) .menu-drawer__navigation>:is(ul,nav,div):not(#sa-fixed-drawer):not(.sa-drawer-discover):not(.sa-drawer-cols-wrap),html.sa-system-page .menu-drawer:has(#sa-fixed-drawer) :is(.menu-drawer__menu,.menu-list,.list-menu):not(#sa-fixed-drawer),html[data-sa-challenge=\"1\"] .menu-drawer:has(#sa-fixed-drawer) :is(.menu-drawer__menu,.menu-list,.list-menu):not(#sa-fixed-drawer){display:none!important;visibility:visible!important;height:0!important;overflow:hidden!important;pointer-events:none!important}" +
      "html.sa-system-page .menu-drawer:has(#sa-fixed-drawer)>:not(.menu-drawer__close-button):not(.close-button):not(.menu-drawer__navigation):not(nav):not(#sa-fixed-drawer):not(.menu-drawer__backdrop),html[data-sa-challenge=\"1\"] .menu-drawer:has(#sa-fixed-drawer)>:not(.menu-drawer__close-button):not(.close-button):not(.menu-drawer__navigation):not(nav):not(#sa-fixed-drawer):not(.menu-drawer__backdrop){display:none!important}" +
      "#sa-fixed-drawer.sa-fixed-nav--drawer{display:flex!important;flex-direction:column!important;visibility:visible!important;opacity:1!important;height:auto!important;max-height:none!important;overflow:visible!important}" +
      /* Challenge/password only: plain #sa-fixed-drawer replaces theme chrome.
         Storefront keeps liquid .sa-drawer-nav (icons + WhatsApp footer). */
      "html.sa-system-page .menu-drawer:has(#sa-fixed-drawer) .menu-drawer__navigation>:is(ul,nav,div):not(#sa-fixed-drawer):not(.sa-drawer-discover):not(.sa-drawer-cols-wrap),html[data-sa-challenge=\"1\"] .menu-drawer:has(#sa-fixed-drawer) .menu-drawer__navigation>:is(ul,nav,div):not(#sa-fixed-drawer):not(.sa-drawer-discover):not(.sa-drawer-cols-wrap),html.sa-system-page .menu-drawer:has(#sa-fixed-drawer) :is(.menu-drawer__menu,.menu-list,.list-menu):not(#sa-fixed-drawer),html[data-sa-challenge=\"1\"] .menu-drawer:has(#sa-fixed-drawer) :is(.menu-drawer__menu,.menu-list,.list-menu):not(#sa-fixed-drawer){display:none!important}" +
      "html.sa-system-page .menu-drawer:has(#sa-fixed-drawer) :is(.icon-caret,.icon-caret--forward,.icon-caret--backward,summary.menu-drawer__menu-item,.menu-drawer__submenu),html[data-sa-challenge=\"1\"] .menu-drawer:has(#sa-fixed-drawer) :is(.icon-caret,.icon-caret--forward,.icon-caret--backward,summary.menu-drawer__menu-item,.menu-drawer__submenu){display:none!important}" +
      /* Desktop: theme .sa-col-dropdown is canonical — never show legacy .sa-col-panel under it */
      "#sa-fixed-nav .sa-nav-has-panel:has(.sa-col-dropdown)>.sa-col-panel,#sa-fixed-nav .sa-col-panel[data-sa-legacy-panel=\"1\"]{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;max-height:0!important;overflow:hidden!important}" +
      "#sa-fixed-drawer.sa-fixed-nav--drawer{display:flex!important;flex-direction:column!important;list-style:none!important;margin:.35rem .85rem 1rem!important;padding:0!important;gap:.15rem!important}" +
      "#sa-fixed-drawer.sa-fixed-nav--drawer>li,#sa-fixed-drawer.sa-fixed-nav--drawer>li>a[data-sa-nav-key]{display:block!important;opacity:1!important;visibility:visible!important}" +
      "#sa-fixed-drawer.sa-fixed-nav--drawer>li>a{color:rgba(15,23,42,.78)!important;-webkit-text-fill-color:rgba(15,23,42,.78)!important;background:transparent!important;border-radius:12px!important;font-weight:500!important}" +
      "#sa-fixed-drawer.sa-fixed-nav--drawer>li>a.selfabout-nav-active,#sa-fixed-drawer.sa-fixed-nav--drawer>li>a[aria-current=page]{background:rgba(4,120,87,.12)!important;color:#059669!important;-webkit-text-fill-color:#059669!important;font-weight:600!important}" +
      "@media (hover:none),(pointer:coarse){#sa-fixed-drawer.sa-fixed-nav--drawer>li>a:hover,#sa-fixed-drawer.sa-fixed-nav--drawer>li>a:focus,#sa-fixed-drawer.sa-fixed-nav--drawer>li>a:focus-visible{background:transparent!important;color:rgba(15,23,42,.78)!important;-webkit-text-fill-color:rgba(15,23,42,.78)!important;outline:none!important}#sa-fixed-drawer.sa-fixed-nav--drawer>li>a.selfabout-nav-active:hover,#sa-fixed-drawer.sa-fixed-nav--drawer>li>a.selfabout-nav-active:focus,#sa-fixed-drawer.sa-fixed-nav--drawer>li>a[aria-current=page]:hover,#sa-fixed-drawer.sa-fixed-nav--drawer>li>a[aria-current=page]:focus{background:rgba(4,120,87,.12)!important;color:#059669!important;-webkit-text-fill-color:#059669!important}}" +
      '#sa-fixed-drawer.sa-fixed-nav--drawer>li>a[data-sa-nav-key="collections"]{display:block!important}' +
      "html.sa-menu-open #sa-content-scroll,html:has(details.menu-drawer-container[open]) #sa-content-scroll,html:has(details.menu-drawer-container.menu-open) #sa-content-scroll{overflow:hidden!important}" +
      /* Browse collections: same mint left accent on every card */
      "#sa-fixed-drawer .sa-drawer-cols__link,#sa-fixed-drawer .sa-drawer-cols__link.selfabout-nav-child,.menu-drawer #sa-fixed-drawer .sa-drawer-cols a.selfabout-nav-child{background:rgba(255,255,255,.88)!important;border:1px solid rgba(15,23,42,.06)!important;border-inline-start:2.5px solid #6ee7b7!important;border-radius:12px!important;color:#0f172a!important;-webkit-text-fill-color:#0f172a!important;margin-inline-start:0!important;padding:.65rem .75rem .65rem .8rem!important;min-height:0!important}" +
      /* Challenge parity CSS — premium stylesheet can race/miss on /challenge */
      "#sa-fixed-drawer .sa-drawer-has-cols>a[data-sa-nav-key=collections]{margin-bottom:.15rem!important}" +
      "#sa-fixed-drawer .sa-drawer-cols{display:block!important;visibility:visible!important;opacity:1!important;background:linear-gradient(165deg,rgba(4,120,87,.06),rgba(15,23,42,.02))!important;border:1px solid rgba(4,120,87,.12)!important;border-radius:14px!important;box-sizing:border-box!important;margin:.15rem 0 .45rem!important;max-width:100%!important;padding:.6rem .5rem .5rem!important;width:100%!important;height:auto!important;overflow:visible!important}" +
      "#sa-fixed-drawer .sa-drawer-cols__eyebrow{display:block!important;color:rgba(15,23,42,.45)!important;font:650 .68rem/1.2 Plus Jakarta Sans,Segoe UI,system-ui,sans-serif!important;letter-spacing:.12em!important;margin:0 .4rem .45rem!important;text-transform:uppercase!important}" +
      "#sa-fixed-drawer .sa-drawer-cols__featured{display:grid!important;gap:.35rem!important;grid-template-columns:1fr 1fr!important;margin:0 0 .45rem!important}" +
      "#sa-fixed-drawer .sa-drawer-cols__featured a{background:rgba(255,255,255,.95)!important;border:1px solid rgba(4,120,87,.16)!important;border-radius:12px!important;color:#0f172a!important;-webkit-text-fill-color:#0f172a!important;display:flex!important;flex-direction:column!important;font:650 .88rem/1.2 Plus Jakarta Sans,Segoe UI,system-ui,sans-serif!important;gap:.1rem!important;padding:.6rem .7rem!important;text-decoration:none!important}" +
      "#sa-fixed-drawer .sa-drawer-cols__featured a span{color:#64748b!important;-webkit-text-fill-color:#64748b!important;font-size:.68rem!important;font-weight:500!important}" +
      "#sa-fixed-drawer .sa-drawer-cols__list{display:grid!important;gap:.2rem!important;list-style:none!important;margin:0!important;max-height:12.5rem!important;overflow:auto!important;padding:0 .15rem!important}" +
      "#sa-fixed-drawer .sa-drawer-cols__foot{margin:.35rem .35rem 0!important}" +
      "#sa-fixed-drawer .sa-drawer-cols__foot a{color:#059669!important;-webkit-text-fill-color:#059669!important;font:600 .82rem/1.2 Plus Jakarta Sans,Segoe UI,system-ui,sans-serif!important;text-decoration:none!important}" +
      ".menu-drawer:has(#sa-fixed-drawer) .menu-drawer__close-button,.menu-drawer:has(#sa-fixed-drawer) .menu-drawer__close{position:sticky!important;top:0!important;z-index:5!important;background:#fff!important}" +
      /* Hamburger: no click circle / no caret flash */
      "@media (max-width:899px){:is(#header-component,header-component) :is(summary.header__icon--menu,button.header__icon--menu,.header__icon--menu):is(:active,:focus,:focus-visible){background:transparent!important;box-shadow:none!important;outline:none!important}:is(#header-component,header-component) :is(summary.header__icon--menu,button.header__icon--menu,.header__icon--menu) :is(.icon-caret,.icon-caret--forward,.icon-caret--backward){display:none!important}:is(#header-component,header-component) details:not([open]):not(.menu-open) .header__icon--menu .header-drawer-icon--close{display:none!important}}" +
      "html.sa-paint-ready :is(.announcement-bar,announcement-bar,[data-testid=announcement-bar]) :is(a,.announcement-bar__announcement a,.announcement-bar__message a){cursor:pointer!important;transition:opacity 200ms ease,filter 200ms ease!important}" +
      "html.sa-paint-ready :is(.announcement-bar,announcement-bar,[data-testid=announcement-bar]) :is(a,.announcement-bar__announcement a,.announcement-bar__message a):hover,html.sa-paint-ready :is(.announcement-bar,announcement-bar,[data-testid=announcement-bar]) :is(a,.announcement-bar__announcement a,.announcement-bar__message a):focus-visible{opacity:.9!important;filter:brightness(1.06)!important}" +
      /* Mobile: document scroll - never pin footer in a 100dvh flex shell (display:contents + overflow:hidden) */
      "@media (max-width:899px){" +
      "html,body,html.sa-content-scroll,html.sa-content-scroll body{height:auto!important;max-height:none!important;overflow-x:hidden!important;overflow-y:auto!important;position:static!important}" +
      ".page-wrapper,html.sa-content-scroll .page-wrapper{display:flex!important;flex-direction:column!important;height:auto!important;max-height:none!important;min-height:0!important;overflow:visible!important;padding-top:var(--sa-chrome-h,56px)!important;gap:0!important}" +
      "html.sa-pdp .page-wrapper,html.has-sa-product .page-wrapper,html.sa-content-scroll.sa-pdp .page-wrapper,html.sa-content-scroll.has-sa-product .page-wrapper{height:auto!important;max-height:none!important;overflow:visible!important}" +
      ":is(#header-group,.shopify-section-group-header-group),#header-group:has(#header-component[sticky]),#header-group:has(header-component[sticky]){display:flex!important;flex-direction:column!important;margin:0!important;padding:0!important;height:auto!important;position:fixed!important;top:0!important;left:0!important;right:0!important;width:100%!important}" +
      ":is(#header-group,.shopify-section-group-header-group) :is(sticky-header,.header-wrapper,.shopify-section-header-sticky){display:block!important;height:auto!important;min-height:0!important;max-height:none!important;padding:0!important;margin:0!important}" +
      ":is(#MainContent,main),.page-wrapper>:is(#MainContent,main){margin-top:0!important;padding-top:0!important}" +
      "#sa-content-scroll,[data-sa-content-scroll=\"1\"]{display:contents!important;flex:none!important;min-height:0!important;overflow:visible!important;height:auto!important;max-height:none!important}" +
      "html.sa-pdp #sa-content-scroll,html.has-sa-product #sa-content-scroll{display:contents!important;flex:none!important;overflow:visible!important;min-height:0!important}" +
      ":is(#MainContent,main){flex:0 0 auto!important;min-height:0!important;height:auto!important;max-height:none!important;overflow:visible!important;order:1!important}" +
      "html:not(.sa-footer-ready) #sa-content-scroll>:is(#MainContent,main){flex:0 0 auto!important;min-height:0!important}" +
      "html:not(.sa-footer-ready) #MainContent :is(.selfabout-collection,[data-selfabout-collection],.selfabout-product,[data-selfabout-product],.selfabout-collections-hub,[data-selfabout-collections-hub],.selfabout-page:not(.selfabout-home-hero),.sa-ab,.sa-ct,[data-selfabout-about],[data-selfabout-contact],.sa-search-live,[data-sa-search-live]){min-height:0!important}" +
      ":is(#footer-group,.shopify-section-group-footer-group,footer,.footer,.selfabout-site-footer,[data-selfabout-site-footer]){position:relative!important;top:auto!important;bottom:auto!important;inset:auto!important;left:auto!important;right:auto!important;transform:none!important;flex:0 0 auto!important;order:9!important;width:100%!important;height:auto!important;max-height:none!important;overflow:visible!important}" +
      ".page-wrapper>:is(#header-group,.shopify-section-group-header-group){order:0!important;flex:0 0 auto!important}" +
      /* Drawer open: kill background page scroll (must beat overflow-y:auto above) */
      "html.sa-menu-open,html.sa-menu-open.sa-content-scroll,html:has(details.menu-drawer-container.menu-open)," +
      "html.sa-menu-open body,html.sa-menu-open.sa-content-scroll body,html:has(details.menu-drawer-container.menu-open) body{" +
      "overflow:hidden!important;overflow-x:hidden!important;overflow-y:hidden!important;overscroll-behavior:none!important;touch-action:none!important;height:100%!important;max-height:100dvh!important" +
      "}" +
      "html.sa-menu-open .page-wrapper,html:has(details.menu-drawer-container.menu-open) .page-wrapper," +
      "html.sa-menu-open #sa-content-scroll,html:has(details.menu-drawer-container.menu-open) #sa-content-scroll{" +
      "overflow:hidden!important;overscroll-behavior:none!important;touch-action:none!important" +
      "}" +
      "}" +
      /* App-wide: when drawer open, only drawer+backdrop paint above the page - kill bleed-through */
      "html.sa-menu-open,html:has(details.menu-drawer-container.menu-open){" +
      "--sa-drawer-z:2147483000;--sa-drawer-backdrop-z:2147482990;--sa-page-under-drawer-z:0" +
      "}" +
      "html.sa-menu-open :is(#header-group,.shopify-section-group-header-group,#header-component,header-component,.header-section,.header-wrapper,sticky-header,.header,.page-wrapper,#sa-content-scroll,#MainContent,main,#footer-group,.shopify-section-group-footer-group,footer,.selfabout-site-footer,#sa-bottom-nav,.sa-bottom-nav,.sa-wa,#sa-wa,shopify-chat,#ShopifyChat,#shopify-chat,[data-selfabout],.selfabout-home-hero,.selfabout-page){" +
      "z-index:var(--sa-page-under-drawer-z,0)!important;isolation:auto!important" +
      "}" +
      /* Keep navbar icons visible while drawer is open (backdrop covers clicks) */
      "html.sa-menu-open :is(#header-component,header-component) :is(.header__column--right,header-actions,.header-actions,.header__icon--search,.header__icon--account,cart-icon,search-button,a.account-button,.cart-count-bubble,.sa-header-action-btn){" +
      "visibility:visible!important;opacity:1!important;z-index:1!important;isolation:auto!important" +
      "}" +
      /* Keep dedicated mobile mark optically centered; theme logos stay parked */
      "html.sa-menu-open #sa-mobile-logo,html.sa-menu-open #sa-mobile-logo img{" +
      "visibility:visible!important;opacity:1!important;pointer-events:auto!important;z-index:6!important" +
      "}" +
      "html.sa-menu-open #sa-mobile-logo{display:inline-flex!important}" +
      "html.sa-menu-open #sa-mobile-logo img{display:block!important}" +
      "html.sa-menu-open :is(#header-component,header-component) :is(.header-logo,[data-testid=header-logo],.header-logo__image-container,a.header__heading-link,.sa-brand-logo-host):not(#sa-mobile-logo){" +
      "height:0!important;width:0!important;max-height:0!important;max-width:0!important;opacity:0!important;" +
      "visibility:hidden!important;overflow:hidden!important;pointer-events:none!important" +
      "}" +
      "html.sa-menu-open :is(#header-component,header-component) summary.header__icon--menu,html.sa-menu-open :is(#header-component,header-component) summary.header__icon--summary{" +
      "visibility:visible!important;opacity:1!important;pointer-events:auto!important;z-index:1!important" +
      "}" +
      "html.sa-menu-open .announcement-bar,html.sa-menu-open announcement-bar,html.sa-menu-open .header-announcements{" +
      "visibility:hidden!important;opacity:0!important;pointer-events:none!important" +
      "}" +
      "html.sa-menu-open body>.menu-drawer__backdrop[data-sa-portaled=\"1\"],html.sa-menu-open .menu-drawer__backdrop,details.menu-drawer-container.menu-open>.menu-drawer__backdrop{" +
      "position:fixed!important;inset:0!important;width:100vw!important;height:100dvh!important;max-width:none!important;margin:0!important;" +
      "background:rgba(15,23,42,.58)!important;opacity:1!important;visibility:visible!important;" +
      "z-index:var(--sa-drawer-backdrop-z,2147482990)!important;pointer-events:auto!important;" +
      "backdrop-filter:none!important;-webkit-backdrop-filter:none!important;isolation:isolate!important;" +
      "transform:translateZ(0)!important" +
      "}" +
      "html.sa-menu-open body>.menu-drawer[data-sa-portaled=\"1\"],html.sa-menu-open details.menu-drawer-container.menu-open>.menu-drawer:not([data-sa-drawer-stub]),details.menu-drawer-container.menu-open>.menu-drawer:not([data-sa-drawer-stub]){" +
      "position:fixed!important;inset:0 auto 0 0!important;top:0!important;left:0!important;right:auto!important;" +
      "width:min(82vw,20rem)!important;max-width:min(82vw,20rem)!important;height:100dvh!important;max-height:100dvh!important;" +
      "background:#ffffff!important;background-color:#ffffff!important;opacity:1!important;visibility:visible!important;" +
      "z-index:var(--sa-drawer-z,2147483000)!important;isolation:isolate!important;" +
      "box-shadow:12px 0 40px rgba(15,23,42,.18)!important;overflow-x:hidden!important;overflow-y:auto!important;touch-action:pan-y!important;overscroll-behavior:contain!important;" +
      "transform:translate3d(0,0,0) translateZ(0)!important;-webkit-backface-visibility:hidden!important;backface-visibility:hidden!important;" +
      "pointer-events:auto!important;display:flex!important;flex-direction:column!important;" +
      "mix-blend-mode:normal!important;filter:none!important;-webkit-filter:none!important" +
      "}" +
      "html.sa-menu-open body>.menu-drawer[data-sa-portaled=\"1\"] a[href],html.sa-menu-open details.menu-drawer-container.menu-open>.menu-drawer a[href],body>.menu-drawer[data-sa-portaled=\"1\"] a[href]{" +
      "touch-action:manipulation!important;cursor:pointer!important;-webkit-tap-highlight-color:rgba(4,120,87,.12)!important;pointer-events:auto!important;position:relative!important;z-index:2!important" +
      "}" +
      "html.sa-menu-open body>.menu-drawer[data-sa-portaled=\"1\"] a[href] :is(span,.sa-drawer-link__icon,.sa-drawer-link__text,.sa-drawer-sublink__icon,.sa-drawer-sublink__text),body>.menu-drawer[data-sa-portaled=\"1\"] a[href] :is(span,.sa-drawer-link__icon,.sa-drawer-link__text,.sa-drawer-sublink__icon,.sa-drawer-sublink__text){" +
      "pointer-events:none!important;-webkit-user-select:none!important;user-select:none!important" +
      "}" +
      /* Navigating: keep drawer visible until new page paints (masks FOUC) */
      "html.sa-drawer-navigating,html.sa-drawer-navigating body{overflow:hidden!important;overscroll-behavior:none!important}" +
      "html.sa-drawer-navigating body>.menu-drawer[data-sa-portaled=\"1\"]{visibility:visible!important;opacity:1!important;display:flex!important;pointer-events:none!important}" +
      "html.sa-drawer-navigating body>.menu-drawer__backdrop[data-sa-portaled=\"1\"]{opacity:1!important;visibility:visible!important;pointer-events:none!important}" +
      "html.sa-drawer-navigating .sa-drawer-link--pending,html.sa-drawer-navigating .sa-drawer-sublink.sa-drawer-link--pending{background:rgba(16,185,129,.08)!important;color:#047857!important;font-weight:600!important;opacity:1!important;outline:none!important}" +
      "@media (hover:none){.sa-drawer-sublink:hover{background:transparent!important;color:#475569!important;font-weight:500!important}.sa-drawer-sublink.sa-drawer-sublink--active,.sa-drawer-sublink.sa-drawer-link--pending{background:rgba(16,185,129,.08)!important;color:#047857!important;font-weight:600!important}}" +
      ".sa-drawer-sublink,.sa-drawer-subnav a.sa-drawer-sublink{transition:none!important;-webkit-tap-highlight-color:transparent!important;touch-action:manipulation!important}" +
      /* Rich drawer: class + data-sa-nav-key beats legacy /collections/all substring rules */
      "html[data-sa-nav=\"bundles\"] .sa-drawer-nav a.sa-drawer-link[data-sa-nav-key=\"shop\"]{background:transparent!important;color:#1e293b!important;font-weight:600!important}" +
      "html[data-sa-nav=\"bundles\"] .sa-drawer-nav a.sa-drawer-link[data-sa-nav-key=\"bundles\"],html[data-sa-nav=\"bundles\"] .sa-drawer-nav a.sa-drawer-link--active[data-sa-nav-key=\"bundles\"]{background:rgba(16,185,129,.08)!important;color:#047857!important;font-weight:700!important}" +
      "html[data-sa-nav=\"shop\"] .sa-drawer-nav a.sa-drawer-link[data-sa-nav-key=\"shop\"],html[data-sa-nav=\"shop\"] .sa-drawer-nav a.sa-drawer-link--active[data-sa-nav-key=\"shop\"]{background:rgba(16,185,129,.08)!important;color:#047857!important;font-weight:700!important}" +
      "html.sa-menu-open .sa-drawer-close-btn,html.sa-menu-open .menu-drawer__close-btn,html.sa-menu-open .menu-drawer__close-button,body>.menu-drawer[data-sa-portaled=\"1\"] .sa-drawer-close-btn,body>.menu-drawer[data-sa-portaled=\"1\"] .menu-drawer__close-btn{" +
      "touch-action:manipulation!important;cursor:pointer!important;pointer-events:auto!important;z-index:20!important;-webkit-tap-highlight-color:transparent!important" +
      "}" +
      "html.sa-menu-open .sa-drawer-close-btn svg,html.sa-menu-open .menu-drawer__close-btn svg,body>.menu-drawer[data-sa-portaled=\"1\"] .sa-drawer-close-btn svg{" +
      "pointer-events:none!important" +
      "}" +
      "html.sa-menu-open body>.menu-drawer[data-sa-portaled=\"1\"]::before,html.sa-menu-open details.menu-drawer-container.menu-open>.menu-drawer:not([data-sa-drawer-stub])::before{" +
      "content:\"\"!important;position:absolute!important;inset:0!important;z-index:0!important;" +
      "background:#ffffff!important;pointer-events:none!important" +
      "}" +
      "html.sa-menu-open body>.menu-drawer[data-sa-portaled=\"1\"]>:where(*),html.sa-menu-open details.menu-drawer-container.menu-open>.menu-drawer:not([data-sa-drawer-stub])>:where(*){" +
      "position:relative!important;z-index:1!important" +
      "}" +
      "html.sa-menu-open body>.menu-drawer[data-sa-portaled=\"1\"] *,html.sa-menu-open details.menu-drawer-container.menu-open>.menu-drawer:not([data-sa-drawer-stub]) *{" +
      "visibility:visible!important" +
      "}" +
      "html.sa-menu-open body>:is(.menu-drawer[data-sa-portaled=\"1\"],.menu-drawer__backdrop[data-sa-portaled=\"1\"]){" +
      "position:fixed!important" +
      "}";
    var style = document.createElement("style");
    style.id = "sa-nav-boot-css";
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  }

  function isChromeNode(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.id === "header-group" || node.id === "sa-content-scroll" || node.id === "sa-nav-boot-css") {
      return true;
    }
    var cls = node.classList;
    if (cls && cls.contains("shopify-section-group-header-group")) return true;
    var hint =
      ((node.id || "") + " " + (typeof node.className === "string" ? node.className : "")).toLowerCase();
    if (hint.indexOf("announcement") !== -1) return true;
    try {
      if (node.matches && node.matches("announcement-bar, .announcement-bar, [data-testid='announcement-bar']")) {
        return true;
      }
    } catch (e) {}
    return false;
  }

  function canMoveNode(node) {
    if (!node || node.nodeType !== 1) return false;
    var tag = node.tagName;
    if (
      tag === "SCRIPT" ||
      tag === "STYLE" ||
      tag === "LINK" ||
      tag === "NOSCRIPT" ||
      tag === "TEMPLATE" ||
      tag === "META"
    ) {
      return false;
    }
    if (isChromeNode(node)) return false;
    return true;
  }

  function adoptIntoShell(shell, fromNode) {
    var moved = 0;
    var node = fromNode;
    while (node) {
      var next = node.nextSibling;
      if (node === shell) {
        node = next;
        continue;
      }
      if (node.nodeType === 1 && canMoveNode(node)) {
        shell.appendChild(node);
        moved += 1;
      }
      node = next;
    }
    return moved;
  }

  var __saDomLock = 0;
  function withDomLock(fn) {
    __saDomLock += 1;
    try {
      return fn();
    } finally {
      __saDomLock -= 1;
    }
  }

  function recoverChrome() {
    return withDomLock(function () {
    var shell = document.getElementById("sa-content-scroll");
    var header = document.getElementById("header-group");
    var wrapper = document.querySelector(".page-wrapper") || document.body;
    if (!header || !wrapper) return false;
    var moved = false;

    /* Always pin chrome as first child of page-wrapper — wrong sibling order put navbar at bottom */
    if (header.parentNode !== wrapper || wrapper.firstElementChild !== header) {
      wrapper.insertBefore(header, wrapper.firstChild);
      moved = true;
    }

    if (shell) {
      if (shell.parentNode !== wrapper || header.nextElementSibling !== shell) {
        wrapper.insertBefore(shell, header.nextSibling);
        moved = true;
      }
      if (shell.contains(header)) {
        wrapper.insertBefore(header, shell);
        moved = true;
      }
      var kids = shell.children ? Array.prototype.slice.call(shell.children) : [];
      for (var i = 0; i < kids.length; i++) {
        if (isChromeNode(kids[i]) && kids[i].id !== "sa-content-scroll") {
          wrapper.insertBefore(kids[i], shell);
          moved = true;
        }
      }
    }

    header.style.setProperty("opacity", "1", "important");
    header.style.setProperty("visibility", "visible", "important");
    header.style.setProperty("transform", "none", "important");
    header.style.setProperty("order", "-1", "important");
    header.style.setProperty("width", "100%", "important");
    header.style.setProperty("max-width", "none", "important");
    if (shell) {
      shell.style.setProperty("order", "1", "important");
      shell.style.setProperty("width", "100%", "important");
      shell.style.setProperty("max-width", "none", "important");
    }
    if (wrapper) {
      wrapper.style.setProperty("width", "100%", "important");
      wrapper.style.setProperty("max-width", "none", "important");
    }

    return moved;
    });
  }

  function isPdpPath() {
    return (
      document.documentElement.classList.contains("sa-pdp") ||
      document.documentElement.classList.contains("has-sa-product") ||
      /\/products\//i.test(location.pathname || "")
    );
  }

  var __saScrollMode = "";
  var __saScrollResetPath = "";

  function resetScrollerToTop() {
    /* Don't yank to top when returning from newsletter captcha / FAQ hash */
    var hash = location.hash || "";
    if (
      hash === "#selfabout-site-footer" ||
      hash === "#selfabout-faq" ||
      hash === "#sa-ct-panel" ||
      hash === "#sa-ct-form"
    ) {
      return;
    }
    try {
      if (sessionStorage.getItem("sa-nl-scroll") === "1") return;
      var holdUntil = parseInt(sessionStorage.getItem("sa-nl-hold-until") || "0", 10);
      if (holdUntil && Date.now() < holdUntil) return;
      if (/[?&]customer_posted=true/i.test(location.search || "")) return;
      /* Only keep scroll after confirmed Join success — not captcha abandon */
    } catch (_ss) {}

    var wrapper = document.querySelector(".page-wrapper");
    var shell = document.getElementById("sa-content-scroll");
    try {
      if (shell) {
        shell.style.setProperty("scroll-behavior", "auto", "important");
        shell.scrollTop = 0;
      }
    } catch (_s) {}
    try {
      if (wrapper) {
        wrapper.style.setProperty("scroll-behavior", "auto", "important");
        wrapper.scrollTop = 0;
      }
    } catch (_w) {}
    try {
      window.scrollTo(0, 0);
    } catch (_e) {}
  }

  /* Affinity/product escaping the shell made shell ~142px and RV look sticky below it */
  function repairEscapedPdpSections() {
    var shell = document.getElementById("sa-content-scroll");
    var main = document.getElementById("MainContent") || document.querySelector("main");
    if (!shell) return 0;
    var moved = 0;
    var nodes = document.querySelectorAll(
      "[data-selfabout-product], [data-selfabout-affinity], [data-selfabout-bundle], [data-selfabout-product-reviews]"
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (shell.contains(el)) continue;
      var host =
        (el.closest && (el.closest(".shopify-section") || el.closest(".shopify-block"))) || el;
      if (!canMoveNode(host)) continue;
      if (main && shell.contains(main)) {
        main.appendChild(host);
      } else {
        shell.appendChild(host);
      }
      moved += 1;
    }
    return moved;
  }

  function hardenScrollShell(opts) {
    if (SA_SYSTEM) return;
    var options = opts || {};
    var shell = getScrollShell();
    var header = document.getElementById("header-group");
    var wrapper = document.querySelector(".page-wrapper");
    if (!shell) return;

    repairEscapedPdpSections();

    var pdp = isPdpPath();
    var isMobile =
      !!(window.matchMedia && window.matchMedia("(max-width:899px)").matches);
    /* Mobile: document scroll (fail-open). Desktop: #sa-content-scroll shell. */
    var mode = isMobile ? "document" : "shell";
    var modeChanged = __saScrollMode !== mode;
    var path = location.pathname || "";
    var pathChanged = __saScrollResetPath !== path;

    if (!options.forceReset && !modeChanged && shell.getAttribute("data-sa-scroll-mode") === mode) {
      if (pathChanged) {
        __saScrollResetPath = path;
        if (pdp) document.documentElement.classList.add("sa-pdp");
        resetScrollerToTop();
      }
      repairEscapedPdpSections();
      return;
    }

    __saScrollMode = mode;
    shell.setAttribute("data-sa-scroll-mode", mode);

    if (pdp) document.documentElement.classList.add("sa-pdp");

    if (isMobile) {
      var menuOpen =
        document.documentElement.classList.contains("sa-menu-open") ||
        !!document.querySelector("details.menu-drawer-container.menu-open");
      document.documentElement.style.setProperty("overflow-x", "hidden", "important");
      document.documentElement.style.setProperty(
        "overflow-y",
        menuOpen ? "hidden" : "auto",
        "important",
      );
      document.documentElement.style.setProperty("height", menuOpen ? "100%" : "auto", "important");
      if (menuOpen) {
        document.documentElement.style.setProperty("max-height", "100dvh", "important");
      } else {
        document.documentElement.style.removeProperty("max-height");
      }
      if (document.body) {
        document.body.style.setProperty("overflow-x", "hidden", "important");
        document.body.style.setProperty(
          "overflow-y",
          menuOpen ? "hidden" : "auto",
          "important",
        );
        document.body.style.setProperty("height", menuOpen ? "100%" : "auto", "important");
        document.body.style.setProperty(
          "max-height",
          menuOpen ? "100dvh" : "none",
          "important",
        );
        document.body.style.removeProperty("position");
      }
      if (wrapper) {
        wrapper.style.setProperty("display", "flex", "important");
        wrapper.style.setProperty("flex-direction", "column", "important");
        wrapper.style.setProperty("height", "auto", "important");
        wrapper.style.setProperty("max-height", "none", "important");
        wrapper.style.setProperty("min-height", "0", "important");
        wrapper.style.setProperty("overflow", "visible", "important");
      }
      /* Fixed mobile navbar — sticky fails under overflow:hidden ancestors */
      if (header) {
        header.style.setProperty("position", "fixed", "important");
        header.style.setProperty("top", "0", "important");
        header.style.setProperty("left", "0", "important");
        header.style.setProperty("right", "0", "important");
        header.style.setProperty("width", "100%", "important");
        header.style.setProperty("z-index", "250", "important");
        header.style.setProperty("background", "#fff", "important");
        header.style.setProperty("transform", "none", "important");
      }
      shell.style.setProperty("display", "contents", "important");
      shell.style.setProperty("flex", "none", "important");
      shell.style.removeProperty("height");
      shell.style.removeProperty("max-height");
      shell.style.setProperty("overflow", "visible", "important");
      shell.style.setProperty("min-height", "0", "important");
      try {
        syncMobileChromePad();
      } catch (_e2m) {}
      if (options.forceReset || modeChanged || pathChanged) {
        __saScrollResetPath = path;
      }
      return;
    }

    document.documentElement.style.setProperty("overflow", "hidden", "important");
    document.documentElement.style.setProperty("height", "100%", "important");
    if (document.body) {
      document.body.style.setProperty("overflow", "hidden", "important");
      document.body.style.setProperty("height", "100%", "important");
      document.body.style.setProperty("max-height", "100dvh", "important");
    }
    if (wrapper) {
      wrapper.style.setProperty("display", "flex", "important");
      wrapper.style.setProperty("flex-direction", "column", "important");
      wrapper.style.setProperty("height", "100%", "important");
      wrapper.style.setProperty("max-height", "100dvh", "important");
      wrapper.style.setProperty("min-height", "0", "important");
      /* Never scroll the wrapper — keeps scrollbar below header */
      wrapper.style.setProperty("overflow", "hidden", "important");
    }
    if (header) {
      /* Desktop shell: header is a non-scrolling flex sibling — clear mobile fixed pin */
      header.style.setProperty("position", "relative", "important");
      header.style.setProperty("top", "auto", "important");
      header.style.setProperty("left", "auto", "important");
      header.style.setProperty("right", "auto", "important");
      header.style.removeProperty("background");
    }
    if (wrapper) {
      wrapper.style.setProperty("padding-top", "0", "important");
    }
    var headerH2 = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    var maxH = Math.max(160, Math.floor(window.innerHeight - headerH2));
    shell.style.removeProperty("display");
    shell.style.setProperty("flex", "1 1 0%", "important");
    shell.style.setProperty("min-height", "0", "important");
    shell.style.setProperty("height", maxH + "px", "important");
    shell.style.setProperty("max-height", maxH + "px", "important");
    shell.style.setProperty("overflow-x", "hidden", "important");
    shell.style.setProperty("overflow-y", "auto", "important");
    shell.style.setProperty("-webkit-overflow-scrolling", "touch", "important");
    try {
      document.documentElement.style.setProperty("--sa-chrome-h", headerH2 + "px");
    } catch (_e2) {}
    if (options.forceReset || modeChanged || pathChanged) {
      __saScrollResetPath = path;
      resetScrollerToTop();
    }
  }
  window.__saHardenScrollShell = hardenScrollShell;

  function getScrollShell() {
    var shells = document.querySelectorAll(
      "#sa-content-scroll, [data-sa-content-scroll='1']",
    );
    if (!shells.length) {
      var created = document.createElement("div");
      created.id = "sa-content-scroll";
      created.setAttribute("data-sa-content-scroll", "1");
      return created;
    }
    /* Prefer the shell that already has MainContent (live had empty+footer twin) */
    var keep = shells[0];
    var si;
    for (si = 0; si < shells.length; si++) {
      if (shells[si].querySelector("#MainContent, main, footer")) {
        keep = shells[si];
        break;
      }
    }
    for (si = 0; si < shells.length; si++) {
      var extra = shells[si];
      if (extra === keep) continue;
      while (extra.firstChild) {
        try {
          keep.appendChild(extra.firstChild);
        } catch (_m) {
          break;
        }
      }
      if (extra.parentNode) {
        try {
          extra.parentNode.removeChild(extra);
        } catch (_r) {}
      }
    }
    if (!keep.id) keep.id = "sa-content-scroll";
    keep.setAttribute("data-sa-content-scroll", "1");
    return keep;
  }

  var __saShellBuilt = 0;
  function ensureContentScroll() {
    if (SA_SYSTEM) return false;
    if (!document.body) return false;
    /* After first successful shell build, skip heavy reparent — was locking the tab */
    if (__saShellBuilt && Date.now() - __saShellBuilt < 8000) {
      try {
        hardenScrollShell();
      } catch (_h) {}
      return true;
    }
    return withDomLock(function () {
    var wrapper = document.querySelector(".page-wrapper") || document.body;
    var header = document.getElementById("header-group");
    if (!wrapper) return false;

    var shell = getScrollShell();

    /* Create/move shell only after header is pinned first */
    recoverChrome();
    if (header) {
      if (shell.parentNode !== wrapper || header.nextElementSibling !== shell) {
        wrapper.insertBefore(shell, header.nextSibling);
      }
      adoptIntoShell(shell, header.nextSibling);
      recoverChrome();
    } else if (!shell.parentNode) {
      wrapper.appendChild(shell);
    }

    /* Re-dedupe after adopt — never leave a 2nd shell under page-wrapper */
    shell = getScrollShell();
    if (header && (shell.parentNode !== wrapper || header.nextElementSibling !== shell)) {
      try {
        wrapper.insertBefore(shell, header.nextSibling);
      } catch (_s) {}
    }

    var orphans = document.querySelectorAll(
      ".page-wrapper > #MainContent, .page-wrapper > main, .page-wrapper > #footer-group, .page-wrapper > .shopify-section-group-footer-group, body > #MainContent, body > main, body > #footer-group, body > .shopify-section-group-footer-group, body > footer, .page-wrapper > .shopify-section, body > .shopify-section, .page-wrapper > footer"
    );
    var orphanList = [];
    for (var oi = 0; oi < orphans.length; oi++) {
      var orphan = orphans[oi];
      if (orphan && orphan !== shell && orphan !== header && !shell.contains(orphan) && canMoveNode(orphan)) {
        orphanList.push(orphan);
      }
    }
    /* Main first, footer last — query order can put dark footer under header for one frame */
    orphanList.sort(function (a, b) {
      function rank(n) {
        if (!n) return 5;
        var id = n.id || "";
        var tag = (n.tagName || "").toLowerCase();
        if (id === "MainContent" || tag === "main") return 0;
        if (
          id === "footer-group" ||
          tag === "footer" ||
          (n.classList && n.classList.contains("shopify-section-group-footer-group"))
        ) {
          return 9;
        }
        return 5;
      }
      return rank(a) - rank(b);
    });
    for (var oj = 0; oj < orphanList.length; oj++) {
      shell.appendChild(orphanList[oj]);
    }
    /* Keep MainContent above footer — reparent races can put footer first (black footer flash) */
    (function pinShellOrder() {
      shell = getScrollShell();
      var main =
        shell.querySelector(":scope > #MainContent, :scope > main") ||
        document.getElementById("MainContent");
      var foot =
        shell.querySelector(
          ":scope > footer, :scope > #footer-group, :scope > .shopify-section-group-footer-group",
        ) ||
        document.querySelector(
          ".page-wrapper > footer, body > footer, footer, #footer-group",
        );
      if (main && main.parentNode !== shell) {
        try {
          shell.insertBefore(main, shell.firstChild);
        } catch (_im) {
          try {
            shell.appendChild(main);
          } catch (_im2) {}
        }
      }
      if (foot && foot.parentNode !== shell) {
        try {
          shell.appendChild(foot);
        } catch (_f) {}
      }
      if (!main || !foot || !shell.contains(main) || !shell.contains(foot)) return;
      try {
        if (shell.firstElementChild !== main) shell.insertBefore(main, shell.firstChild);
        if (shell.lastElementChild !== foot) shell.appendChild(foot);
      } catch (_e) {}
    })();
    repairEscapedPdpSections();
    recoverChrome();

    document.documentElement.classList.add("sa-content-scroll");
    hardenScrollShell();
    __saShellBuilt = Date.now();
    return true;
    });
  }

  var ITEMS = [
    { label: "Home", href: "/", key: "home" },
    { label: "Shop", href: "/collections/all", key: "shop" },
    { label: "Bundles", href: "/collections/all?sa_type=bundle", key: "bundles" },
    { label: "Collections", href: "/collections", key: "collections" },
    { label: "About", href: "/pages/about", key: "about" },
    { label: "Contact", href: "/pages/contact", key: "contact" },
  ];

  var CAT_SKIP = {
    all: 1,
    frontpage: 1,
    bundles: 1,
    shop: 1,
    "all-accessories": 1,
    catalog: 1,
  };

  /* Match desktop overlay capacity — was hard-capped at 5 in the drawer */
  var COLLECTIONS_PANEL_LIMIT = 24;
  var __saColsCache = { at: 0, items: null };

  function fetchLatestCollections(limit, done, opts) {
    var max = typeof limit === "number" ? limit : COLLECTIONS_PANEL_LIMIT;
    var force = opts && opts.force;
    var now = Date.now();
    if (
      !force &&
      __saColsCache.items &&
      now - __saColsCache.at < 20000
    ) {
      done(__saColsCache.items.slice(0, max));
      return;
    }
    fetch("/collections.json?limit=250", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
      cache: force ? "no-store" : "default",
    })
      .then(function (res) {
        if (!res.ok) throw new Error("collections " + res.status);
        return res.json();
      })
      .then(function (data) {
        var nodes = (data && data.collections) || [];
        var items = [];
        for (var i = 0; i < nodes.length; i++) {
          var col = nodes[i];
          var handle = String((col && col.handle) || "").toLowerCase();
          if (!handle || CAT_SKIP[handle]) continue;
          var count =
            typeof col.products_count === "number" ? col.products_count : null;
          if (count === 0) continue;
          var title = col.title || handle;
          items.push({
            label: title,
            title: title,
            handle: handle,
            href: "/collections/" + handle,
            url: "/collections/" + handle,
            count: count,
            image:
              (col.image && (col.image.src || col.image)) ||
              (col.featured_image &&
                (col.featured_image.src || col.featured_image)) ||
              "",
            published: Date.parse(col.published_at || 0) || 0,
            updated: Date.parse(col.updated_at || 0) || 0,
            id: Number(col.id) || 0,
          });
        }
        /* Newest published first (nav / home / hub share this) */
        items.sort(function (a, b) {
          if (b.published !== a.published) return b.published - a.published;
          if (b.id !== a.id) return b.id - a.id;
          return String(a.label || "").localeCompare(String(b.label || ""));
        });
        __saColsCache = { at: Date.now(), items: items };
        done(items.slice(0, max));
      })
      .catch(function () {
        if (__saColsCache.items) done(__saColsCache.items.slice(0, max));
        else done([]);
      });
  }
  window.__saFetchLatestCollections = fetchLatestCollections;

  function renderDrawerCollectionLinks(wrap, items) {
    if (!wrap) return;
    var ul = wrap.querySelector(".sa-drawer-cols__list");
    if (!ul) return;
    ul.replaceChildren();
    if (!items.length) {
      var empty = document.createElement("li");
      empty.className = "sa-drawer-cols__empty";
      empty.textContent = "No collections yet";
      ul.appendChild(empty);
      return;
    }
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var cli = document.createElement("li");
      var ca = document.createElement("a");
      ca.href = item.href;
      ca.className = "sa-drawer-cols__link";
      var strong = document.createElement("strong");
      strong.textContent = item.label;
      ca.appendChild(strong);
      if (item.count != null) {
        var em = document.createElement("em");
        em.textContent =
          item.count === 1 ? "1 item" : String(item.count) + " items";
        ca.appendChild(em);
      }
      (function (href) {
        ca.addEventListener("click", function () {
          try {
            var hm = (href || "").match(/\/collections\/([^/?#]+)/i);
            if (hm && hm[1]) {
              var handle = decodeURIComponent(hm[1]).toLowerCase();
              if (!/^(all|all-accessories|catalog|shop|bundles|everyday-carry)$/i.test(handle)) {
                document.documentElement.setAttribute("data-sa-nav", "shop");
                var n = document.getElementById("sa-fixed-nav");
                var d = document.getElementById("sa-fixed-drawer");
                if (n) paintActive(n);
                if (d) paintActive(d);
              }
            }
          } catch (_c) {}
        });
      })(item.href);
      cli.appendChild(ca);
      ul.appendChild(cli);
    }
    paintCollectionSelection(wrap.closest("#sa-fixed-drawer") || wrap);
    Array.prototype.forEach.call(ul.querySelectorAll(".sa-drawer-cols__link"), function (a) {
      a.classList.remove("selfabout-nav-child");
      if (a.parentNode) a.parentNode.classList.remove("selfabout-nav-child-item");
    });
  }

  function ensureDrawerCollections(nav, opts) {
    if (!nav || nav.id !== "sa-fixed-drawer") return;
    var force = !!(opts && opts.force);
    var link = nav.querySelector(':scope > li > a[data-sa-nav-key="collections"]');
    if (!link) return;
    var li = link.parentNode;
    if (!li || li.tagName !== "LI") return;
    li.classList.add("sa-drawer-has-cols");
    var wrap = li.querySelector(":scope > .sa-drawer-cols");
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "sa-drawer-cols";
      wrap.setAttribute("data-sa-drawer-cols", "1");
      wrap.innerHTML =
        '<p class="sa-drawer-cols__eyebrow">Browse collections</p>' +
        '<div class="sa-drawer-cols__featured">' +
        '<a href="/collections/all">Shop all<span>Full catalog</span></a>' +
        '<a href="/collections/all?sa_type=bundle">Bundles<span>Clear savings</span></a>' +
        "</div>" +
        '<ul class="sa-drawer-cols__list" role="list">' +
        '<li class="sa-drawer-cols__loading">Loading…</li>' +
        "</ul>" +
        '<div class="sa-drawer-cols__foot"><a href="/collections">View all collections</a></div>';
      li.appendChild(wrap);
    } else {
      if (!wrap.querySelector(".sa-drawer-cols__featured")) {
        var feat = document.createElement("div");
        feat.className = "sa-drawer-cols__featured";
        feat.innerHTML =
          '<a href="/collections/all">Shop all<span>Full catalog</span></a>' +
          '<a href="/collections/all?sa_type=bundle">Bundles<span>Clear savings</span></a>';
        var eye = wrap.querySelector(".sa-drawer-cols__eyebrow");
        if (eye && eye.nextSibling) wrap.insertBefore(feat, eye.nextSibling);
        else wrap.insertBefore(feat, wrap.firstChild);
      }
      if (!wrap.querySelector(".sa-drawer-cols__foot")) {
        var foot = document.createElement("div");
        foot.className = "sa-drawer-cols__foot";
        foot.innerHTML = '<a href="/collections">View all collections</a>';
        wrap.appendChild(foot);
      }
    }
    if (!force && wrap.getAttribute("data-sa-cols-loaded") === "1") return;
    wrap.setAttribute("data-sa-cols-loaded", "1");
    fetchLatestCollections(
      COLLECTIONS_PANEL_LIMIT,
      function (items) {
        renderDrawerCollectionLinks(wrap, items);
      },
      { force: force },
    );
  }

  function pinNavKey() {
    var p = (location.pathname || "/").replace(/\/$/, "") || "/";
    var q = location.search || "";
    var bundleQ = /(?:^|[?&])sa_type=(?:bundle|kit)(?:&|$)/i.test(q);
    var k = "";
    if (SA_SYSTEM || /^\/(challenge|password)$/i.test(p)) {
      document.documentElement.removeAttribute("data-sa-nav");
      return;
    }
    if (p === "/") k = "home";
    else if (/\/products\//i.test(p)) {
      document.documentElement.classList.add("sa-pdp");
      k =
        document.documentElement.getAttribute("data-sa-bundle-pdp") === "1" ||
        document.querySelector("[data-selfabout-product][data-sa-kit='1']") ||
        (function () {
          try {
            return sessionStorage.getItem("sa-nav") === "bundles";
          } catch (_e) {
            return false;
          }
        })()
          ? "bundles"
          : "shop";
    } else if (p === "/collections" || /\/collections$/i.test(p)) k = "collections";
    else if (/\/collections\/(bundles|everyday-carry)(\/|$)/i.test(p)) k = "bundles";
    else if (/\/collections\/(all|all-accessories|catalog|shop)(\/|$)/i.test(p)) {
      k = bundleQ ? "bundles" : "shop";
    } else if (/\/collections\/[^/]+/i.test(p)) {
      /* Single collection PLP = Shop catalog lane (hub /collections only is Collections) */
      k = "shop";
    } else if (/\/pages\/about(\/|$)/i.test(p)) k = "about";
    else if (/\/pages\/contact(\/|$)/i.test(p)) k = "contact";
    else if (/\/search(\/|$)/i.test(p)) k = "";
    if (k === "bundles") {
      try {
        sessionStorage.setItem("sa-nav", "bundles");
      } catch (_e) {}
    } else if (k === "shop" && !/\/products\//i.test(p)) {
      try {
        if (sessionStorage.getItem("sa-nav") === "bundles") sessionStorage.removeItem("sa-nav");
      } catch (_e) {}
    }
    if (k) document.documentElement.setAttribute("data-sa-nav", k);
    else document.documentElement.removeAttribute("data-sa-nav");
    paintRichDrawerNav();
  }

  function currentCollectionHandle() {
    /* Per-collection highlight disabled — sticky sessionStorage was lighting
       items even on Home (collection selection fix). Path kept for logs. */
    var p = (location.pathname || "/").replace(/\/$/, "") || "/";
    var m = p.match(/\/collections\/([^/]+)/i);
    if (!m || !m[1]) return "";
    var h = decodeURIComponent(m[1]).toLowerCase();
    if (/^(all|all-accessories|catalog|shop|bundles|everyday-carry)$/i.test(h)) return "";
    return h;
  }

  function paintCollectionSelection(root) {
    try {
      sessionStorage.removeItem("sa-col-handle");
    } catch (_ss) {}
    var scopes = root
      ? [root]
      : [
          document.getElementById("sa-fixed-nav"),
          document.getElementById("sa-fixed-drawer"),
        ];
    var activeLeft = 0;
    for (var s = 0; s < scopes.length; s++) {
      var scope = scopes[s];
      if (!scope) continue;
      var links = scope.querySelectorAll(
        ".sa-col-panel__list a, .sa-col-panel__featured a, .sa-drawer-cols__list a, .sa-drawer-cols__link, .sa-drawer-cols__featured a",
      );
      for (var i = 0; i < links.length; i++) {
        var a = links[i];
        if (a.classList.contains("is-sa-col-active")) activeLeft += 1;
        a.classList.remove("is-sa-col-active");
        if (a.getAttribute("aria-current") === "true") a.removeAttribute("aria-current");
      }
    }
  }

  function ensureCollectionsPanel(nav, opts) {
    if (!nav) return;
    if (nav.id === "sa-fixed-drawer") {
      ensureDrawerCollections(nav, opts);
      return;
    }
    if (window.matchMedia && window.matchMedia("(max-width:899px)").matches) return;
    var link = nav.querySelector(':scope > li > a[data-sa-nav-key="collections"]');
    if (!link) return;
    var li = link.parentNode;
    if (!li || li.tagName !== "LI") return;

    /* Theme liquid owns .sa-col-dropdown (caret panel). Legacy .sa-col-panel
       from this boot script was stacking behind it on hover. */
    if (!SA_SYSTEM) {
      try {
        var legacy = li.querySelectorAll(".sa-col-panel");
        for (var lp = 0; lp < legacy.length; lp++) {
          try {
            legacy[lp].remove();
          } catch (_rmp) {
            legacy[lp].setAttribute("data-sa-legacy-panel", "1");
            legacy[lp].style.setProperty("display", "none", "important");
          }
        }
        li.classList.remove("is-open");
        document.documentElement.classList.remove("sa-panel-open");
      } catch (_leg) {}
      return;
    }

    li.classList.add("sa-nav-has-panel");
    link.setAttribute("aria-haspopup", "true");
    if (!link.getAttribute("aria-expanded")) link.setAttribute("aria-expanded", "false");

    /* Lazy panel: build only on first open so initial nav width stays compact */
    function renderCollectionLinks(panel, items) {
      var oldList = panel.querySelector(".sa-col-panel__list");
      var oldEmpty = panel.querySelector(".sa-col-panel__empty");
      if (oldList) oldList.remove();
      if (oldEmpty) oldEmpty.remove();

      if (!items.length) {
        var empty = document.createElement("div");
        empty.className = "sa-col-panel__empty";
        empty.innerHTML =
          "<strong>No collections yet</strong>" +
          "<span>Create collections in Shopify Admin and they will appear here automatically.</span>";
        var foot = panel.querySelector(".sa-col-panel__foot");
        if (foot) panel.insertBefore(empty, foot);
        else panel.appendChild(empty);
        return;
      }

      var ul = document.createElement("ul");
      ul.className = "sa-col-panel__list";
      ul.setAttribute("role", "list");
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var cli = document.createElement("li");
        var ca = document.createElement("a");
        ca.href = item.href;
        ca.textContent = item.label;
        if (item.count != null) {
          var em = document.createElement("em");
          em.textContent =
            item.count === 1 ? "1 item" : String(item.count) + " items";
          ca.appendChild(em);
        }
        ca.addEventListener(
          "click",
          (function (href) {
            return function () {
              try {
                var hm = (href || "").match(/\/collections\/([^/?#]+)/i);
                if (hm && hm[1]) {
                  var handle = decodeURIComponent(hm[1]).toLowerCase();
                  if (!/^(all|all-accessories|catalog|shop|bundles|everyday-carry)$/i.test(handle)) {
                    document.documentElement.setAttribute("data-sa-nav", "shop");
                    if (nav) paintActive(nav);
                  }
                }
              } catch (_c) {}
            };
          })(item.href),
        );
        cli.appendChild(ca);
        ul.appendChild(cli);
      }
      var footNode = panel.querySelector(".sa-col-panel__foot");
      if (footNode) panel.insertBefore(ul, footNode);
      else panel.appendChild(ul);
      paintCollectionSelection(nav);
    }

    function loadCollections(panel, force) {
      if (!force && panel.getAttribute("data-sa-cols-loaded") === "1") return;
      panel.setAttribute("data-sa-cols-loaded", "1");
      fetchLatestCollections(
        COLLECTIONS_PANEL_LIMIT,
        function (items) {
          renderCollectionLinks(panel, items);
        },
        { force: !!force },
      );
    }

    function buildPanel() {
      if (li.querySelector(".sa-col-panel")) return li.querySelector(".sa-col-panel");
      var panel = document.createElement("div");
      panel.className = "sa-col-panel";
      panel.setAttribute("role", "region");
      panel.setAttribute("aria-label", "Shop collections");

      var eye = document.createElement("p");
      eye.className = "sa-col-panel__eyebrow";
      eye.textContent = "Collections";
      panel.appendChild(eye);

      var loading = document.createElement("div");
      loading.className = "sa-col-panel__empty";
      loading.innerHTML = "<strong>Loading</strong><span>Fetching live collections...</span>";
      panel.appendChild(loading);

      var foot = document.createElement("div");
      foot.className = "sa-col-panel__foot";
      var all = document.createElement("a");
      all.href = "/collections";
      all.textContent = "View all collections";
      foot.appendChild(all);
      panel.appendChild(foot);
      li.appendChild(panel);
      loadCollections(panel);
      return panel;
    }

    if (li.getAttribute("data-sa-col-bound") === "1") return;
    li.setAttribute("data-sa-col-bound", "1");

    var closeTimer = 0;
    var openCat = function () {
      var panel = buildPanel();
      /* Refresh live list on each open — same source as mobile drawer */
      loadCollections(panel, true);
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = 0;
      }
      link.setAttribute("aria-expanded", "true");
      li.classList.add("is-open");
      document.documentElement.classList.add("sa-panel-open");
      if (typeof window.__saEnhanceCollectionsPanel === "function") {
        window.__saEnhanceCollectionsPanel(nav);
      }
      return panel;
    };
    var closeCat = function () {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        closeTimer = 0;
        link.setAttribute("aria-expanded", "false");
        li.classList.remove("is-open");
        if (!document.querySelector("#sa-fixed-nav .sa-nav-has-panel.is-open")) {
          document.documentElement.classList.remove("sa-panel-open");
        }
      }, 80);
    };

    link.addEventListener("mouseenter", openCat);
    link.addEventListener("focus", openCat);
    li.addEventListener("mouseleave", closeCat);
    li.addEventListener("focusout", function (ev) {
      if (li.contains(ev.relatedTarget)) return;
      closeCat();
    });
    li.addEventListener(
      "mouseenter",
      function onPanelEnter(ev) {
        var panel = li.querySelector(".sa-col-panel");
        if (!panel || !panel.contains(ev.target)) return;
        if (!li.classList.contains("is-open")) return;
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = 0;
        }
      },
      true
    );
    /* Dismiss if pointer leaves nav for page content (stops ghost overlay clicks) */
    if (!document.documentElement.getAttribute("data-sa-col-dismiss")) {
      document.documentElement.setAttribute("data-sa-col-dismiss", "1");
      document.addEventListener(
        "pointerdown",
        function (ev) {
          var t = ev.target;
          if (!t || !t.closest) return;
          if (t.closest("#sa-fixed-nav .sa-nav-has-panel")) return;
          var openLi = document.querySelector(
            "#sa-fixed-nav .sa-nav-has-panel.is-open",
          );
          if (!openLi) return;
          openLi.classList.remove("is-open");
          var openLink = openLi.querySelector(":scope > a");
          if (openLink) openLink.setAttribute("aria-expanded", "false");
          document.documentElement.classList.remove("sa-panel-open");
        },
        true,
      );
      function closeOpenPanels() {
        document
          .querySelectorAll("#sa-fixed-nav .sa-nav-has-panel.is-open")
          .forEach(function (openLi) {
            openLi.classList.remove("is-open");
            var openLink = openLi.querySelector(":scope > a");
            if (openLink) openLink.setAttribute("aria-expanded", "false");
          });
        document.documentElement.classList.remove("sa-panel-open");
      }
      var scrollRoot =
        document.getElementById("sa-content-scroll") ||
        document.querySelector(".page-wrapper");
      if (scrollRoot) {
        scrollRoot.addEventListener("scroll", closeOpenPanels, {
          passive: true,
        });
      }
      window.addEventListener("scroll", closeOpenPanels, { passive: true });
    }
  }

  function fillNav(list) {
    /* Skip rebuild when keys already match — replaceChildren caused navlink CLS */
    if (list && list.children && list.children.length === ITEMS.length) {
      var stable = true;
      for (var si = 0; si < ITEMS.length; si++) {
        var sa = list.children[si] && list.children[si].querySelector(":scope > a");
        if (!sa || sa.getAttribute("data-sa-nav-key") !== ITEMS[si].key) {
          stable = false;
          break;
        }
      }
      if (stable) {
        ensureCollectionsPanel(list);
        return;
      }
    }
    /* Build off-DOM then swap once — never leave an empty UL painted */
    var frag = document.createDocumentFragment();
    for (var i = 0; i < ITEMS.length; i++) {
      var item = ITEMS[i];
      var li = document.createElement("li");
      li.setAttribute("role", "listitem");
      var a = document.createElement("a");
      a.href = item.href;
      a.setAttribute("data-sa-nav-key", item.key);
      a.textContent = item.label;
      li.appendChild(a);
      frag.appendChild(li);
    }
    list.replaceChildren(frag);
    ensureCollectionsPanel(list);
  }

  window.__saEnsureCollectionsPanel = ensureCollectionsPanel;

  function syncNavItems(nav) {
    if (!nav) return;
    var hasShipping = !!nav.querySelector(
      ':scope > li > a[data-sa-nav-key="shipping"], :scope > li > a[data-sa-nav-key="support"]',
    );
    if (hasShipping) {
      fillNav(nav);
      return;
    }
    /* Patch by key — never destroy Collections because of panel/nest children */
    var ok = true;
      for (var i = 0; i < ITEMS.length; i++) {
        var item = ITEMS[i];
      var a = nav.querySelector(
        ':scope > li > a[data-sa-nav-key="' + item.key + '"]',
      );
      if (!a) {
          ok = false;
          break;
        }
        if (a.getAttribute("href") !== item.href) a.setAttribute("href", item.href);
      var label = "";
      for (var n = 0; n < a.childNodes.length; n++) {
        if (a.childNodes[n].nodeType === 3) label += a.childNodes[n].nodeValue || "";
      }
      label = label.trim() || (a.textContent || "").trim();
      if (label !== item.label && !a.querySelector("em, span, strong")) {
        a.textContent = item.label;
      } else if (label !== item.label && a.firstElementChild) {
        /* Keep nested markup; update first text node only */
        if (a.childNodes[0] && a.childNodes[0].nodeType === 3) {
          a.childNodes[0].nodeValue = item.label;
        }
      }
    }
    if (!ok) {
    fillNav(nav);
      return;
    }
    ensureCollectionsPanel(nav);
  }

  function build(id, drawer) {
    var list = document.createElement("ul");
    list.id = id;
    list.className = drawer ? "sa-fixed-nav sa-fixed-nav--drawer" : "sa-fixed-nav";
    list.setAttribute("role", "list");
    list.setAttribute("aria-label", "Primary");
    fillNav(list);
    return list;
  }

  function paintActive(root) {
    var key = document.documentElement.getAttribute("data-sa-nav") || "";
    if (!root) return;
    /* Top-level nav only — never decorate panel/featured links as route active */
    var links = root.querySelectorAll(":scope > li > a[data-sa-nav-key]");
    var activeKeys = [];
    for (var i = 0; i < links.length; i++) {
      var on = !!(key && links[i].getAttribute("data-sa-nav-key") === key);
      links[i].classList.toggle("selfabout-nav-active", on);
      if (on) {
        links[i].setAttribute("aria-current", "page");
        activeKeys.push(links[i].getAttribute("data-sa-nav-key"));
      } else {
        links[i].removeAttribute("aria-current");
        links[i].removeAttribute("data-sa-active");
      }
    }
    paintCollectionSelection(root);
  }

  function paintRichDrawerNav() {
    var key = document.documentElement.getAttribute("data-sa-nav") || "";
    var roots = document.querySelectorAll(
      "body > .menu-drawer[data-sa-portaled='1'] .sa-drawer-nav, .menu-drawer .sa-drawer-nav",
    );
    for (var r = 0; r < roots.length; r++) {
      var nav = roots[r];
      var links = nav.querySelectorAll("a.sa-drawer-link[data-sa-nav-key]");
      for (var i = 0; i < links.length; i++) {
        var linkKey = links[i].getAttribute("data-sa-nav-key") || "";
        var on = !!(key && linkKey === key);
        links[i].classList.toggle("sa-drawer-link--active", on);
        if (on) links[i].setAttribute("aria-current", "page");
        else links[i].removeAttribute("aria-current");
      }
    }
  }

  function saNavKeyFromHref(href) {
    try {
      var u = new URL(href, location.href);
      var p = (u.pathname || "/").replace(/\/$/, "") || "/";
      var q = u.search || "";
      if (p === "/") return "home";
      if (/\/pages\/about(\/|$)/i.test(p)) return "about";
      if (/\/pages\/contact(\/|$)/i.test(p) || /\/pages\/support(\/|$)/i.test(p)) return "contact";
      if (p === "/collections" || /\/collections$/i.test(p)) return "collections";
      if (/\/collections\/(bundles|everyday-carry)(\/|$)/i.test(p)) return "bundles";
      if (
        /\/collections\/(all|all-accessories|catalog|shop)(\/|$)/i.test(p) &&
        /(?:^|[?&])sa_type=(?:bundle|kit)(?:&|$)/i.test(q)
      ) {
        return "bundles";
      }
      if (/\/collections\/(all|all-accessories|catalog|shop)(\/|$)/i.test(p)) return "shop";
      if (/\/collections\/[^/]+/i.test(p)) return "shop";
    } catch (_k) {}
    return "";
  }

  function clearInlinePosition(nav) {
    if (!nav) return;
    /* Strip conflicting inline coords — CSS absolute-centers via translate */
    [
      "position",
      "top",
      "left",
      "right",
      "bottom",
      "margin",
      "margin-left",
      "margin-top",
      "transform",
      "visibility",
      "opacity",
      "pointer-events",
      "width",
      "max-width",
    ].forEach(function (prop) {
      nav.style.removeProperty(prop);
    });
    nav.style.setProperty("display", "flex", "important");
  }

  function unlockFixedChrome() {
    var mobile =
      !!(window.matchMedia && window.matchMedia("(max-width:899px)").matches);
    var nodes = document.querySelectorAll(
      "sticky-header, .header-wrapper, .shopify-section-header-sticky, header-component, #header-component, #header-group, .shopify-section-group-header-group, .announcement-bar, announcement-bar"
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var isHeaderChrome =
        el.id === "header-group" ||
        (el.classList && el.classList.contains("shopify-section-group-header-group")) ||
        el.id === "header-component" ||
        (el.tagName && el.tagName.toLowerCase() === "header-component") ||
        (el.tagName && el.tagName.toLowerCase() === "sticky-header") ||
        (el.classList &&
          (el.classList.contains("header-wrapper") ||
            el.classList.contains("shopify-section-header-sticky")));

      /* Mobile: pin only the header-group with fixed; keep children in normal flow */
      if (mobile && isHeaderChrome) {
        var isGroup =
          el.id === "header-group" ||
          (el.classList && el.classList.contains("shopify-section-group-header-group"));
        if (isGroup) {
          el.style.setProperty("position", "fixed", "important");
          el.style.setProperty("top", "0", "important");
          el.style.setProperty("left", "0", "important");
          el.style.setProperty("right", "0", "important");
          el.style.setProperty("width", "100%", "important");
          el.style.setProperty("z-index", "250", "important");
          el.style.setProperty("background", "#fff", "important");
        } else {
          el.style.setProperty("position", "relative", "important");
          el.style.setProperty("top", "auto", "important");
          el.style.setProperty("left", "auto", "important");
          el.style.setProperty("right", "auto", "important");
          el.style.setProperty("bottom", "auto", "important");
        }
        el.style.setProperty("transform", "none", "important");
        el.style.setProperty("opacity", "1", "important");
        el.style.setProperty("visibility", "visible", "important");
        el.classList.remove("shopify-section-header-hidden");
        if (el.tagName === "STICKY-HEADER" || (el.classList && el.classList.contains("shopify-section-header-sticky"))) {
          el.style.setProperty("height", "auto", "important");
          el.style.setProperty("min-height", "0", "important");
          el.style.setProperty("padding-top", "0", "important");
          el.style.removeProperty("margin-top");
        }
        continue;
      }

      var inlinePos = el.style && el.style.position;
      if (inlinePos === "fixed" || inlinePos === "sticky") {
        el.style.setProperty("position", "relative", "important");
        el.style.setProperty("top", "auto", "important");
        el.style.setProperty("left", "auto", "important");
        el.style.setProperty("right", "auto", "important");
        el.style.setProperty("bottom", "auto", "important");
      }
      /* Sticky spacers leave inline height — was doubling chrome to 256px */
      if (el.tagName === "STICKY-HEADER" || (el.classList && el.classList.contains("shopify-section-header-sticky"))) {
        el.style.setProperty("height", "auto", "important");
        el.style.setProperty("min-height", "0", "important");
        el.style.setProperty("padding-top", "0", "important");
        el.style.removeProperty("margin-top");
      }
      el.style.setProperty("transform", "none", "important");
      el.style.setProperty("opacity", "1", "important");
      el.style.setProperty("visibility", "visible", "important");
      el.classList.remove("shopify-section-header-hidden");
    }
    recoverChrome();
  }

  var pendingNav = null;

  function dedupeFixedNav() {
    var all = document.querySelectorAll("#sa-fixed-nav, .sa-fixed-nav:not(.sa-fixed-nav--drawer)");
    if (all.length <= 1) return all[0] || null;
    var keep = null;
    for (var i = 0; i < all.length; i++) {
      var n = all[i];
      if (n.id === "sa-fixed-drawer" || (n.classList && n.classList.contains("sa-fixed-nav--drawer"))) continue;
      var inCenter =
        n.closest &&
        (n.closest(".header__column--center") ||
          n.closest('[data-testid="header-top-center"]'));
      if (inCenter && n.querySelector('a[data-sa-nav-key="collections"]')) {
        keep = n;
        break;
      }
      if (!keep && inCenter) keep = n;
      if (!keep) keep = n;
    }
    for (var j = 0; j < all.length; j++) {
      if (all[j] === keep) continue;
      if (all[j].id === "sa-fixed-drawer" || (all[j].classList && all[j].classList.contains("sa-fixed-nav--drawer"))) continue;
      try {
        all[j].remove();
      } catch (_rm) {
        try {
          all[j].style.setProperty("display", "none", "important");
        } catch (_h) {}
      }
    }
    return keep;
  }

  function ensureNav() {
    if (window.matchMedia && window.matchMedia("(max-width:899px)").matches) return null;
    pinNavKey();
    var nav = dedupeFixedNav() || document.getElementById("sa-fixed-nav") || pendingNav;
    if (!nav) {
      nav = build("sa-fixed-nav", false);
      pendingNav = nav;
    }
    syncNavItems(nav);
    /* Never leave nav on html/body — CSS forces display:none there (blank flash) */
    var parent = nav.parentNode;
    if (parent && (parent === document.documentElement || parent === document.body)) {
      parent.removeChild(nav);
      pendingNav = nav;
    }
    /* Keep detached until center exists — never appendChild to html/body */
    paintActive(nav);
    document.documentElement.classList.add("selfabout-js");
    return nav;
  }

  function measureVisibleChromeH(group) {
    if (!group) return 56;
    try {
      var hdr =
        group.querySelector("#header-component, header-component") ||
        group.querySelector(".header-wrapper .header, .header");
      var ann = group.querySelector(
        ".announcement-bar, announcement-bar, .header-announcements, announcement-bar-component, [data-testid='announcement-bar']"
      );
      var top = Infinity;
      var bottom = 0;
      function include(el) {
        if (!el) return;
        var st = window.getComputedStyle(el);
        if (!st || st.display === "none" || st.visibility === "hidden") return;
        if (parseFloat(st.opacity || "1") < 0.05) return;
        var r = el.getBoundingClientRect();
        if (r.height < 2 || r.width < 2) return;
        if (r.top < top) top = r.top;
        if (r.bottom > bottom) bottom = r.bottom;
      }
      /* Announcement only if it has real text (forced 2.25rem empty shells inflate pad) */
      if (ann && ((ann.textContent || "").replace(/\s+/g, "").length > 0)) include(ann);
      include(hdr);
      if (!(bottom > top) || !isFinite(top)) return 56;
      return Math.max(56, Math.ceil(bottom - Math.min(top, 0)));
    } catch (_m) {
      return 56;
    }
  }

  function syncMobileChromePad() {
    var mobile =
      !!(window.matchMedia && window.matchMedia("(max-width:899px)").matches);
    var group =
      document.getElementById("header-group") ||
      document.querySelector(".shopify-section-group-header-group");
    var wrapper =
      (group && group.closest && group.closest(".page-wrapper")) ||
      document.querySelector(".page-wrapper");
    if (!mobile) {
      if (wrapper) wrapper.style.setProperty("padding-top", "0", "important");
      if (group) {
        group.style.removeProperty("display");
        group.style.removeProperty("flex-direction");
      }
      return;
    }
    if (!group) return;

    /* Beat Horizon `#header-group:has([sticky]){display:contents}` which drops fixed
       and leaves in-flow header + padding-top = post-load white strip */
    group.style.setProperty("display", "flex", "important");
    group.style.setProperty("flex-direction", "column", "important");
    group.style.setProperty("position", "fixed", "important");
    group.style.setProperty("top", "0", "important");
    group.style.setProperty("left", "0", "important");
    group.style.setProperty("right", "0", "important");
    group.style.setProperty("width", "100%", "important");
    group.style.setProperty("z-index", "250", "important");
    group.style.setProperty("background", "#fff", "important");
    group.style.setProperty("height", "auto", "important");
    group.style.setProperty("min-height", "0", "important");
    group.style.setProperty("max-height", "none", "important");
    group.style.setProperty("padding", "0", "important");
    group.style.setProperty("margin", "0", "important");
    group.style.setProperty("transform", "none", "important");

    var spacers = group.querySelectorAll(
      "sticky-header, .header-wrapper, .shopify-section-header-sticky, .header-section"
    );
    for (var i = 0; i < spacers.length; i++) {
      var sp = spacers[i];
      sp.style.setProperty("display", "block", "important");
      sp.style.setProperty("position", "relative", "important");
      sp.style.setProperty("height", "auto", "important");
      sp.style.setProperty("min-height", "0", "important");
      sp.style.setProperty("max-height", "none", "important");
      sp.style.setProperty("padding-top", "0", "important");
      sp.style.setProperty("padding-bottom", "0", "important");
      sp.style.setProperty("margin-top", "0", "important");
      sp.style.setProperty("margin-bottom", "0", "important");
      sp.style.setProperty("top", "auto", "important");
    }

    var h = measureVisibleChromeH(group);
    document.documentElement.style.setProperty("--sa-chrome-h", h + "px");
    if (wrapper) {
      wrapper.style.setProperty("padding-top", h + "px", "important");
    }
  }

  function pinChromeHeight() {
    var group =
      document.getElementById("header-group") ||
      document.querySelector(".shopify-section-group-header-group");
    var mobile =
      !!(window.matchMedia && window.matchMedia("(max-width:899px)").matches);
    if (mobile) {
      syncMobileChromePad();
      return;
    }
    var h = group ? Math.round(group.getBoundingClientRect().height) : 0;
    if (h < 40) h = 72;
    document.documentElement.style.setProperty("--sa-chrome-h", h + "px");
  }

  function finishNav(nav) {
    if (nav) clearInlinePosition(nav);
    ensureContentScroll();
    pinChromeHeight();
    document.documentElement.classList.add("selfabout-js", "sa-nav-ready", "sa-nav-placed", "sa-header-ready");
    try {
      hideThemeDesktopMenu(
        document.querySelector("#header-component, header-component"),
      );
    } catch (_htm) {}
    requestAnimationFrame(function () {
      ensureContentScroll();
    });
  }

  /* Keep search/profile/cart in the right actions cluster — never beside Contact */
  function pinHeaderActions(header) {
    if (!header) return;
    try {
      var cols = header.querySelector(".header__columns");
      var actions =
        header.querySelector("header-actions, .header-actions") ||
        header.querySelector(".header__icons");
      var rightCol =
        header.querySelector(".header__columns .header__column--right") ||
        header.querySelector(".header__column--right");
      var leftCol =
        header.querySelector(".header__column--left") ||
        header.querySelector(".header__column:has(.header-logo)");
      var centerCol =
        header.querySelector(".header__columns .header__column--center") ||
        header.querySelector(".header__column--center");

      if (cols && actions) {
        if (rightCol) {
          if (actions.parentNode !== rightCol) rightCol.appendChild(actions);
        } else if (actions.parentNode !== cols) {
          cols.appendChild(actions);
        }
      }

      var searches = header.querySelectorAll(
        "search-button, .header__icon--search, summary.header__icon--search, a.header__icon--search, [data-testid='header-search'], .header-search"
      );
      var keepSearch = null;
      for (var si = 0; si < searches.length; si++) {
        if (actions && actions.contains(searches[si])) {
          keepSearch = searches[si];
          break;
        }
      }
      if (!keepSearch && searches.length) keepSearch = searches[searches.length - 1];
      for (var sj = 0; sj < searches.length; sj++) {
        if (searches[sj] === keepSearch) {
          searches[sj].removeAttribute("data-sa-search-dupe");
          searches[sj].style.removeProperty("display");
          continue;
        }
        /* Hard-remove left/center search duplicates — display:none still painted briefly */
        try {
        searches[sj].setAttribute("data-sa-search-dupe", "1");
          if (searches[sj].parentNode) searches[sj].parentNode.removeChild(searches[sj]);
        } catch (_rm) {
        searches[sj].style.setProperty("display", "none", "important");
      }
      }
      /*
        Keep search as sibling of header-actions in the right column.
        Reparenting into actions shifts the cart edge during load.
      */
      var mobile =
        typeof window.matchMedia === "function" &&
        window.matchMedia("(max-width: 899px)").matches;
      var gap = mobile ? "0.25rem" : "0.35rem";
      var trio = "calc(3 * 44px + 2 * " + gap + ")";
      var barH = mobile ? "56px" : "66px";
      var topPx = mobile ? "6px" : "11px";
      if (keepSearch && actions) {
        if (!actions.contains(keepSearch)) {
          try {
            actions.insertBefore(keepSearch, actions.firstChild);
          } catch (_ins) {
            try { actions.appendChild(keepSearch); } catch (_ap2) {}
          }
        }
      }
      if (rightCol) {
        rightCol.style.setProperty("position", "relative", "important");
        rightCol.style.setProperty("display", "flex", "important");
        rightCol.style.setProperty("align-items", "center", "important");
        rightCol.style.setProperty("justify-content", "flex-end", "important");
        rightCol.style.setProperty("gap", gap, "important");
        rightCol.style.setProperty("min-width", trio, "important");
        rightCol.style.setProperty("height", mobile ? barH : "44px", "important");
        rightCol.style.setProperty("max-height", mobile ? barH : "44px", "important");
        rightCol.style.setProperty("align-self", "center", "important");
        rightCol.style.setProperty("overflow", "visible", "important");
        rightCol.style.setProperty("opacity", "1", "important");
        rightCol.style.setProperty("visibility", "visible", "important");
        if (mobile) {
          rightCol.style.setProperty("order", "3", "important");
          rightCol.style.setProperty("flex", "0 0 " + trio, "important");
          rightCol.style.setProperty("width", trio, "important");
          rightCol.style.setProperty("grid-area", "auto", "important");
          rightCol.style.removeProperty("grid-row");
        } else {
          /* Drop mobile flex leftovers so desktop grid areas work */
          [
            "order",
            "flex",
            "width",
            "max-width",
          ].forEach(function (prop) {
            try {
              rightCol.style.removeProperty(prop);
            } catch (_clrR) {}
          });
          rightCol.style.setProperty("grid-area", "right", "important");
          rightCol.style.setProperty("grid-row", "1", "important");
          rightCol.style.setProperty("justify-self", "end", "important");
        }
      }
      if (leftCol) {
        leftCol.style.setProperty("min-width", mobile ? "44px" : "0", "important");
        leftCol.style.setProperty("height", barH, "important");
        leftCol.style.setProperty("max-height", barH, "important");
        leftCol.style.setProperty("align-self", "stretch", "important");
        leftCol.style.setProperty("overflow", "visible", "important");
        if (mobile) {
          leftCol.style.setProperty("order", "1", "important");
          leftCol.style.setProperty("flex", "0 0 44px", "important");
          leftCol.style.setProperty("max-width", "44px", "important");
          leftCol.style.setProperty("width", "44px", "important");
          leftCol.style.setProperty("grid-area", "auto", "important");
          leftCol.style.removeProperty("grid-row");
        } else {
          ["order", "flex", "width", "max-width"].forEach(function (prop) {
            try {
              leftCol.style.removeProperty(prop);
            } catch (_clrL) {}
          });
          leftCol.style.setProperty("grid-area", "left", "important");
          leftCol.style.setProperty("grid-row", "1", "important");
        }
      }
      if (centerCol) {
        if (mobile) {
          centerCol.style.setProperty("min-width", "0", "important");
          centerCol.style.removeProperty("max-width");
          centerCol.style.removeProperty("width");
          centerCol.style.setProperty("max-width", "none", "important");
          centerCol.style.setProperty("width", "auto", "important");
          centerCol.style.setProperty("height", barH, "important");
          centerCol.style.setProperty("max-height", barH, "important");
          centerCol.style.setProperty("min-height", "0", "important");
          centerCol.style.setProperty("overflow", "visible", "important");
          centerCol.style.setProperty("padding", "0", "important");
          centerCol.style.setProperty("display", "flex", "important");
          centerCol.style.setProperty("align-items", "center", "important");
          centerCol.style.setProperty("justify-content", "center", "important");
          centerCol.style.setProperty("order", "2", "important");
          centerCol.style.setProperty("flex", "1 1 auto", "important");
          centerCol.style.setProperty("grid-area", "auto", "important");
          centerCol.style.removeProperty("grid-row");
          centerCol.style.setProperty("align-self", "stretch", "important");
        } else {
          ["order", "flex", "width", "max-width", "min-width"].forEach(function (prop) {
            try {
              centerCol.style.removeProperty(prop);
            } catch (_clrC) {}
          });
          centerCol.style.setProperty("grid-area", "center", "important");
          centerCol.style.setProperty("grid-row", "1", "important");
          centerCol.style.setProperty("display", "flex", "important");
          centerCol.style.setProperty("align-items", "center", "important");
          centerCol.style.setProperty("justify-content", "center", "important");
          centerCol.style.setProperty("height", barH, "important");
          centerCol.style.setProperty("max-height", barH, "important");
          centerCol.style.setProperty("min-height", barH, "important");
        }
      }
      /* Desktop: restore grid on columns — mobile left display:flex stuck and hid the icon rail */
      if (cols) {
        if (mobile) {
          cols.style.setProperty("display", "flex", "important");
          cols.style.setProperty("flex-wrap", "nowrap", "important");
          cols.style.setProperty("align-items", "center", "important");
          cols.style.setProperty("justify-content", "space-between", "important");
          cols.style.setProperty("height", barH, "important");
          cols.style.setProperty("max-height", barH, "important");
        } else {
          [
            "flex-wrap",
            "justify-content",
            "align-items",
          ].forEach(function (prop) {
            try {
              cols.style.removeProperty(prop);
            } catch (_clrCols) {}
          });
          cols.style.setProperty("display", "grid", "important");
          cols.style.setProperty(
            "grid-template-areas",
            '"left center right"',
            "important",
          );
          cols.style.setProperty(
            "grid-template-columns",
            "minmax(10rem, 1fr) auto minmax(10rem, 1fr)",
            "important",
          );
          cols.style.setProperty("height", barH, "important");
          cols.style.setProperty("max-height", barH, "important");
          cols.style.setProperty("min-height", barH, "important");
          cols.style.setProperty("align-items", "center", "important");
        }
      }
      if (header) {
        if (mobile) {
          header.style.setProperty("overflow", "visible", "important");
          header.style.setProperty("height", barH, "important");
          header.style.setProperty("max-height", barH, "important");
        } else {
          header.style.setProperty("overflow", "visible", "important");
          header.style.setProperty("height", barH, "important");
          header.style.setProperty("min-height", barH, "important");
          header.style.setProperty("max-height", barH, "important");
        }
      }
      var rowEl = header && header.querySelector(".header__row, .header__row--top");
      if (rowEl) {
        rowEl.style.setProperty("height", barH, "important");
        rowEl.style.setProperty("max-height", barH, "important");
        rowEl.style.setProperty("min-height", barH, "important");
        if (mobile) {
          rowEl.style.setProperty("overflow", "visible", "important");
          rowEl.style.setProperty("display", "block", "important");
        } else {
          rowEl.style.setProperty("overflow", "visible", "important");
          rowEl.style.setProperty("display", "block", "important");
        }
      }
      /* Mobile brand: absolute 50% of .header__columns = true optical center
         (flex-center in middle col shifts left because right rail is wider than hamburger). */
      if (mobile && cols) {
        cols.style.setProperty("position", "relative", "important");
        var pin =
          document.getElementById("sa-mobile-logo") ||
          (function () {
            var logoUrl =
              (window.__SA_BRAND && window.__SA_BRAND.logo) ||
              (document.querySelector('meta[name="selfabout-brand-logo"]') &&
                document
                  .querySelector('meta[name="selfabout-brand-logo"]')
                  .getAttribute("content")) ||
              "";
            if (!logoUrl) return null;
            var a = document.createElement("a");
            a.id = "sa-mobile-logo";
            a.href = "/";
            a.setAttribute(
              "aria-label",
              (window.__SA_BRAND && window.__SA_BRAND.logoAlt) || "SelfAbout",
            );
            var img = document.createElement("img");
            img.className = "sa-brand-logo";
            img.src = logoUrl;
            img.alt = a.getAttribute("aria-label");
            img.decoding = "async";
            img.setAttribute("fetchpriority", "high");
            img.width = 116;
            img.height = 30;
            a.appendChild(img);
            return a;
          })();
        if (pin) {
          if (pin.parentNode !== cols) {
            try {
              cols.appendChild(pin);
            } catch (_mvPin) {}
          }
          pin.style.setProperty("display", "inline-flex", "important");
          pin.style.setProperty("align-items", "center", "important");
          pin.style.setProperty("justify-content", "center", "important");
          pin.style.setProperty("position", "absolute", "important");
          pin.style.setProperty("left", "50%", "important");
          pin.style.setProperty("top", "50%", "important");
          pin.style.setProperty("right", "auto", "important");
          pin.style.setProperty("bottom", "auto", "important");
          pin.style.setProperty("transform", "translate(-50%, -50%)", "important");
          pin.style.setProperty("opacity", "1", "important");
          pin.style.setProperty("visibility", "visible", "important");
          pin.style.setProperty("pointer-events", "auto", "important");
          pin.style.setProperty("height", "1.85rem", "important");
          pin.style.setProperty("width", "max-content", "important");
          pin.style.setProperty("max-width", "min(7.25rem, 42vw)", "important");
          pin.style.setProperty("z-index", "6", "important");
          pin.style.setProperty("margin", "0", "important");
          pin.style.setProperty("padding", "0", "important");
          var pinImg = pin.querySelector("img");
          if (pinImg) {
            pinImg.style.setProperty("display", "block", "important");
            pinImg.style.setProperty("opacity", "1", "important");
            pinImg.style.setProperty("visibility", "visible", "important");
            pinImg.style.setProperty("height", "1.85rem", "important");
            pinImg.style.setProperty("max-height", "1.85rem", "important");
            pinImg.style.setProperty("width", "auto", "important");
            pinImg.style.setProperty("max-width", "min(7.25rem, 42vw)", "important");
          }
          document.documentElement.classList.add("sa-has-brand-logo");
        }
        /* Reinforce park on theme logos — never let open/close unhide 0-size hosts */
        var themeLogos = header.querySelectorAll(
          ".header-logo, .sa-brand-logo-host, a.header__heading-link, [data-testid='header-logo']",
        );
        for (var tl = 0; tl < themeLogos.length; tl++) {
          if (themeLogos[tl].id === "sa-mobile-logo") continue;
          themeLogos[tl].style.setProperty("opacity", "0", "important");
          themeLogos[tl].style.setProperty("visibility", "hidden", "important");
          themeLogos[tl].style.setProperty("pointer-events", "none", "important");
          themeLogos[tl].style.setProperty("width", "0", "important");
          themeLogos[tl].style.setProperty("height", "0", "important");
          themeLogos[tl].style.setProperty("overflow", "hidden", "important");
        }
      }
      if (!mobile && leftCol && centerCol) {
        var backLogo = centerCol.querySelector(
          ".header-logo[data-sa-logo-was-left], a.header__heading-link[data-sa-logo-was-left], .sa-brand-logo-host[data-sa-logo-was-left], a.header-logo[data-sa-logo-was-left]",
        );
        if (backLogo) {
          try {
            leftCol.appendChild(backLogo);
            backLogo.removeAttribute("data-sa-logo-was-left");
          } catch (_logoBk) {}
        }
      }
      /* Scrub any remaining search still sitting in the logo column */
      if (leftCol) {
        var leftSearches = leftCol.querySelectorAll(
          "search-button, .header__icon--search, summary.header__icon--search, a.header__icon--search, .header-search, [data-testid='header-search']",
        );
        for (var ls = 0; ls < leftSearches.length; ls++) {
          if (keepSearch && leftSearches[ls] === keepSearch) continue;
          try {
            if (leftSearches[ls].parentNode) leftSearches[ls].parentNode.removeChild(leftSearches[ls]);
          } catch (_ls) {}
        }
      }
      if (leftCol && actions && leftCol.contains(actions) && rightCol) {
        rightCol.appendChild(actions);
      }

      if (actions) {
        actions.style.setProperty("pointer-events", "auto", "important");
        actions.style.setProperty("z-index", "12", "important");
        actions.style.setProperty("display", "inline-flex", "important");
        actions.style.setProperty("align-items", "center", "important");
        actions.style.setProperty("justify-content", "flex-end", "important");
        actions.style.setProperty("gap", gap, "important");
        actions.style.setProperty("margin-inline-start", "0", "important");
        actions.style.setProperty("position", "static", "important");
        actions.style.setProperty("right", "auto", "important");
        actions.style.setProperty("top", "auto", "important");
        actions.style.setProperty("bottom", "auto", "important");
        actions.style.setProperty("left", "auto", "important");
        actions.style.setProperty("height", "44px", "important");
        actions.style.setProperty("margin-block", "0", "important");
        actions.style.setProperty("transform", "none", "important");
        actions.style.setProperty("opacity", "1", "important");
        actions.style.setProperty("visibility", "visible", "important");
        var clickables = actions.querySelectorAll(
          "search-button, account-button, cart-icon, .header__icon--search, .header__icon--account, .header__icon--cart, a, button, summary, .header-actions__action, .sa-header-action-btn"
        );
        for (var ci = 0; ci < clickables.length; ci++) {
          clickables[ci].style.setProperty("pointer-events", "auto", "important");
          clickables[ci].style.setProperty("cursor", "pointer", "important");
          clickables[ci].style.setProperty("opacity", "1", "important");
          clickables[ci].style.setProperty("visibility", "visible", "important");
          clickables[ci].style.setProperty("display", "inline-flex", "important");
        }
      }
      if (keepSearch && actions && !actions.contains(keepSearch)) {
        try {
          actions.insertBefore(keepSearch, actions.firstChild);
        } catch (_insSearch) {
          try { actions.appendChild(keepSearch); } catch (_ap) {}
        }
      }
      if (keepSearch) {
        keepSearch.style.setProperty("position", "static", "important");
        keepSearch.style.setProperty("right", "auto", "important");
        keepSearch.style.setProperty("top", "auto", "important");
        keepSearch.style.setProperty("bottom", "auto", "important");
        keepSearch.style.setProperty("left", "auto", "important");
        keepSearch.style.setProperty("height", "44px", "important");
        keepSearch.style.setProperty("width", "44px", "important");
        keepSearch.style.setProperty("margin", "0", "important");
        keepSearch.style.setProperty("transform", "none", "important");
        keepSearch.style.setProperty("display", "inline-flex", "important");
        keepSearch.style.setProperty("align-items", "center", "important");
        keepSearch.style.setProperty("justify-content", "center", "important");
        keepSearch.style.setProperty("z-index", "2", "important");
        keepSearch.style.setProperty("opacity", "1", "important");
        keepSearch.style.setProperty("visibility", "visible", "important");
      }
    } catch (eAct) {}
  }

  function findLiveMenuDrawer() {
    var portaled = document.querySelector(
      "body > .menu-drawer[data-sa-portaled='1']",
    );
    if (portaled && portaled.getAttribute("data-sa-drawer-stub") !== "1") {
      return portaled;
    }
    var nodes = document.querySelectorAll(
      ".menu-drawer:not([data-sa-drawer-stub]):not(.sa-menu-drawer-stub)",
    );
    for (var i = 0; i < nodes.length; i++) {
      var d = nodes[i];
      if (!d || d.getAttribute("data-sa-drawer-stub") === "1") continue;
      if (
        d.querySelector(
          ".menu-drawer__navigation, nav, .menu-drawer__menu, ul, .menu-drawer__close-button, .close-button",
        )
      ) {
        return d;
      }
    }
    /* Challenge/Horizon sometimes exposes the panel as <menu-drawer class="menu-drawer"> */
    var host = document.querySelector("menu-drawer");
    if (host) {
      if (host.classList && host.classList.contains("menu-drawer")) return host;
      var inner = host.querySelector(".menu-drawer");
      if (inner) return inner;
    }
    return document.querySelector("#menu-drawer .menu-drawer") || null;
  }

  function hasRichThemeDrawer(drawer) {
    if (!drawer || !drawer.querySelector) return false;
    return !!(
      drawer.querySelector(".sa-drawer-nav") ||
      drawer.querySelector(".sa-drawer-link") ||
      drawer.querySelector(".sa-drawer-footer")
    );
  }

  function restoreRichThemeDrawer(drawer) {
    if (!drawer) return;
    try {
      var junk = drawer.querySelectorAll("#sa-fixed-drawer");
      for (var j = 0; j < junk.length; j++) {
        try {
          junk[j].remove();
        } catch (_rj) {
          junk[j].style.setProperty("display", "none", "important");
        }
      }
    } catch (_j2) {}
    try {
      var hidden = drawer.querySelectorAll(
        "[data-sa-theme-menu-hidden],[data-sa-theme-extra-hidden]",
      );
      for (var h = 0; h < hidden.length; h++) {
        var node = hidden[h];
        if (!node) continue;
        node.removeAttribute("data-sa-theme-menu-hidden");
        node.removeAttribute("data-sa-theme-extra-hidden");
        node.removeAttribute("hidden");
        node.style.removeProperty("display");
        node.style.removeProperty("visibility");
        node.style.removeProperty("pointer-events");
        node.style.removeProperty("height");
        node.style.removeProperty("overflow");
      }
    } catch (_h2) {}
  }

  function hideThemeDrawerExtras(drawer) {
    if (!drawer) return;
    /* Storefront liquid drawer (icons + WhatsApp) must stay visible */
    if (!SA_SYSTEM && hasRichThemeDrawer(drawer)) {
      restoreRichThemeDrawer(drawer);
      return;
    }
    /* Only strip theme chrome once SelfAbout list is actually present */
    if (!drawer.querySelector("#sa-fixed-drawer > li > a[data-sa-nav-key]")) return;
    var host =
      drawer.querySelector(".menu-drawer__navigation") ||
      drawer.querySelector("nav") ||
      drawer;
    var kids = host.children || [];
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (!el || el.id === "sa-fixed-drawer") continue;
      if (
        el.classList &&
        (el.classList.contains("sa-drawer-discover") ||
          el.classList.contains("sa-drawer-cols-wrap") ||
          el.classList.contains("sa-drawer-cols"))
      ) {
        continue;
      }
      if (
        el.matches &&
        el.matches(
          "ul, nav, .menu-list, .list-menu, .menu-drawer__menu, .menu-drawer__menu-item",
        )
      ) {
        el.setAttribute("hidden", "");
        el.setAttribute("data-sa-theme-menu-hidden", "1");
        el.style.setProperty("display", "none", "important");
        el.style.setProperty("visibility", "hidden", "important");
      }
    }
    /* Challenge product rail / featured blocks sit as drawer siblings */
    var kidsTop = drawer.children || [];
    for (var t = 0; t < kidsTop.length; t++) {
      var top = kidsTop[t];
      if (!top) continue;
      if (
        top.id === "sa-fixed-drawer" ||
        (top.classList &&
          (top.classList.contains("menu-drawer__close-button") ||
            top.classList.contains("close-button") ||
            top.classList.contains("menu-drawer__navigation") ||
            top.classList.contains("menu-drawer__backdrop"))) ||
        (top.tagName === "NAV" && top.querySelector("#sa-fixed-drawer")) ||
        top.tagName === "BUTTON"
      ) {
        continue;
      }
      if (top.querySelector && top.querySelector("#sa-fixed-drawer")) continue;
      top.setAttribute("data-sa-theme-extra-hidden", "1");
      top.style.setProperty("display", "none", "important");
    }
    var closeBtn = drawer.querySelector(
      ":scope > .menu-drawer__close-button, :scope > .close-button.menu-drawer__close-button, .menu-drawer__close-button, .close-button.menu-drawer__close-button",
    );
    if (closeBtn) {
      closeBtn.style.setProperty("align-self", "flex-end", "important");
      closeBtn.style.setProperty("margin-inline-start", "auto", "important");
      closeBtn.style.setProperty("margin-left", "auto", "important");
      closeBtn.style.setProperty("position", "sticky", "important");
      closeBtn.style.setProperty("top", "0", "important");
      closeBtn.style.setProperty("display", "inline-flex", "important");
    }
  }

  function ensureDrawerHost(drawer) {
    var host =
      drawer.querySelector(".menu-drawer__navigation") ||
      drawer.querySelector("nav.menu-drawer__navigation") ||
      drawer.querySelector(":scope > nav") ||
      drawer.querySelector("nav");
    if (host) return host;
    host = document.createElement("nav");
    host.className = "menu-drawer__navigation";
    host.setAttribute("data-sa-nav-host", "1");
    var closeBtn = drawer.querySelector(
      ":scope > .menu-drawer__close-button, :scope > .close-button",
    );
    if (closeBtn && closeBtn.parentNode === drawer) {
      if (closeBtn.nextSibling) drawer.insertBefore(host, closeBtn.nextSibling);
      else drawer.appendChild(host);
    } else {
      drawer.insertBefore(host, drawer.firstChild);
    }
    return host;
  }

  function ensureDrawerNav() {
    /* Prefer the live (portaled) drawer — never the theme ref stub. */
    var drawer = findLiveMenuDrawer();
    if (!drawer || drawer.getAttribute("data-sa-drawer-stub") === "1") return null;

    /* Storefront: keep liquid .sa-drawer-nav (emoji icons + WhatsApp footer).
       Plain #sa-fixed-drawer is challenge/password only. */
    if (!SA_SYSTEM && hasRichThemeDrawer(drawer)) {
      restoreRichThemeDrawer(drawer);
      return null;
    }

    var hostDrawer = ensureDrawerHost(drawer);

    /* Challenge/password: REMOVE theme lists then mount SelfAbout ITEMS.
       Insert-alongside kept failing — theme Home/Collections/About/Contact won. */
    if (SA_SYSTEM) {
      try {
        var stale = hostDrawer.querySelectorAll(
          "ul:not(#sa-fixed-drawer), details, .menu-list, .list-menu, .menu-drawer__menu",
        );
        for (var si = 0; si < stale.length; si++) {
          var sn = stale[si];
          if (!sn || sn.id === "sa-fixed-drawer") continue;
          if (sn.closest && sn.closest("#sa-fixed-drawer")) continue;
          try {
            sn.remove();
          } catch (_rm) {
            sn.setAttribute("hidden", "");
            sn.style.setProperty("display", "none", "important");
          }
        }
      } catch (_st) {}
    }

    var drawerNav = document.getElementById("sa-fixed-drawer");
    if (drawerNav && !drawer.contains(drawerNav)) {
      try {
        if (drawerNav.parentNode) drawerNav.parentNode.removeChild(drawerNav);
      } catch (_rm2) {}
      drawerNav = null;
    }
    if (!drawerNav) {
      try {
        drawerNav = build("sa-fixed-drawer", true);
        hostDrawer.insertBefore(drawerNav, hostDrawer.firstChild);
      } catch (_ins) {
        try {
          drawerNav = build("sa-fixed-drawer", true);
          drawer.insertBefore(drawerNav, drawer.firstChild);
        } catch (_ins2) {
          return null;
        }
      }
    } else {
      if (drawerNav.parentNode !== hostDrawer) {
        try {
          hostDrawer.insertBefore(drawerNav, hostDrawer.firstChild);
        } catch (_mv) {}
      }
      /* Prefer patch — always fillNav wiped Browse Collections on challenge */
      syncNavItems(drawerNav);
    }

    drawerNav.removeAttribute("hidden");
    drawerNav.style.setProperty("display", "flex", "important");
    drawerNav.style.setProperty("flex-direction", "column", "important");
    drawerNav.style.setProperty("visibility", "visible", "important");
    drawerNav.style.setProperty("opacity", "1", "important");
    drawerNav.style.setProperty("height", "auto", "important");
    drawerNav.style.setProperty("overflow", "visible", "important");
    drawerNav.style.setProperty("margin", "0.35rem 0.85rem 1.25rem", "important");
    drawerNav.style.setProperty("padding", "0", "important");
    drawerNav.style.setProperty("gap", "0.15rem", "important");
    drawerNav.style.setProperty("list-style", "none", "important");

    var links = drawerNav.querySelectorAll(":scope > li > a[data-sa-nav-key]");
    if (links.length < ITEMS.length) {
      fillNav(drawerNav);
      links = drawerNav.querySelectorAll(":scope > li > a[data-sa-nav-key]");
    }
    for (var li = 0; li < links.length; li++) {
      var a = links[li];
      a.style.setProperty("display", "block", "important");
      a.style.setProperty("visibility", "visible", "important");
      a.style.setProperty("opacity", "1", "important");
      /* Never lock color inline — blocks .selfabout-nav-active green + premium CSS */
      a.style.removeProperty("color");
      a.style.removeProperty("-webkit-text-fill-color");
      a.style.removeProperty("background");
      a.style.removeProperty("font");
      a.style.setProperty("padding", "0.72rem 0.9rem", "important");
      a.style.setProperty("border-radius", "12px", "important");
      a.style.setProperty("font-size", "1.12rem", "important");
      a.style.setProperty("font-weight", "500", "important");
      a.style.setProperty("text-decoration", "none", "important");
      if (a.parentNode) {
        a.parentNode.style.setProperty("display", "block", "important");
        a.parentNode.style.setProperty("list-style", "none", "important");
      }
    }

    /* Verify required keys — rewrite theme leftovers if Shop/Bundles still absent */
    var needShop = !drawerNav.querySelector(':scope > li > a[data-sa-nav-key="shop"]');
    var needBundles = !drawerNav.querySelector(':scope > li > a[data-sa-nav-key="bundles"]');
    if (needShop || needBundles) fillNav(drawerNav);

    if (drawerNav.querySelectorAll(":scope > li > a[data-sa-nav-key]").length >= 4) {
      hideThemeDrawerExtras(drawer);
    }
    paintActive(drawerNav);
    try {
      ensureDrawerCollections(drawerNav, { force: !!SA_SYSTEM });
    } catch (_cols) {}
    /* Hard require Browse Collections on challenge — theme fallback used to omit it */
    if (SA_SYSTEM && !drawerNav.querySelector(".sa-drawer-cols")) {
      try {
        ensureDrawerCollections(drawerNav, { force: true });
      } catch (_cols2) {}
    }
    return drawerNav;
  }

  var __saSystemDrawerWatch = null;
  function watchSystemDrawerRemount(drawer) {
    if (!SA_SYSTEM || !drawer || typeof MutationObserver === "undefined") return;
    if (__saSystemDrawerWatch) {
      try {
        __saSystemDrawerWatch.disconnect();
      } catch (_d) {}
    }
    var scheduled = false;
    function rerun() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        try {
          ensureDrawerNav();
        } catch (_e) {}
      });
    }
    __saSystemDrawerWatch = new MutationObserver(function () {
      var nav = document.getElementById("sa-fixed-drawer");
      var shopOk = !!(nav && nav.querySelector('a[data-sa-nav-key="shop"]'));
      var bundlesOk = !!(nav && nav.querySelector('a[data-sa-nav-key="bundles"]'));
      var colsOk = !!(nav && nav.querySelector(".sa-drawer-cols"));
      if (!nav || !drawer.contains(nav) || !shopOk || !bundlesOk || !colsOk) rerun();
      else hideThemeDrawerExtras(drawer);
    });
    try {
      __saSystemDrawerWatch.observe(drawer, { childList: true, subtree: true });
    } catch (_o) {}
  }

  function hardenSystemChrome() {
    if (!SA_SYSTEM) return;
    try {
      saEarlyPolishIcons();
    } catch (_i) {}
    try {
      place();
    } catch (_p) {}

    /* Challenge: kill predictive-search so missing empty-section does not crash UI */
    if (!window.__saChallengeSearchKilled) {
      window.__saChallengeSearchKilled = 1;
      try {
        document
          .querySelectorAll(
            "predictive-search-component, .predictive-search, dialog.search-modal, #search-modal, search-modal, .search-modal",
          )
          .forEach(function (el) {
            try {
              el.remove();
            } catch (_rm) {
              el.style.setProperty("display", "none", "important");
              el.style.setProperty("pointer-events", "none", "important");
            }
          });
      } catch (_sk) {}
    }

    function softClearChallengeBackdrops() {
      /* One-shot / on demand: mute ghost backdrops only. Never strip details[open]
         or run on an interval — that raced hamburger open on challenge. */
      if (window.__saDrawerWantOpen || __saDrawerWantOpen) return;
      try {
        document.documentElement.classList.remove("sa-menu-open");
        var backdrops = document.querySelectorAll(".menu-drawer__backdrop");
        for (var bi = 0; bi < backdrops.length; bi++) {
          var bd = backdrops[bi];
          if (!bd) continue;
          bd.style.setProperty("pointer-events", "none", "important");
          bd.style.setProperty("opacity", "1", "important");
          bd.style.setProperty("visibility", "hidden", "important");
        }
        var bn = document.getElementById("sa-bottom-nav");
        if (bn) {
          bn.style.setProperty("display", "none", "important");
          bn.style.setProperty("pointer-events", "none", "important");
        }
      } catch (_purge) {}
    }

    softClearChallengeBackdrops();

    var drawerNav = null;
    try {
      drawerNav = ensureDrawerNav();
    } catch (_d) {}
    var drawer = findLiveMenuDrawer();
    if (drawer) {
      hideThemeDrawerExtras(drawer);
      watchSystemDrawerRemount(drawer);
    }
    if (!window.__saChallengeCaptchaGuard) {
      window.__saChallengeCaptchaGuard = 1;
      document.addEventListener(
        "pointerdown",
        function (ev) {
          if (!SA_SYSTEM) return;
          var t = ev.target;
          if (!t || !t.closest) return;
          if (
            t.closest(
              "summary.header__icon--menu, .header__icon--menu, .menu-drawer, .menu-drawer__backdrop",
            )
          ) {
            return;
          }
          if (
            t.closest(
              ".shopify-challenge__container, .h-captcha, #MainContent form, #MainContent",
            )
          ) {
            if (window.__saDrawerWantOpen) {
              var d = document.querySelector("details.menu-drawer-container");
              if (d && typeof saSmoothClose === "function") saSmoothClose(d, "captcha-guard");
            } else {
              softClearChallengeBackdrops();
            }
          }
        },
        true,
      );
    }
    return drawerNav;
  }

  function navIsPlacedInHeader(nav) {
    if (!nav || !nav.isConnected) return false;
    var header = document.querySelector("#header-component, header-component");
    return !!(header && header.contains(nav));
  }

  function pinBrandLogo(header) {
    var scope =
      header ||
      document.querySelector("#header-component, header-component") ||
      document;
    var meta = document.querySelector('meta[name="selfabout-brand-logo"]');
    var brandLogo =
      (window.__SA_BRAND && window.__SA_BRAND.logo) ||
      (meta && meta.getAttribute("content")) ||
      "";
    if (brandLogo && (!window.__SA_BRAND || !window.__SA_BRAND.logo)) {
      window.__SA_BRAND = Object.assign(window.__SA_BRAND || {}, {
        logo: brandLogo,
        logoAlt:
          (window.__SA_BRAND && window.__SA_BRAND.logoAlt) ||
          (document.querySelector('meta[name="selfabout-shop-name"]') &&
            document
              .querySelector('meta[name="selfabout-shop-name"]')
              .getAttribute("content")) ||
          "SelfAbout",
      });
    }
    try {
      var logoNodes = scope.querySelectorAll(
        ".header-logo, .header-logo__image-container, [data-testid='header-logo'], a.header__heading-link, .sa-brand-logo-host",
      );
      if (!logoNodes.length) return !!brandLogo;
      var pinned = 0;
      for (var li = 0; li < logoNodes.length; li++) {
        var node = logoNodes[li];
        var existing =
          node.querySelector("img.sa-brand-logo, img.header-logo__image") ||
          node.querySelector("img");
        if (existing) {
          existing.classList.add("sa-brand-logo");
          if (brandLogo && !/cdn\.shopify|shopify\.com|\.shopifycdn\./i.test(existing.src || "")) {
            /* keep theme SSR src; only fill empty broken src */
            if (!existing.getAttribute("src")) existing.src = brandLogo;
          }
          node.classList.add("sa-brand-logo-host");
          /* Strip leftover text nodes that flash "SelfAbout" */
          for (var tn = node.childNodes.length - 1; tn >= 0; tn--) {
            if (node.childNodes[tn].nodeType === 3) {
              var tv = (node.childNodes[tn].nodeValue || "").trim();
              if (tv) node.removeChild(node.childNodes[tn]);
            }
          }
          pinned++;
          continue;
        }
        if (!brandLogo) continue;
        var img = document.createElement("img");
        img.className = "sa-brand-logo";
        img.src = brandLogo;
        img.alt = (window.__SA_BRAND && window.__SA_BRAND.logoAlt) || "SelfAbout";
        img.decoding = "async";
        img.setAttribute("width", "120");
        img.setAttribute("height", "32");
        img.setAttribute("fetchpriority", "high");
        node.replaceChildren(img);
        node.classList.add("sa-brand-logo-host");
        pinned++;
      }
      if (pinned || brandLogo) {
        document.documentElement.classList.add("sa-has-brand-logo");
        window.__saBrandPinned = 1;
        return pinned > 0;
      }
    } catch (_b) {}
    return false;
  }

  function hideDesktopNavForMobile() {
    var nav = document.getElementById("sa-fixed-nav");
    if (!nav) return;
    nav.style.removeProperty("display");
    nav.style.removeProperty("opacity");
    nav.style.removeProperty("visibility");
    nav.setAttribute("data-sa-mobile-hide", "1");
    var header =
      document.querySelector("#header-component") ||
      document.querySelector("header-component");
    if (header) header.classList.remove("sa-desktop-nav");
  }

  function showDesktopNavStyles(nav) {
    if (!nav) return;
    nav.removeAttribute("data-sa-mobile-hide");
    /* Prefer class/CSS over inline so breakpoint media can hide on resize */
    nav.style.removeProperty("display");
    nav.style.setProperty("opacity", "1", "important");
    nav.style.setProperty("visibility", "visible", "important");
  }


  function hideThemeDesktopMenu(header) {
    var root =
      header ||
      document.querySelector("#header-component, header-component") ||
      document;
    var nodes = root.querySelectorAll(
      "header-menu, overflow-list, .header__inline-menu, nav.header__inline-menu, .menu-list, .overflow-menu, [slot='overflow']",
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest && el.closest("#sa-fixed-nav, #sa-fixed-drawer, .menu-drawer")) continue;
      try {
        el.setAttribute("data-sa-theme-menu-hidden", "1");
        el.style.setProperty("display", "none", "important");
        el.style.setProperty("visibility", "hidden", "important");
        el.style.setProperty("pointer-events", "none", "important");
        /* Remove from center column so it cannot flash / shift #sa-fixed-nav */
        var parent = el.parentNode;
        if (
          parent &&
          parent.classList &&
          (parent.classList.contains("header__column--center") ||
            parent.getAttribute("data-testid") === "header-top-center")
        ) {
          parent.removeChild(el);
        }
      } catch (_h) {}
    }
  }

  function place() {
    pinBrandLogo();
    if (window.matchMedia && window.matchMedia("(max-width:899px)").matches) {
      document.documentElement.classList.add("sa-header-ready", "sa-nav-placed");
      hideDesktopNavForMobile();
      ensureDrawerNav();
      pinBrandLogo();
      try {
        var g =
          document.getElementById("header-group") ||
          document.querySelector(".shopify-section-group-header-group");
        if (g) g.style.setProperty("pointer-events", "auto", "important");
        var hdr =
          document.querySelector("#header-component") ||
          document.querySelector("header-component");
        if (hdr) {
          hdr.style.setProperty("pointer-events", "auto", "important");
          pinHeaderActions(hdr);
          var acts = hdr.querySelectorAll(
            "header-actions, .header-actions, header-drawer, .menu-drawer-container, summary.header__icon--menu, search-button, cart-icon, account-button, .header__icon--search, .header__icon--cart, .header__icon--account",
          );
          for (var ai = 0; ai < acts.length; ai++) {
            acts[ai].style.setProperty("pointer-events", "auto", "important");
            acts[ai].style.setProperty("cursor", "pointer", "important");
          }
        }
      } catch (_pe) {}
      return true;
    }

    var header =
      document.querySelector("#header-component") ||
      document.querySelector("header-component");
    if (!header) {
      return false;
    }

    var row =
      header.querySelector(".header__row--top, .header__row") ||
      header.querySelector("[class*='header__row']") ||
      header;
    var center =
      header.querySelector(".header__columns .header__column--center") ||
      header.querySelector(".header__column--center") ||
      header.querySelector("[data-testid='header-top-center']") ||
      header.querySelector(".header__columns") ||
      row;
    var host = center;

    var extras = document.querySelectorAll("#sa-fixed-nav, .sa-fixed-nav:not(.sa-fixed-nav--drawer)");
    /* Prefer top-center SSR nav; drop bottom-row / JS clones */
    var preferred = dedupeFixedNav();
    for (var ei = 0; ei < extras.length; ei++) {
      if (extras[ei].id === "sa-fixed-drawer") continue;
      if (extras[ei].querySelector('a[data-sa-nav-key="collections"]')) {
        var tid =
          extras[ei].closest &&
          extras[ei].closest('[data-testid="header-top-center"]');
        if (tid || !preferred) preferred = extras[ei];
        if (tid) break;
      }
    }
    preferred = dedupeFixedNav() || preferred;

    var nav =
      preferred ||
      document.getElementById("sa-fixed-nav") ||
      pendingNav ||
      ensureNav();
    if (!nav) nav = build("sa-fixed-nav", false);

    /* SSR already in top center — skip DOM moves that nudge placement */
    if (
      nav.getAttribute("data-sa-ssr") === "1" &&
      nav.parentNode === host &&
      nav.children.length === ITEMS.length
    ) {
      showDesktopNavStyles(nav);
    syncNavItems(nav);
      paintActive(nav);
      pinBrandLogo(header);
      pinHeaderActions(header);
      hideThemeDesktopMenu(header);
      header.classList.add("sa-desktop-nav");
      document.documentElement.classList.add("sa-header-ready", "sa-nav-placed");
      finishNav(nav);
      return true;
    }

    syncNavItems(nav);
    showDesktopNavStyles(nav);

    /* Always re-pin actions — theme can shove search next to Contact after paint */
    unlockFixedChrome();
    pinHeaderActions(header);
    pinBrandLogo(header);
    hideThemeDesktopMenu(header);

    if (nav.parentNode === host && document.documentElement.classList.contains("sa-nav-placed")) {
      paintActive(nav);
      ensureDrawerNav();
      ensureContentScroll();
      return true;
    }

    row.style.position = "relative";
    if (nav.parentNode !== host) {
      showDesktopNavStyles(nav);
      host.appendChild(nav);
      pendingNav = null;
    }
    header.classList.add("sa-desktop-nav");
    ensureDrawerNav();

    pinNavKey();
    paintActive(nav);
    pinBrandLogo(header);
    ensureDrawerNav();

    finishNav(nav);
    return true;
  }

  window.__saPlaceNav = place;

  var placing = false;
  function recoverNav() {
    if (placing) return;
    placing = true;
    try {
      var nav = document.getElementById("sa-fixed-nav");
      var header =
        document.querySelector("#header-component") ||
        document.querySelector("header-component");
      var center = header
        ? header.querySelector(".header__columns .header__column--center, .header__column--center, [data-testid='header-top-center']") ||
          header.querySelector(".header__columns") ||
          header.querySelector(".header__row, .header__row--top, [class*='header__row']") ||
          header
        : null;
      if (!nav || !center || !center.contains(nav)) {
        unlockFixedChrome();
        place();
      } else {
        unlockFixedChrome();
        pinHeaderActions(header);
        syncNavItems(nav);
        paintActive(nav);
        if (!document.documentElement.classList.contains("sa-nav-placed")) finishNav(nav);
      }
    } finally {
      placing = false;
    }
  }

  pinNavKey();
  unlockFixedChrome();
  try {
    if (window.matchMedia && window.matchMedia("(max-width:899px)").matches) {
      syncMobileChromePad();
    } else {
      document.documentElement.style.setProperty("--sa-chrome-h", "72px");
    }
  } catch (_ch) {
    document.documentElement.style.setProperty("--sa-chrome-h", "56px");
  }
  /* Re-assert after Horizon header.js applies [sticky] → display:contents */
  function resyncMobileChromeSoon() {
    try {
      syncMobileChromePad();
    } catch (_r) {}
  }
  if (typeof requestAnimationFrame === "function") {
    requestAnimationFrame(function () {
      resyncMobileChromeSoon();
      requestAnimationFrame(resyncMobileChromeSoon);
    });
  }
  setTimeout(resyncMobileChromeSoon, 0);
  setTimeout(resyncMobileChromeSoon, 250);
  setTimeout(resyncMobileChromeSoon, 1000);
  if (document.readyState === "complete") {
    resyncMobileChromeSoon();
  } else {
    window.addEventListener("load", resyncMobileChromeSoon);
  }
  window.addEventListener("resize", function () {
    if (window.matchMedia && window.matchMedia("(max-width:899px)").matches) {
      resyncMobileChromeSoon();
    }
  });
  /* Header ready only — paint-ready waits for armPaintReady stylesheet settle */
  document.documentElement.classList.add("sa-header-ready");
  /* Reveal MainContent immediately — waiting on stylesheet settle blanked the store pages */
  document.documentElement.classList.add("sa-paint-ready");


  var BUNDLES_HREF = "/collections/all?sa_type=bundle";
  if (/\/collections\/(bundles|everyday-carry)$/i.test((location.pathname || "").replace(/\/$/, "") || "/")) {
    location.replace(BUNDLES_HREF);
    return;
  }

  function rewriteBundlesHrefs(root) {
    var scope = root || document;
    var links = scope.querySelectorAll("a[href]");
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute("href") || "";
      var label = (a.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
      var isDeadCollection = /\/collections\/(bundles|everyday-carry)(\/|$|\?|#)/i.test(href);
      var isPlainAll =
        /\/collections\/all\/?$/i.test((href.split("?")[0] || "")) &&
        !/sa_type=(?:bundle|kit)/i.test(href);
      var looksLikeBundlesCta =
        /^(bundles|shop bundles|browse bundles|view all bundles|view bundles)$/i.test(label) ||
        (/bundle/i.test(label) && /^(shop|browse|view)/i.test(label));
      if (isDeadCollection || (isPlainAll && looksLikeBundlesCta)) {
        a.setAttribute("href", BUNDLES_HREF);
      }
    }
  }

  /* Prefetch nav in memory so first place() is append-only (no build flash) */
  try {
    ensureNav();
    pinBrandLogo();
    rewriteBundlesHrefs(document);
    place();
    ensureContentScroll();
    pinBrandLogo();
  } catch (mountErr) {
    try {
      document.documentElement.classList.add("sa-paint-ready", "sa-header-ready");
    } catch (_pe) {}
  }

  /* Win races with theme nav helpers that remint aria-current / data-sa-nav */
  [120, 400, 900].forEach(function (ms) {
    window.setTimeout(function () {
      pinNavKey();
      rewriteBundlesHrefs(document);
      /* Hard lock: Bundles PLP must not lose to Shop path-match races. */
      if (/(?:^|[?&])sa_type=(?:bundle|kit)(?:&|$)/i.test(location.search || "")) {
        document.documentElement.setAttribute("data-sa-nav", "bundles");
      }
      var navNode = document.getElementById("sa-fixed-nav");
      if (navNode) paintActive(navNode);
      var drawerNode = document.getElementById("sa-fixed-drawer");
      if (drawerNode) paintActive(drawerNode);
    }, ms);
  });

  var recoverQueued = false;
  function queueRecover() {
    /* Disabled: document-wide MO + ensureContentScroll fought Horizon and froze the tab
       ("Page Unresponsive"). Boot place()/DOMContentLoaded still mounts nav once. */
    return;
  }

  /* Do NOT observe document.documentElement subtree — every theme remount re-entered
     recover/ensureContentScroll and locked the main thread. */
  var mo = null;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      try {
        place();
        recoverNav();
      } catch (_d) {}
    });
  } else {
    try {
      place();
      recoverNav();
    } catch (_d2) {}
  }

  window.addEventListener("pageshow", function () {
    var legacy = document.getElementById("sa-scroll-shell");
    if (legacy && legacy.parentNode) {
      var p = legacy.parentNode;
      while (legacy.firstChild) p.insertBefore(legacy.firstChild, legacy);
      legacy.remove();
    }
    place();
    ensureContentScroll();
    hardenScrollShell();
    pinNavKey();
    var nav = document.getElementById("sa-fixed-nav");
    if (nav) paintActive(nav);
    recoverNav();
    hardenSystemChrome();
  });

  var hardenResizeTimer = 0;
  var lastDesktop =
    !window.matchMedia || !window.matchMedia("(max-width:899px)").matches;
  var lastInnerW = window.innerWidth || 0;

  function forceHeaderIconsVisible(header) {
    if (!header) return;
    var nodes = header.querySelectorAll(
      ".header__column--right, header-actions, .header-actions, .header__icons, search-button, .header__icon--search, .header-search, account-button, .account-button, .header__icon--account, cart-icon, .header__icon--cart, .header-actions__action, .sa-header-action-btn, search-button button, .action__cart-btn, a.account-button",
    );
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (!n || !n.style) continue;
      n.style.setProperty("opacity", "1", "important");
      n.style.setProperty("visibility", "visible", "important");
      n.style.removeProperty("pointer-events");
      if (n.matches && n.matches("header-actions, .header-actions, .header__icons, search-button, account-button, .account-button, cart-icon, .header-actions__action, .sa-header-action-btn, search-button button, .action__cart-btn")) {
        n.style.setProperty("display", "inline-flex", "important");
      }
      if (n.classList && n.classList.contains("header__column--right")) {
        n.style.setProperty("display", "flex", "important");
      }
    }
  }

  function syncHeaderBreakpoint() {
    var desktop =
      !window.matchMedia || !window.matchMedia("(max-width:899px)").matches;
    var header =
      document.querySelector("#header-component") ||
      document.querySelector("header-component");

    /* Theme critical chrome (logo park / icon rail) — keep in sync with viewport */
    try {
      if (typeof window.saThemeMobileChrome === "function") {
        window.saThemeMobileChrome();
      } else if (desktop && typeof window.saThemeDesktopChromeRestore === "function") {
        window.saThemeDesktopChromeRestore();
      }
    } catch (_themeChrome) {}

    if (!desktop) {
      hideDesktopNavForMobile();
      document.documentElement.classList.remove("sa-desktop-nav");
      if (header) header.classList.remove("sa-desktop-nav");
    }

    place();
    ensureContentScroll();
    recoverNav();
    hardenScrollShell({ forceReset: true });
    pinBrandLogo(header);

    if (header) {
      unlockFixedChrome();
      pinHeaderActions(header);
      forceHeaderIconsVisible(header);
      if (desktop) {
        hideThemeDesktopMenu(header);
        header.classList.add("sa-desktop-nav");
        document.documentElement.classList.add("sa-desktop-nav");
        var nav = document.getElementById("sa-fixed-nav");
        if (nav) showDesktopNavStyles(nav);
      }
    }

    /* Drop sticky mobile logo when returning to desktop (DevTools resize) */
    try {
      var pin = document.getElementById("sa-mobile-logo");
      if (desktop && pin) {
        [
          "display",
          "position",
          "left",
          "top",
          "right",
          "bottom",
          "transform",
          "z-index",
          "opacity",
          "visibility",
          "width",
          "height",
          "max-width",
          "max-height",
          "pointer-events",
          "margin",
          "padding",
        ].forEach(function (prop) {
          pin.style.removeProperty(prop);
        });
        pin.style.setProperty("display", "none", "important");
      }
      if (desktop && header) {
        header
          .querySelectorAll(
            ".header-logo, .sa-brand-logo-host, a.header__heading-link, [data-testid='header-logo']",
          )
          .forEach(function (node) {
            if (node.id === "sa-mobile-logo") return;
            [
              "opacity",
              "visibility",
              "pointer-events",
              "width",
              "height",
              "overflow",
              "max-width",
              "max-height",
              "position",
              "left",
              "top",
              "transform",
              "z-index",
              "margin",
              "padding",
              "min-width",
              "min-height",
            ].forEach(function (prop) {
              node.style.removeProperty(prop);
            });
          });
        forceHeaderIconsVisible(header);
        pinHeaderActions(header);
      }
    } catch (_logoResize) {}

    /* Close mobile drawer if we landed on desktop */
    if (desktop) {
      try {
        var details = document.querySelector("details.menu-drawer-container");
        if (
          details &&
          (__saDrawerWantOpen ||
            document.documentElement.classList.contains("sa-menu-open") ||
            details.classList.contains("menu-open") ||
            details.hasAttribute("open"))
        ) {
          saSmoothClose(details, "responsive-desktop");
        }
      } catch (_close) {}
      saRestoreHeaderChrome();
      if (header) {
        forceHeaderIconsVisible(header);
        pinHeaderActions(header);
      }
    }
  }

  function onBreakpointChange() {
    var desktop =
      !window.matchMedia || !window.matchMedia("(max-width:899px)").matches;
    var w = window.innerWidth || 0;
    /* Ignore micro DevTools noise while same breakpoint */
    if (desktop === lastDesktop) {
      if (Math.abs(w - lastInnerW) < 8) return;
      lastInnerW = w;
      /* Still re-pin icons/rail on width-only resize within desktop/mobile */
      withDomLock(function () {
        var header =
          document.querySelector("#header-component") ||
          document.querySelector("header-component");
        if (header) {
          pinHeaderActions(header);
          forceHeaderIconsVisible(header);
        }
        hardenScrollShell({ forceReset: true });
      });
      return;
    }
    lastDesktop = desktop;
    lastInnerW = w;
    withDomLock(syncHeaderBreakpoint);
  }
  window.addEventListener("resize", function () {
    window.clearTimeout(hardenResizeTimer);
    hardenResizeTimer = window.setTimeout(onBreakpointChange, 120);
  });
  if (window.matchMedia) {
    try {
      var mql = window.matchMedia("(max-width:899px)");
      if (mql.addEventListener) mql.addEventListener("change", onBreakpointChange);
      else if (mql.addListener) mql.addListener(onBreakpointChange);
    } catch (_mql) {}
  }
  window.saSyncHeaderBreakpoint = syncHeaderBreakpoint;
  /* PDP media / sticky bar can change header height after first paint */
  window.setTimeout(function () {
    hardenScrollShell();
  }, 600);
  window.setTimeout(function () {
    hardenScrollShell();
  }, 1600);

  setTimeout(function () {
    place();
    ensureContentScroll();
    recoverNav();
    if (!document.documentElement.classList.contains("sa-nav-placed")) {
      finishNav(document.getElementById("sa-fixed-nav") || pendingNav);
    }
  }, 400);

  /* Collections sometimes drops after Horizon header reflow — re-assert for a few seconds */
  (function guardCollections() {
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      var nav = document.getElementById("sa-fixed-nav");
      if (nav && !nav.querySelector(':scope > li > a[data-sa-nav-key="collections"]')) {
        syncNavItems(nav);
        paintActive(nav);
      }
      if (tries >= 12) window.clearInterval(timer);
    }, 250);
  })();

  /* FOUC: reveal content only after stylesheets settle (header/announcement stay visible) */
  (function armPaintReady() {
    if (SA_SYSTEM) {
      function placeSystem() {
        try {
          hardenSystemChrome();
        } catch (_p) {}
        var drawerOk = !!document.getElementById("sa-fixed-drawer");
        var desktopNav = document.getElementById("sa-fixed-nav");
        if (drawerOk || desktopNav) {
          document.documentElement.classList.add(
            "sa-paint-ready",
            "sa-nav-placed",
            "sa-header-ready",
          );
          return true;
        }
        document.documentElement.classList.add("sa-paint-ready", "sa-header-ready");
        return false;
      }
      placeSystem();
      var tries = 0;
      var timer = window.setInterval(function () {
        tries += 1;
        if (placeSystem() || tries >= 48) window.clearInterval(timer);
      }, 100);
      /* Extra passes — challenge HTML can remount header-drawer after first paint */
      [300, 700, 1400, 2200].forEach(function (ms) {
        window.setTimeout(hardenSystemChrome, ms);
      });
      return;
    }
    var done = false;
    var settleGen = 0;
    var quiet;
    var cssMo;
    function finish() {
      if (done) return;
      done = true;
      clearTimeout(quiet);
      try {
        if (cssMo) cssMo.disconnect();
      } catch (e) {}
      /* Shell + reparent escaped RV/product BEFORE reveal — otherwise RV flashes under header */
      try {
        place();
      } catch (_p) {}
      ensureContentScroll();
      hardenScrollShell({ forceReset: true });
      requestAnimationFrame(function () {
        ensureContentScroll();
      document.documentElement.classList.add("sa-paint-ready");
        hardenScrollShell();
      });
    }
    function waitLink(link, next) {
      if (!link) return next();
      try {
        if (link.sheet) return next();
      } catch (e) {}
      var once = function () {
        link.removeEventListener("load", once);
        link.removeEventListener("error", once);
        next();
      };
      link.addEventListener("load", once);
      link.addEventListener("error", once);
    }
    function settle() {
      if (done) return;
      var my = ++settleGen;
      var links = document.querySelectorAll('link[rel="stylesheet"]');
      var left = links.length ? links.length : 1;
      function oneDone() {
        if (done || my !== settleGen) return;
        left -= 1;
        if (left > 0) return;
        /* Quiet window so late section CSS can still register before reveal */
        clearTimeout(quiet);
        quiet = setTimeout(function () {
          if (done || my !== settleGen) return;
          requestAnimationFrame(function () {
            requestAnimationFrame(finish);
          });
        }, 140);
      }
      if (!links.length) {
        oneDone();
        return;
      }
      Array.prototype.forEach.call(links, function (link) {
        waitLink(link, oneDone);
      });
    }
    settle();
    cssMo = new MutationObserver(function (records) {
      if (done) return;
      var relevant = false;
      for (var i = 0; i < records.length; i++) {
        var nodes = records[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (
            n.nodeType === 1 &&
            (n.tagName === "LINK" ||
              n.tagName === "STYLE" ||
              (n.querySelector && n.querySelector("link[rel='stylesheet'],style")))
          ) {
            relevant = true;
            break;
          }
        }
        if (relevant) break;
      }
      if (!relevant) return;
      settle();
    });
    cssMo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(finish, 1600);
  })();

  /* Track mobile menu open for float mute + drawer choreography hooks */
  var __saMenuWasOpen = false;
  var __saDrawerContentToken = 0;
  function saScheduleIdle(fn, timeoutMs) {
    if (typeof window.requestIdleCallback === "function") {
      return window.requestIdleCallback(fn, { timeout: timeoutMs || 180 });
    }
    return window.setTimeout(fn, 0);
  }
  function saPrefetchDrawerCollections() {
    try {
      fetchLatestCollections(COLLECTIONS_PANEL_LIMIT, function () {}, { force: false });
    } catch (_pf) {}
  }
  /* Mount nav + collections AFTER the slide ends — mid-slide DOM thrash = jitter */
  function saHydrateDrawerContent(opts) {
    opts = opts || {};
    var token = ++__saDrawerContentToken;
    function run() {
      if (token !== __saDrawerContentToken) return;
      if (!__saDrawerWantOpen && !opts.force) return;
      try {
        ensureDrawerNav();
      } catch (_e) {}
      if (opts.harden) {
        try {
          hardenSystemChrome();
        } catch (_h) {}
      }
      try {
        var drawerNav = document.getElementById("sa-fixed-drawer");
        if (drawerNav) ensureDrawerCollections(drawerNav, { force: !!opts.forceCollections });
      } catch (_cols) {}
    }
    if (opts.sync) {
      run();
      return;
    }
    var delay = typeof opts.delayMs === "number" ? opts.delayMs : 0;
    if (delay > 0) {
      window.setTimeout(function () {
        saScheduleIdle(run, opts.idleTimeout || 200);
      }, delay);
      return;
    }
    saScheduleIdle(run, opts.idleTimeout || 200);
  }
  function saBeginDrawerAnim(ms) {
    document.documentElement.classList.add("sa-drawer-animating");
    window.clearTimeout(window.__saDrawerAnimTimer);
    window.__saDrawerAnimTimer = window.setTimeout(function () {
      document.documentElement.classList.remove("sa-drawer-animating");
    }, ms || 320);
  }
  /* Portal + geometry once; subsequent toggles are transform-only.
     Keep this LIGHT — never hydrate nav on the gesture path (blocks open). */
  function saWarmDrawerShell(details) {
    /* Never thrash open/opening drawer — clearMotion wiped inline transform mid-slide */
    if (__saDrawerWantOpen || __saDrawerOpening) return null;
    if (!details) {
      details = document.querySelector("details.menu-drawer-container");
    }
    if (!details) return null;
    var drawer = saPortalDrawer(details);
    var backdrop = saBackdropEl(details);
    if (drawer || backdrop) {
      saPaintDrawerLayout(drawer, backdrop);
      saClearMotionInline(drawer);
      saClearMotionInline(backdrop);
    }
    return drawer;
  }
  function saHoldOpenAttrs(details, summary, ms) {
    /* Coarse ownership pulse — every-frame rAF contested the compositor during slide */
    var until = Date.now() + (ms || 450);
    function tick() {
      if (!__saDrawerWantOpen) return;
      if (
        !details.hasAttribute("open") ||
        !details.classList.contains("menu-open") ||
        !document.documentElement.classList.contains("sa-menu-open")
      ) {
        saAssertOpenAttrs(details, summary);
      }
      if (__saDrawerWantOpen) saSuppressGhostDrawers();
      if (Date.now() < until) {
        window.setTimeout(tick, 48);
      }
    }
    window.setTimeout(tick, 32);
  }

  function saClearMotionInline(el) {
    if (!el || !el.style) return;
    [
      "transform",
      "translate",
      "transition",
      "visibility",
      "opacity",
    ].forEach(function (p) {
      el.style.removeProperty(p);
    });
  }

  function saPaintDrawerLayout(drawer, backdrop) {
    /* Geometry only — never set transform/visibility (CSS class owns the slide) */
    if (drawer) {
      drawer.style.setProperty("display", "flex", "important");
      drawer.style.setProperty("flex-direction", "column", "important");
      drawer.style.setProperty("position", "fixed", "important");
      drawer.style.setProperty("inset", "0 auto 0 0", "important");
      drawer.style.setProperty("top", "0", "important");
      drawer.style.setProperty("left", "0", "important");
      drawer.style.setProperty("right", "auto", "important");
      drawer.style.setProperty("width", "min(82vw, 20rem)", "important");
      drawer.style.setProperty("max-width", "min(82vw, 20rem)", "important");
      drawer.style.setProperty("height", "100dvh", "important");
      drawer.style.setProperty("max-height", "100dvh", "important");
      drawer.style.setProperty("z-index", "2147483646", "important");
      drawer.style.setProperty("background", "#fff", "important");
      drawer.style.setProperty("overflow", "hidden", "important");
      drawer.style.setProperty("margin", "0", "important");
      drawer.style.setProperty("backface-visibility", "hidden", "important");
      drawer.style.setProperty("-webkit-backface-visibility", "hidden", "important");
      drawer.style.setProperty("pointer-events", "none", "important");
      drawer.setAttribute("data-sa-geo", "1");
    }
    if (backdrop) {
      var isOpen =
        !!document.documentElement.classList.contains("sa-menu-open") ||
        !!document.querySelector("details.menu-drawer-container.menu-open");
      backdrop.style.setProperty("display", isOpen ? "block" : "none", "important");
      backdrop.style.setProperty("position", "fixed", "important");
      backdrop.style.setProperty("inset", "0", "important");
      backdrop.style.setProperty("width", "100vw", "important");
      backdrop.style.setProperty("height", "100dvh", "important");
      backdrop.style.setProperty("z-index", "2147483645", "important");
      backdrop.style.setProperty("background", "rgba(15,23,42,.42)", "important");
      backdrop.style.setProperty("margin", "0", "important");
      backdrop.style.setProperty("pointer-events", "none", "important");
      backdrop.setAttribute("data-sa-geo", "1");
    }
  }
  var __saBodyScrollLockY = 0;

  function lockBodyScrollForDrawer() {
    try {
      __saBodyScrollLockY =
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      var html = document.documentElement;
      var body = document.body;
      html.style.setProperty("overflow", "hidden", "important");
      html.style.setProperty("overflow-x", "hidden", "important");
      html.style.setProperty("overflow-y", "hidden", "important");
      html.style.setProperty("overscroll-behavior", "none", "important");
      /* Do NOT set touch-action:none on html/body — on iOS Safari that
         intersects to none for all descendants and kills drawer <a> taps. */
      if (body) {
        body.style.setProperty("overflow", "hidden", "important");
        body.style.setProperty("overflow-x", "hidden", "important");
        body.style.setProperty("overflow-y", "hidden", "important");
        body.style.setProperty("overscroll-behavior", "none", "important");
        /* Freeze scroll position — prevents background rubber-band on iOS */
        body.style.setProperty("position", "fixed", "important");
        body.style.setProperty("top", "-" + __saBodyScrollLockY + "px", "important");
        body.style.setProperty("left", "0", "important");
        body.style.setProperty("right", "0", "important");
        body.style.setProperty("width", "100%", "important");
      }
    } catch (_l) {}
  }

  function unlockBodyScrollForDrawer() {
    try {
      var html = document.documentElement;
      var body = document.body;
      var y = __saBodyScrollLockY || 0;
      html.style.removeProperty("overflow");
      html.style.removeProperty("overscroll-behavior");
      html.style.removeProperty("touch-action");
      /* Restore mobile document-scroll defaults */
      var mobile =
        !!(window.matchMedia && window.matchMedia("(max-width:899px)").matches);
      if (mobile) {
        html.style.setProperty("overflow-x", "hidden", "important");
        html.style.setProperty("overflow-y", "auto", "important");
        html.style.setProperty("height", "auto", "important");
        html.style.removeProperty("max-height");
      } else {
        html.style.setProperty("overflow", "hidden", "important");
      }
      if (body) {
        body.style.removeProperty("overflow");
        body.style.removeProperty("overscroll-behavior");
        body.style.removeProperty("touch-action");
        body.style.removeProperty("position");
        body.style.removeProperty("top");
        body.style.removeProperty("left");
        body.style.removeProperty("right");
        body.style.removeProperty("width");
        if (mobile) {
          body.style.setProperty("overflow-x", "hidden", "important");
          body.style.setProperty("overflow-y", "auto", "important");
          body.style.setProperty("height", "auto", "important");
          body.style.setProperty("max-height", "none", "important");
        }
      }
      if (y) {
        window.scrollTo(0, y);
      }
      __saBodyScrollLockY = 0;
    } catch (_u) {}
  }

  function syncMenuOpenClass() {
    /* Navigating away — keep body locked until unload (no iOS scrollbar flash) */
    if (document.documentElement.classList.contains("sa-drawer-navigating")) return;
    /* Prefer ownership flag — theme/MO can strip .menu-open after portal while
       we still want the portaled panel visible (normal-page hamburger fix). */
    var open =
      !!__saDrawerWantOpen ||
      !!document.querySelector(
        "details.menu-drawer-container.menu-open, details.menu-open.menu-drawer-container",
    );
    var wasOpen = !!document.documentElement.classList.contains("sa-menu-open");
    document.documentElement.classList.toggle("sa-menu-open", open);
    if (open && !wasOpen) {
      lockBodyScrollForDrawer();
    } else if (!open && wasOpen) {
      unlockBodyScrollForDrawer();
    }
    /* Rising edge only — NEVER hydrate mid-slide (defer past open duration) */
    if (open && !__saMenuWasOpen) {
      saHydrateDrawerContent({
        harden: true,
        forceCollections: false,
        delayMs: 300,
        idleTimeout: 220,
      });
    }
    __saMenuWasOpen = open;
  }
  var __saDrawerWantOpen = false;
  var __saDrawerBusy = false;
  var __saDrawerOpening = false; /* true from open start until afterOpen/close */
  var __saDrawerPoseLock = false; /* true while intentionally posing closed for open anim */
  var __saHamIntent = null; /* "open" | "close" — captured at pointerdown */
  var __saHamHandledAt = 0; /* touch: preventDefault kills click — open on pointerdown */
  /* Challenge overlay guard reads this — keep on window for early hardenSystemChrome */
  window.__saDrawerWantOpen = false;

  function saDrawerEl(details) {
    var portaled = document.querySelector(
      "body > .menu-drawer[data-sa-portaled='1']",
    );
    if (portaled) return portaled;
    return details
      ? details.querySelector(
          ":scope > .menu-drawer:not([data-sa-drawer-stub])",
        ) ||
          details.querySelector(".menu-drawer:not([data-sa-drawer-stub])")
      : null;
  }

  function saBackdropEl(details) {
    var portaled = document.querySelector(
      "body > .menu-drawer__backdrop[data-sa-portaled='1']",
    );
    if (portaled) return portaled;
    return details
      ? details.querySelector(
          ":scope > .menu-drawer__backdrop",
        )
      : null;
  }

  /* Theme re-clones panel inside details after portal → two drawers / double close. */
  function saSuppressGhostDrawers() {
    var live = document.querySelector(
      "body > .menu-drawer[data-sa-portaled='1']",
    );
    if (!live) return 0;
    var killed = 0;
    var nodes = document.querySelectorAll(
      ".menu-drawer, menu-drawer.menu-drawer",
    );
    for (var i = 0; i < nodes.length; i++) {
      var d = nodes[i];
      if (!d || d === live) continue;
      if (d.getAttribute("data-sa-drawer-stub") === "1") continue;
      if (d.classList && d.classList.contains("sa-menu-drawer-stub")) continue;
      d.setAttribute("data-sa-ghost-drawer", "1");
      d.style.setProperty("display", "none", "important");
      d.style.setProperty("visibility", "hidden", "important");
      d.style.setProperty("pointer-events", "none", "important");
      d.style.setProperty("opacity", "1", "important");
      d.style.setProperty(
        "transform",
        "translate3d(-100%,0,0)",
        "important",
      );
      killed += 1;
    }
    var liveBd = document.querySelector(
      "body > .menu-drawer__backdrop[data-sa-portaled='1']",
    );
    var bds = document.querySelectorAll(".menu-drawer__backdrop");
    for (var j = 0; j < bds.length; j++) {
      var b = bds[j];
      if (!b || b === liveBd) continue;
      if (b.getAttribute("data-sa-portaled") === "1") continue;
      b.setAttribute("data-sa-ghost-backdrop", "1");
      b.style.setProperty("display", "none", "important");
      b.style.setProperty("visibility", "hidden", "important");
      b.style.setProperty("pointer-events", "none", "important");
      b.style.setProperty("opacity", "1", "important");
      killed += 1;
    }
    return killed;
  }

  function saPortalMarker(el, kind) {
    if (!el || !el.parentNode) return null;
    /* Theme header-drawer requiredRefs includes menuDrawer. Moving the real
       panel to body would throw MissingRefError on MutationObserver — leave a
       hidden stub with the same ref so Component.#updateRefs stays happy.
       Do NOT use class menu-drawer on the stub or ensureDrawerNav /
       querySelector(".menu-drawer") will prefer it and move #sa-fixed-drawer
       into a hidden node (menus look stripped). */
    var mark;
    if (kind === "drawer") {
      mark = document.createElement("div");
      mark.setAttribute("ref", "menuDrawer");
      mark.setAttribute("data-sa-drawer-stub", "1");
      mark.setAttribute("hidden", "");
      mark.setAttribute("aria-hidden", "true");
      mark.className = "sa-menu-drawer-stub";
      mark.style.cssText =
        "display:none!important;visibility:visible!important;pointer-events:none!important;position:absolute!important;width:0!important;height:0!important;overflow:hidden!important;";
      /* Only the stub keeps ref= — duplicate refs confuse Component.updateRefs */
      try {
        el.removeAttribute("ref");
      } catch (_rf) {}
      el.setAttribute("data-sa-portal-kind", "drawer");
    } else {
      mark = document.createComment("sa-" + kind + "-home");
      el.setAttribute("data-sa-portal-kind", kind || "backdrop");
    }
    el.parentNode.insertBefore(mark, el);
    el.__saHomeMark = mark;
    el.setAttribute("data-sa-portaled", "1");
    return mark;
  }

  function saPortalDrawer(details) {
    if (!details) return null;
    var drawer = saDrawerEl(details);
    var backdrop = saBackdropEl(details);
    try {
      /* Backdrop first, drawer last — paint-order fallback if z-index races on iOS */
      if (backdrop && backdrop.parentElement !== document.body) {
        saPortalMarker(backdrop, "backdrop");
        document.body.appendChild(backdrop);
      }
      if (drawer && drawer.parentElement !== document.body) {
        saPortalMarker(drawer, "drawer");
        document.body.appendChild(drawer);
      } else if (drawer && backdrop && drawer.parentElement === document.body) {
        try {
          document.body.appendChild(drawer);
        } catch (_ord) {}
      }
    } catch (_p) {}
    return drawer;
  }

  function saUnportalEl(el) {
    if (!el || el.getAttribute("data-sa-portaled") !== "1") return;
    var mark = el.__saHomeMark;
    var kind = el.getAttribute("data-sa-portal-kind");
    try {
      if (mark && mark.parentNode) {
        mark.parentNode.insertBefore(el, mark);
        mark.parentNode.removeChild(mark);
      }
    } catch (_u) {}
    el.__saHomeMark = null;
    el.removeAttribute("data-sa-portaled");
    el.removeAttribute("data-sa-portal-kind");
    if (kind === "drawer") {
      try {
        el.setAttribute("ref", "menuDrawer");
      } catch (_ref) {}
    }
  }

  function saUnportalDrawer(details) {
    var drawer =
      document.querySelector("body > .menu-drawer[data-sa-portaled='1']") ||
      (details && details.querySelector(".menu-drawer[data-sa-portaled='1']"));
    var backdrop =
      document.querySelector(
        "body > .menu-drawer__backdrop[data-sa-portaled='1']",
      ) ||
      (details &&
        details.querySelector(".menu-drawer__backdrop[data-sa-portaled='1']"));
    saUnportalEl(drawer);
    saUnportalEl(backdrop);
  }

  function saDrawerOnScreen(drawer) {
    if (!drawer) return false;
    try {
      var rect = drawer.getBoundingClientRect();
      return (
        rect.width > 80 &&
        rect.height > 80 &&
        rect.left > -40 &&
        rect.left < Math.min(120, (window.innerWidth || 400) * 0.4)
      );
    } catch (_r) {
      return false;
    }
  }

  /* Ownership only — never trust theme mid-open attrs or orphan geometry
     (drawer intent fix). */
  function saDrawerIsOpen() {
    return !!__saDrawerWantOpen;
  }

  function saAssertOpenAttrs(details, summary) {
    if (!details || !__saDrawerWantOpen) return;
    details.setAttribute("data-sa-drawer-owned", "1");
    /* Only mutate when missing — same-value setAttribute can retrigger MO loops */
    if (!details.hasAttribute("open")) details.setAttribute("open", "");
    if (!details.classList.contains("menu-open")) details.classList.add("menu-open");
    if (!document.documentElement.classList.contains("sa-menu-open")) {
      document.documentElement.classList.add("sa-menu-open");
    }
    if (summary) summary.setAttribute("aria-expanded", "true");
    __saMenuWasOpen = true;
  }

  function saClearDrawerPaint(details) {
    var drawer = saDrawerEl(details);
    var backdrop = saBackdropEl(details);
    [drawer, backdrop].forEach(function (el) {
      if (!el || !el.style) return;
      [
        "transform",
        "translate",
        "visibility",
        "opacity",
        "pointer-events",
        "display",
        "transition",
        "position",
        "left",
        "top",
        "right",
        "bottom",
        "height",
        "width",
        "max-width",
        "z-index",
        "inset",
        "background",
        "overflow",
        "flex-direction",
        "margin",
      ].forEach(function (p) {
        el.style.removeProperty(p);
      });
    });
  }

  /* Challenge-parity: keep OPEN geometry on the element. Relying only on
     html.sa-menu-open CSS lost the race with theme MO on normal pages.
     Geometry is applied once; open/close only flips via sa-menu-open class. */
  function saPaintOpenDrawer(drawer, backdrop, opts) {
    opts = opts || {};
    var layoutOnly = !!opts.layoutOnly;
    var off = !!opts.offscreen;
    var pe = opts.pointerEvents === "auto" ? "auto" : "none";
    var motionOnly = !!opts.motionOnly;
    if (drawer) {
      if (!motionOnly || drawer.getAttribute("data-sa-geo") !== "1") {
        drawer.style.setProperty("display", "flex", "important");
        drawer.style.setProperty("flex-direction", "column", "important");
        drawer.style.setProperty("position", "fixed", "important");
        drawer.style.setProperty("inset", "0 auto 0 0", "important");
        drawer.style.setProperty("top", "0", "important");
        drawer.style.setProperty("left", "0", "important");
        drawer.style.setProperty("right", "auto", "important");
        drawer.style.setProperty("width", "min(82vw, 20rem)", "important");
        drawer.style.setProperty("max-width", "min(82vw, 20rem)", "important");
        drawer.style.setProperty("height", "100dvh", "important");
        drawer.style.setProperty("max-height", "100dvh", "important");
        drawer.style.setProperty("z-index", "2147483646", "important");
        drawer.style.setProperty("background", "#fff", "important");
        drawer.style.setProperty("overflow", "auto", "important");
        drawer.style.setProperty("margin", "0", "important");
        drawer.style.setProperty("backface-visibility", "hidden", "important");
        drawer.style.setProperty("-webkit-backface-visibility", "hidden", "important");
        drawer.setAttribute("data-sa-geo", "1");
      }
      if (!layoutOnly) {
        drawer.style.setProperty(
          "transform",
          off ? "translate3d(-100%,0,0) translateZ(0)" : "translate3d(0,0,0) translateZ(0)",
          "important",
        );
        drawer.style.setProperty("translate", "none", "important");
        drawer.style.setProperty("visibility", "visible", "important");
        drawer.style.setProperty("opacity", "1", "important");
      }
      drawer.style.setProperty("pointer-events", pe, "important");
    }
    if (backdrop) {
      if (!motionOnly || backdrop.getAttribute("data-sa-geo") !== "1") {
        var isOpen =
          !!document.documentElement.classList.contains("sa-menu-open") ||
          !!document.querySelector("details.menu-drawer-container.menu-open");
        backdrop.style.setProperty("display", isOpen ? "block" : "none", "important");
        backdrop.style.setProperty("position", "fixed", "important");
        backdrop.style.setProperty("inset", "0", "important");
        backdrop.style.setProperty("width", "100vw", "important");
        backdrop.style.setProperty("height", "100dvh", "important");
        backdrop.style.setProperty("z-index", "2147483645", "important");
        backdrop.style.setProperty("background", "rgba(15,23,42,.42)", "important");
        backdrop.style.setProperty("margin", "0", "important");
        backdrop.setAttribute("data-sa-geo", "1");
      }
      if (!layoutOnly) {
        backdrop.style.setProperty(
          "opacity",
          off ? "0" : "1",
          "important",
        );
        backdrop.style.setProperty(
          "visibility",
          off && opts.hideWhenOff ? "hidden" : "visible",
          "important",
        );
      }
      backdrop.style.setProperty("pointer-events", pe, "important");
    }
  }

  function saArmDrawerPointerEvents(details) {
    if (!__saDrawerWantOpen) return;
    var drawer = saDrawerEl(details);
    var backdrop = saBackdropEl(details);
    if (drawer) drawer.style.setProperty("pointer-events", "auto", "important");
    if (backdrop) backdrop.style.setProperty("pointer-events", "auto", "important");
  }


  function saClearHeaderIconFocus() {
    try {
      var ae = document.activeElement;
      if (ae && typeof ae.blur === "function") {
        var tag = (ae.tagName || "").toLowerCase();
        if (
          tag === "body" ||
          tag === "html" ||
          (ae.closest &&
            ae.closest(
              "#header-component, header-component, .header__column--right, header-actions, .menu-drawer-container",
            ))
        ) {
          ae.blur();
        }
      }
    } catch (_b) {}
    try {
      var hdr = document.querySelector("#header-component, header-component");
      if (!hdr) return;
      var nodes = hdr.querySelectorAll(
        ".header__column--right, header-actions, .header-actions, .header__icons, search-button, .header__icon--search, .header-search, account-button, .account-button, .header__icon--account, cart-icon, .header__icon--cart, .header-actions__action, .sa-header-action-btn, search-button button, .action__cart-btn",
      );
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (!n || !n.style) continue;
        /* Never lock background via inline !important — that kills CSS :hover circle */
        n.style.removeProperty("background");
        n.style.removeProperty("background-color");
        n.style.setProperty("outline", "none", "important");
        n.style.setProperty("box-shadow", "none", "important");
        n.style.setProperty("-webkit-tap-highlight-color", "transparent", "important");
      }
    } catch (_c) {}
  }

  function saRestoreHeaderChrome() {
    try {
      if (document.documentElement.classList.contains("sa-drawer-navigating")) return;
      document.documentElement.classList.remove("sa-menu-open", "sa-drawer-animating");
      unlockBodyScrollForDrawer();
      var hdr = document.querySelector("#header-component, header-component");
      if (!hdr) return;
      var nodes = hdr.querySelectorAll(
        ".header__column--right, .header__column--center, .header-logo, [data-testid='header-logo'], header-actions, .header-actions, .header__icon--search, .header__icon--account, cart-icon, search-button, a.account-button, .cart-count-bubble, .sa-header-action-btn, .announcement-bar, announcement-bar, .header-announcements"
      );
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (!n || !n.style) continue;
        n.style.removeProperty("visibility");
        n.style.removeProperty("opacity");
        n.style.removeProperty("pointer-events");
      }
      saClearHeaderIconFocus();
      try { pinBrandLogo(hdr); } catch (_p) {}
      try { pinHeaderActions(hdr); } catch (_pa) {}
    } catch (_r) {}
  }

  function saClearDeadDrawer(details, host, reason) {
    if (!details) return;
    try {
      __saDrawerWantOpen = false;
      window.__saDrawerWantOpen = false;
      __saDrawerBusy = false;
      __saDrawerContentToken += 1;
      details.classList.remove("menu-open");
      details.removeAttribute("open");
      details.removeAttribute("data-sa-drawer-owned");
      document.documentElement.classList.remove("sa-menu-open", "sa-drawer-animating");
      __saMenuWasOpen = false;
      saRestoreHeaderChrome();
      var summary = details.querySelector("summary");
      if (summary) summary.setAttribute("aria-expanded", "false");
      /* Snap closed via CSS class; keep portaled shell warm for next open */
      var drawer = saDrawerEl(details);
      var backdrop = saBackdropEl(details);
      if (drawer && drawer.getAttribute("data-sa-portaled") === "1") {
        saPaintDrawerLayout(drawer, backdrop);
        saClearMotionInline(drawer);
        saClearMotionInline(backdrop);
      } else {
        saClearDrawerPaint(details);
        saUnportalDrawer(details);
      }
    } catch (_clr) {}
  }

  function saCancelDrawerAnim(el) {
    if (!el) return;
    if (el.__saRaf) {
      try {
        cancelAnimationFrame(el.__saRaf);
      } catch (_r) {}
      el.__saRaf = 0;
    }
    if (el.__saWa) {
      try {
        el.__saWa.cancel();
      } catch (_c) {}
      el.__saWa = null;
    }
  }

  /* Unit cubic-bezier Y at progress t (x≈t for UI easings). */
  function saEaseY(t, x1, y1, x2, y2) {
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    var u = t;
    for (var i = 0; i < 5; i++) {
      var cx =
        3 * (1 - u) * (1 - u) * u * x1 +
        3 * (1 - u) * u * u * x2 +
        u * u * u;
      var dx =
        3 * (1 - u) * (1 - u) * x1 +
        6 * (1 - u) * u * (x2 - x1) +
        3 * u * u * (1 - x2);
      if (Math.abs(dx) < 1e-6) break;
      u -= (cx - t) / dx;
      if (u < 0) u = 0;
      else if (u > 1) u = 1;
    }
    return (
      3 * (1 - u) * (1 - u) * u * y1 +
      3 * (1 - u) * u * u * y2 +
      u * u * u
    );
  }

  /* rAF + inline !important — WAAPI loses to CSS transform !important
     (249: stuck at -320 then snap at settle ~360ms). */
  function saAnimateDrawerX(el, fromX, toX, ms, _ease, onDone) {
    if (!el) {
      if (onDone) onDone();
      return null;
    }
    saCancelDrawerAnim(el);
    var from = fromX === "-100%" || fromX === -1 ? -1 : 0;
    var to = toX === "-100%" || toX === -1 ? -1 : 0;
    var dur = ms || 320;
    var t0 = performance.now();
    var token = (el.__saAnimToken = (el.__saAnimToken || 0) + 1);
    el.style.setProperty("transition", "none", "important");
    el.style.setProperty(
      "transform",
      "translate3d(" + from * 100 + "%,0,0) translateZ(0)",
      "important",
    );

    function apply(p) {
      var e = saEaseY(p, 0.32, 0.72, 0, 1);
      var x = from + (to - from) * e;
      el.style.setProperty(
        "transform",
        "translate3d(" + x * 100 + "%,0,0) translateZ(0)",
        "important",
      );
    }

    function frame(now) {
      if (el.__saAnimToken !== token) return;
      var p = Math.min(1, (now - t0) / dur);
      apply(p);
      if (p < 1) {
        el.__saRaf = requestAnimationFrame(frame);
      } else {
        el.__saRaf = 0;
        apply(1);
        if (onDone) onDone();
      }
    }
    el.__saRaf = requestAnimationFrame(frame);
    return token;
  }

  function saAnimateBackdropOpacity(el, fromOp, toOp, ms) {
    if (!el) return;
    saCancelDrawerAnim(el);
    var dur = ms || 260;
    var t0 = performance.now();
    var token = (el.__saAnimToken = (el.__saAnimToken || 0) + 1);
    el.style.setProperty("transition", "none", "important");
    el.style.setProperty("opacity", String(fromOp), "important");

    function frame(now) {
      if (el.__saAnimToken !== token) return;
      var p = Math.min(1, (now - t0) / dur);
      var e = saEaseY(p, 0.32, 0.72, 0, 1);
      var o = fromOp + (toOp - fromOp) * e;
      el.style.setProperty("opacity", String(o), "important");
      if (p < 1) {
        el.__saRaf = requestAnimationFrame(frame);
      } else {
        el.__saRaf = 0;
        el.style.setProperty("opacity", String(toOp), "important");
      }
    }
    el.__saRaf = requestAnimationFrame(frame);
  }

  function saSmoothOpen(details, summary, reason) {
    if (!details) return;
    var drawer = saDrawerEl(details);
    /* Dual-open kill: pointerdown + late click both called open */
    if (__saDrawerOpening || (__saDrawerWantOpen && !saDrawerOnScreen(drawer) && __saDrawerBusy)) {
      return;
    }
    if (
      __saDrawerWantOpen &&
      details.classList.contains("menu-open") &&
      details.hasAttribute("open") &&
      saDrawerOnScreen(drawer)
    ) {
      return;
    }
    var alreadyBody =
      !!(drawer && drawer.parentElement === document.body && drawer.getAttribute("data-sa-portaled") === "1");
    var hasGeo = !!(drawer && drawer.getAttribute("data-sa-geo") === "1");
    __saDrawerOpening = true;
    __saDrawerWantOpen = true;
    window.__saDrawerWantOpen = true;
    __saDrawerBusy = true;
    window.__saIgnoreCloserUntil = Date.now() + 450;
    if (summary) summary.setAttribute("aria-expanded", "true");
    window.__saHamGhostUntil = Date.now() + 650;
    details.setAttribute("data-sa-drawer-owned", "1");

    drawer = alreadyBody ? drawer : saPortalDrawer(details);
    if (!drawer) drawer = saPortalDrawer(details);
    var backdrop = saBackdropEl(details);
    saSuppressGhostDrawers();

    if (!(alreadyBody && hasGeo)) {
      saPaintDrawerLayout(drawer, backdrop);
    } else if (drawer) {
      drawer.style.setProperty("pointer-events", "none", "important");
      if (backdrop) backdrop.style.setProperty("pointer-events", "none", "important");
    }
    if (drawer) drawer.style.setProperty("overflow", "hidden", "important");

    var openMs = 320;
    var ease = "cubic-bezier(0.32, 0.72, 0, 1)";
    var opened = false;

    function afterOpen() {
      if (opened) return;
      opened = true;
      if (!__saDrawerWantOpen) {
        __saDrawerOpening = false;
        return;
      }
      saAssertOpenAttrs(details, summary);
      saSuppressGhostDrawers();
      drawer = saDrawerEl(details);
      backdrop = saBackdropEl(details);
      if (drawer) {
        drawer.style.setProperty("overflow", "auto", "important");
        drawer.style.setProperty("pointer-events", "auto", "important");
        drawer.style.setProperty(
          "transform",
          "translate3d(0,0,0) translateZ(0)",
          "important",
        );
        drawer.style.setProperty("transition", "none", "important");
      }
      if (backdrop) {
        backdrop.style.setProperty("opacity", "1", "important");
        backdrop.style.setProperty("pointer-events", "auto", "important");
        backdrop.style.setProperty("transition", "none", "important");
      }
      saArmDrawerPointerEvents(details);
      __saDrawerOpening = false;
      __saDrawerPoseLock = false;
      saHydrateDrawerContent({
        harden: true,
        forceCollections: false,
        delayMs: 0,
        idleTimeout: 180,
      });
      paintRichDrawerNav();
    }

    /* Pose + flip sync. Pose-lock through start. */
    __saDrawerPoseLock = true;
    saAssertOpenAttrs(details, summary);
    if (drawer) {
      drawer.style.setProperty("visibility", "visible", "important");
      drawer.style.setProperty("opacity", "1", "important");
    }
    if (backdrop) {
      backdrop.style.setProperty("display", "block", "important");
      backdrop.style.setProperty("visibility", "visible", "important");
      backdrop.style.setProperty("opacity", "0", "important");
    }
    try {
      if (drawer) void drawer.offsetWidth;
    } catch (_rf) {}

    saBeginDrawerAnim(openMs + 40);
    saAnimateBackdropOpacity(backdrop, 0, 1, Math.round(openMs * 0.85), ease);
    saAnimateDrawerX(drawer, "-100%", "0", openMs, ease, afterOpen);

    saHoldOpenAttrs(details, summary, 420);
    __saDrawerBusy = false;
    /* Unlock reclaim after first paint tick — never mid pose */
    window.setTimeout(function () {
      if (__saDrawerOpening) __saDrawerPoseLock = false;
    }, 48);

    document.addEventListener(
      "pointerup",
      function () {
        if (__saDrawerWantOpen) {
          saAssertOpenAttrs(details, summary);
        }
      },
      { capture: true, once: true },
    );
  }

  function saSmoothClose(details, reason) {
    if (!details) return;
    if (!__saDrawerWantOpen && !details.classList.contains("menu-open") && !details.hasAttribute("open")) {
      return;
    }
    __saDrawerWantOpen = false;
    window.__saDrawerWantOpen = false;
    __saDrawerOpening = false;
    __saDrawerBusy = true;
    __saDrawerContentToken += 1;
    var drawer = saDrawerEl(details);
    var backdrop = saBackdropEl(details);
    saSuppressGhostDrawers();
    var summary = details.querySelector("summary");
    if (summary) summary.setAttribute("aria-expanded", "false");
    details.setAttribute("data-sa-drawer-owned", "1");
    if (drawer) {
      drawer.style.setProperty("overflow", "hidden", "important");
      drawer.style.setProperty("pointer-events", "none", "important");
    }
    if (backdrop) {
      backdrop.style.setProperty("pointer-events", "none", "important");
    }

    var closeMs = 280;
    var ease = "cubic-bezier(0.32, 0.72, 0, 1)";
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      if (!__saDrawerWantOpen) {
        details.classList.remove("menu-open");
        document.documentElement.classList.remove("sa-menu-open");
        __saMenuWasOpen = false;
        if (drawer) {
          saCancelDrawerAnim(drawer);
          drawer.style.setProperty(
            "transform",
            "translate3d(-100%,0,0) translateZ(0)",
            "important",
          );
          drawer.style.setProperty("overflow", "hidden", "important");
          drawer.style.setProperty("pointer-events", "none", "important");
          drawer.style.setProperty("transition", "none", "important");
        }
        if (backdrop) {
          saCancelDrawerAnim(backdrop);
          backdrop.style.setProperty("opacity", "0", "important");
          backdrop.style.setProperty("visibility", "hidden", "important");
          backdrop.style.setProperty("pointer-events", "none", "important");
          backdrop.style.setProperty("transition", "none", "important");
          backdrop.style.setProperty("display", "none", "important");
        }
        details.removeAttribute("open");
        details.removeAttribute("data-sa-drawer-owned");
      }
      __saDrawerBusy = false;
      saRestoreHeaderChrome();
    }

    saBeginDrawerAnim(closeMs + 40);
    saAnimateBackdropOpacity(backdrop, 1, 0, Math.round(closeMs * 0.9), ease);
    saAnimateDrawerX(drawer, "0", "-100%", closeMs, ease, finish);
  }

  /* Instant hide before in-drawer navigation — no slide anim / scroll unlock jitter */
  function saHideDrawerForNavigation(details) {
    __saDrawerWantOpen = false;
    window.__saDrawerWantOpen = false;
    __saDrawerOpening = false;
    __saDrawerBusy = false;
    __saDrawerContentToken += 1;
    document.documentElement.classList.add("sa-drawer-navigating");
    document.documentElement.classList.remove("sa-drawer-animating");
    window.clearTimeout(window.__saDrawerAnimTimer);
    var drawer = saDrawerEl(details);
    var backdrop = saBackdropEl(details);
    saSuppressGhostDrawers();
    if (details) {
      details.classList.remove("menu-open");
      details.removeAttribute("open");
      details.removeAttribute("data-sa-drawer-owned");
      var summary = details.querySelector("summary");
      if (summary) summary.setAttribute("aria-expanded", "false");
    }
    if (drawer) {
      saCancelDrawerAnim(drawer);
      drawer.style.setProperty("visibility", "hidden", "important");
      drawer.style.setProperty("opacity", "0", "important");
      drawer.style.setProperty("pointer-events", "none", "important");
      drawer.style.setProperty(
        "transform",
        "translate3d(-100%,0,0) translateZ(0)",
        "important",
      );
      drawer.style.setProperty("transition", "none", "important");
      drawer.style.setProperty("overflow", "hidden", "important");
    }
    if (backdrop) {
      saCancelDrawerAnim(backdrop);
      backdrop.style.setProperty("display", "none", "important");
      backdrop.style.setProperty("opacity", "0", "important");
      backdrop.style.setProperty("visibility", "hidden", "important");
      backdrop.style.setProperty("pointer-events", "none", "important");
      backdrop.style.setProperty("transition", "none", "important");
    }
    /* Keep sa-menu-open + body scroll lock until page unloads — prevents iOS scrollbar flash */
  }

  function saCompleteDrawerOpen(details, host, summary, reason) {
    saSmoothOpen(details, summary, reason || "complete-open");
  }

  /**
   * v13: pointerdown intent is sole truth for hamburger.
   * Theme header-drawer.open() races between down→up and set menuOpen while
   * want=false; treating that as "open" closed the drawer on first click
   *.
   */
  document.addEventListener(
    "toggle",
    function (ev) {
      var details = ev.target;
      if (
        !details ||
        !details.classList ||
        !details.classList.contains("menu-drawer-container")
      ) {
        return;
      }
      /* While we own the open session, ignore theme toggle noise — do NOT re-paint
         (log E: mid-slide strip → re-paint was the jitter). */
      if (__saDrawerWantOpen) {
        var summaryKeep = details.querySelector("summary");
        if (!details.open || !details.classList.contains("menu-open")) {
          saAssertOpenAttrs(details, summaryKeep);
        }
        return;
      }
      if (details.getAttribute("data-sa-drawer-owned") === "1") {
        details.removeAttribute("data-sa-drawer-owned");
        return;
      }
      if (!__saDrawerWantOpen && details.open) {
        details.removeAttribute("open");
        details.classList.remove("menu-open");
        return;
      }
      var summary = details.querySelector("summary");
      if (details.open) {
        if (!__saDrawerWantOpen) {
          details.removeAttribute("open");
          details.classList.remove("menu-open");
        }
      } else {
        details.classList.remove("menu-open");
        if (summary) summary.setAttribute("aria-expanded", "false");
        document.documentElement.classList.remove("sa-menu-open");
        __saMenuWasOpen = false;
  syncMenuOpenClass();
      }
    },
    true,
  );

  document.addEventListener(
    "pointerdown",
    function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var summary = t.closest(
        "summary.header__icon--menu, summary.header__icon--summary",
      );
      if (!summary) return;
      if (
        !summary.classList.contains("header__icon--menu") &&
        !summary.classList.contains("header__icon--summary")
      ) {
        return;
      }
      if (summary.closest(".menu-drawer__navigation, .menu-drawer__submenu")) return;
      var details = summary.closest("details.menu-drawer-container");
      if (!details) return;
      try {
        ev.preventDefault();
        ev.stopPropagation();
        ev.stopImmediatePropagation();
      } catch (_pd) {}
      /* Touch browsers often omit click after preventDefault on pointerdown —
         toggle here so hamburger works on mobile. */
      var live = saDrawerEl(details);
      /* Skip layout read on cold open — only needed to recover stuck wantOpen */
      var onScreen = false;
      if (__saDrawerWantOpen) {
        onScreen = saDrawerOnScreen(live);
        if (!onScreen) {
          __saDrawerWantOpen = false;
          window.__saDrawerWantOpen = false;
        }
      }
      var intent = __saDrawerWantOpen || onScreen ? "close" : "open";
      __saHamIntent = intent;
      __saHamHandledAt = Date.now();
      if (intent === "close") {
        saSmoothClose(details, "owned-hamburger-pointerdown");
      } else {
        saSmoothOpen(details, summary, "owned-hamburger-pointerdown");
      }
    },
    true,
  );

  var __saDrawerCloseLock = 0;

  function saIsCloseButton(closer) {
    if (!closer) return false;
    return (
      closer.classList.contains("menu-drawer__close-btn") ||
      closer.classList.contains("sa-drawer-close-btn") ||
      closer.classList.contains("menu-drawer__close-button") ||
      closer.classList.contains("close-button") ||
      (closer.tagName === "BUTTON" && closer.closest(".sa-drawer-header, .menu-drawer"))
    );
  }

  function saResolveDrawerCloser(t) {
    if (!t || !t.closest) return null;
    if (
      t.closest(
        "body > .menu-drawer[data-sa-portaled='1'] .sa-drawer-nav, body > .menu-drawer[data-sa-portaled='1'] a[href], .menu-drawer .sa-drawer-nav a[href], a.sa-drawer-sublink, a.sa-drawer-link",
      ) &&
      !t.closest(".menu-drawer__backdrop")
    ) {
      return null;
    }
    return t.closest(
      ".menu-drawer__close-button, .menu-drawer__close-btn, .sa-drawer-close-btn, button.close-button.menu-drawer__close-button, .menu-drawer__backdrop",
    );
  }

  function saCommitDrawerClose(ev, closer) {
    if (!closer) {
      if (!ev || !ev.target) return false;
      closer = saResolveDrawerCloser(ev.target);
    }
    if (!closer) return false;
    if (Date.now() - __saDrawerCloseLock < 450) return true;

    var details = closer.closest("details.menu-drawer-container");
    if (!details) details = document.querySelector("details.menu-drawer-container");
    if (!details) return false;

    var isBackdrop = closer.classList.contains("menu-drawer__backdrop");
    var isBtn = saIsCloseButton(closer);

    /* Ghost-open guard applies to backdrop only — X must always close */
    if (!isBtn && Date.now() < (window.__saIgnoreCloserUntil || 0)) {
      return false;
    }

    var portaledCloser =
      closer.getAttribute("data-sa-portaled") === "1" ||
      !!(closer.closest && closer.closest("[data-sa-portaled='1'], body > .menu-drawer"));

    if (
      !__saDrawerWantOpen &&
      !details.classList.contains("menu-open") &&
      !details.hasAttribute("open") &&
      !document.documentElement.classList.contains("sa-menu-open")
    ) {
      if (portaledCloser || document.querySelector("body > .menu-drawer__backdrop[data-sa-portaled='1']")) {
        if (ev) {
          try {
            ev.preventDefault();
            ev.stopPropagation();
            ev.stopImmediatePropagation();
          } catch (_p) {}
        }
        __saDrawerCloseLock = Date.now();
        try {
          __saDrawerNavTap = null;
        } catch (_n) {}
        saSmoothClose(details, "owned-close-fallback");
        return true;
      }
      return false;
    }

    if (ev) {
      try {
        ev.preventDefault();
        ev.stopPropagation();
        ev.stopImmediatePropagation();
      } catch (_p) {}
    }
    __saDrawerCloseLock = Date.now();
    try {
      __saDrawerNavTap = null;
    } catch (_n2) {}
    saSmoothClose(details, isBackdrop ? "owned-backdrop" : "owned-close-btn");
    return true;
  }

  document.addEventListener(
    "click",
    function (ev) {
      var closer = saResolveDrawerCloser(ev.target);
      if (!closer) return;
      saCommitDrawerClose(ev, closer);
    },
    true,
  );

  /* iOS: close X often drops click — touchend + pointerdown are primary */
  var __saDrawerCloseTap = null;

  document.addEventListener(
    "touchstart",
    function (e) {
      if (!saDrawerNavActive()) {
        __saDrawerCloseTap = null;
        return;
      }
      var closer = saResolveDrawerCloser(e.target);
      if (!closer || !saIsCloseButton(closer)) {
        __saDrawerCloseTap = null;
        return;
      }
      var touch = (e.changedTouches && e.changedTouches[0]) || (e.touches && e.touches[0]);
      if (!touch) return;
      __saDrawerCloseTap = {
        el: closer,
        x: touch.clientX,
        y: touch.clientY,
      };
    },
    true,
  );

  document.addEventListener(
    "touchend",
    function (e) {
      var tap = __saDrawerCloseTap;
      __saDrawerCloseTap = null;
      if (!tap) return;
      var touch = e.changedTouches && e.changedTouches[0];
      if (!touch) return;
      if (Math.abs(touch.clientX - tap.x) > 24 || Math.abs(touch.clientY - tap.y) > 24) return;
      var closer = tap.el;
      if (!closer || !closer.isConnected) {
        closer = saResolveDrawerCloser(e.target);
      }
      if (!closer || !saIsCloseButton(closer)) return;
      saCommitDrawerClose(e, closer);
    },
    true,
  );

  document.addEventListener(
    "pointerdown",
    function (ev) {
      if (ev.pointerType === "mouse") return;
      var closer = saResolveDrawerCloser(ev.target);
      if (!closer || !saIsCloseButton(closer)) return;
      try {
        ev.preventDefault();
        ev.stopPropagation();
        ev.stopImmediatePropagation();
      } catch (_pd) {}
      saCommitDrawerClose(ev, closer);
    },
    true,
  );

  document.addEventListener(
    "click",
    function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var summary = t.closest(
        "summary.header__icon--menu, summary.header__icon--summary",
      );
      if (!summary) return;
      if (
        !summary.classList.contains("header__icon--menu") &&
        !summary.classList.contains("header__icon--summary")
      ) {
        return;
      }
      if (summary.closest(".menu-drawer__navigation, .menu-drawer__submenu")) return;
      var details = summary.closest("details.menu-drawer-container");
      if (!details) return;

      ev.preventDefault();
      ev.stopImmediatePropagation();

      /* Already toggled on pointerdown — don't double-open (242: 700ms window too short) */
      if (__saHamHandledAt && Date.now() - __saHamHandledAt < 1500) {
        __saHamIntent = null;
        return;
      }
      if (__saDrawerOpening || __saDrawerWantOpen) {
        __saHamIntent = null;
        return;
      }

      var intent =
        __saHamIntent || (__saDrawerWantOpen ? "close" : "open");
      __saHamIntent = null;

      if (intent === "close") {
        saSmoothClose(details, "owned-hamburger-close");
      } else {
        saSmoothOpen(details, summary, "owned-hamburger-open");
      }
    },
    true,
  );

  syncMenuOpenClass();
  /* Always reset sticky drawer attrs on boot */
  try {
    var stale = document.querySelector("details.menu-drawer-container");
    if (stale) saClearDeadDrawer(stale, null, "boot-force-reset");
  } catch (_stale) {}
  /* Ghost guard: ONLY block accidental Home from open-under-finger.
     Old logic blocked EVERY .menu-drawer link for ~650ms — iOS users
     tap Shop/About right after open and got preventDefault (Android often
     tapped after the window, so it "worked" there). */
  function saHrefIsHome(href) {
    if (href == null) return false;
    var raw = String(href).trim();
    if (!raw || raw.charAt(0) === "#") return false;
    try {
      var u = new URL(raw, location.href);
      var p = (u.pathname || "/").replace(/\/$/, "") || "/";
      return p === "/";
    } catch (_u) {
      var path = raw.split("?")[0].split("#")[0].replace(/\/$/, "") || "/";
      return path === "/" || path === "";
    }
  }

  var __saDrawerNavLock = 0;
  var __saDrawerNavTap = null;
  var __saDrawerNavDest = "";
  var __saIgnoreSublinkClickUntil = 0;

  function saResolveDrawerLink(t) {
    if (!t || !t.closest) return null;
    var a = t.closest(
      "body > .menu-drawer[data-sa-portaled='1'] a[href], " +
        ".menu-drawer a[href], " +
        "#sa-fixed-drawer a[href], " +
        "a.sa-drawer-link, a.sa-drawer-sublink, a.sa-drawer-brand, a.sa-drawer-footer__btn, a[data-sa-drawer-nav]",
    );
    if (!a) return null;
    if (
      a.closest(
        ".menu-drawer__close-button, .menu-drawer__close-btn, .sa-drawer-close-btn, button.menu-drawer__close-button, button.close-button.menu-drawer__close-button",
      )
    ) {
      return null;
    }
    var hrefAttr = a.getAttribute("href");
    if (!hrefAttr || hrefAttr === "#" || hrefAttr.charAt(0) === "#") return null;
    if (a.getAttribute("target") === "_blank" || a.getAttribute("download") != null) return null;
    return a;
  }

  function saDrawerNavActive() {
    if (__saDrawerWantOpen || document.documentElement.classList.contains("sa-menu-open")) {
      return true;
    }
    var drawer = document.querySelector("body > .menu-drawer[data-sa-portaled='1']");
    return saDrawerOnScreen(drawer);
  }

  function saMarkDrawerNavigating(a) {
    document.documentElement.classList.add("sa-drawer-navigating");
    try {
      if (a) {
        a.classList.add("sa-drawer-link--pending");
        a.setAttribute("aria-busy", "true");
      }
    } catch (_m) {}
  }

  function saIsDrawerSublink(a) {
    return !!(a && a.classList && a.classList.contains("sa-drawer-sublink"));
  }

  function saMarkDrawerSublinkPending(a) {
    if (!a) return;
    try {
      var scope =
        a.closest("[data-sa-drawer-collections], .sa-drawer-subnav") ||
        document;
      var subs = scope.querySelectorAll(".sa-drawer-sublink");
      for (var i = 0; i < subs.length; i++) {
        if (subs[i] !== a) {
          subs[i].classList.remove(
            "sa-drawer-link--pending",
            "sa-drawer-sublink--active",
          );
          subs[i].removeAttribute("aria-busy");
        }
      }
      a.classList.add("sa-drawer-sublink--active", "sa-drawer-link--pending");
      a.setAttribute("aria-busy", "true");
    } catch (_s) {}
  }

  function saCommitDrawerNav(a, e) {
    if (!a || !saDrawerNavActive()) return false;
    var dest = a.href;
    if (!dest) return false;
    if (__saDrawerNavDest === dest) {
      if (e) {
        try {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        } catch (_pd) {}
      }
      return true;
    }
    if (Date.now() - __saDrawerNavLock < 900) {
      if (e) {
        try {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        } catch (_pl) {}
      }
      return true;
    }
    var hrefAttr = a.getAttribute("href");
    if (
      window.__saHamGhostUntil &&
      Date.now() <= window.__saHamGhostUntil &&
      saHrefIsHome(hrefAttr)
    ) {
      return false;
    }
    var isSublink = saIsDrawerSublink(a);
    __saDrawerNavLock = Date.now();
    __saDrawerNavDest = dest;
    window.__saDrawerNavDest = dest;
    window.__saHamGhostUntil = 0;
    if (e) {
      try {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      } catch (_p) {}
    }
    if (!isSublink) {
      var navKey = saNavKeyFromHref(dest);
      if (navKey) {
        document.documentElement.setAttribute("data-sa-nav", navKey);
        if (navKey === "bundles") {
          try {
            sessionStorage.setItem("sa-nav", "bundles");
          } catch (_ss) {}
        }
        paintRichDrawerNav();
      }
      saMarkDrawerNavigating(a);
      window.setTimeout(function () {
        try {
          window.location.assign(dest);
        } catch (_nav) {
          window.location.href = dest;
        }
      }, 180);
    } else {
      saMarkDrawerSublinkPending(a);
      try {
        window.location.assign(dest);
      } catch (_nav) {
        window.location.href = dest;
      }
    }
    return true;
  }

  function saScrollParentOf(el) {
    var n = el;
    while (n && n !== document.body && n !== document.documentElement) {
      try {
        var st = window.getComputedStyle(n);
        var oy = st && st.overflowY;
        if (
          (oy === "auto" || oy === "scroll" || oy === "overlay") &&
          n.scrollHeight > n.clientHeight + 2
        ) {
          return n;
        }
      } catch (_sp) {}
      n = n.parentElement;
    }
    return (
      document.querySelector("body > .menu-drawer[data-sa-portaled='1']") ||
      document.querySelector(".menu-drawer") ||
      null
    );
  }

  function saTapWasScroll(tap, touch) {
    if (!tap) return true;
    var dx = Math.abs(touch.clientX - tap.x);
    var dy = Math.abs(touch.clientY - tap.y);
    if (dx > 10 || dy > 10) return true;
    if (Date.now() - tap.t > 480) return true;
    if (tap.scrollEl && typeof tap.scrollTop === "number") {
      try {
        if (Math.abs((tap.scrollEl.scrollTop || 0) - tap.scrollTop) > 2) {
          return true;
        }
      } catch (_st) {}
    }
    return false;
  }

  /* iOS: touchstart records tap; touchend navigates (click is often dropped).
     Collection sublinks: never treat scroll-stop as a tap. */
  document.addEventListener(
    "touchstart",
    function (e) {
      if (!saDrawerNavActive()) {
        __saDrawerNavTap = null;
        return;
      }
      var a = saResolveDrawerLink(e.target);
      if (!a) {
        __saDrawerNavTap = null;
        return;
      }
      var touch = (e.changedTouches && e.changedTouches[0]) || (e.touches && e.touches[0]);
      if (!touch) return;
      var scrollEl = saScrollParentOf(a);
      __saDrawerNavTap = {
        el: a,
        x: touch.clientX,
        y: touch.clientY,
        t: Date.now(),
        scrollEl: scrollEl,
        scrollTop: scrollEl ? scrollEl.scrollTop || 0 : 0,
        moved: false,
      };
      window.__saHamGhostUntil = 0;
    },
    true,
  );

  document.addEventListener(
    "touchmove",
    function (e) {
      var tap = __saDrawerNavTap;
      if (!tap) return;
      var touch = (e.changedTouches && e.changedTouches[0]) || (e.touches && e.touches[0]);
      if (!touch) return;
      if (
        Math.abs(touch.clientX - tap.x) > 8 ||
        Math.abs(touch.clientY - tap.y) > 8
      ) {
        tap.moved = true;
      }
      if (tap.scrollEl && typeof tap.scrollTop === "number") {
        try {
          if (Math.abs((tap.scrollEl.scrollTop || 0) - tap.scrollTop) > 2) {
            tap.moved = true;
          }
        } catch (_tm) {}
      }
    },
    { capture: true, passive: true },
  );

  document.addEventListener(
    "touchend",
    function (e) {
      var tap = __saDrawerNavTap;
      __saDrawerNavTap = null;
      if (!tap || !saDrawerNavActive()) return;
      var touch = e.changedTouches && e.changedTouches[0];
      if (!touch) return;

      var isSublink = saIsDrawerSublink(tap.el);
      if (isSublink) {
        /* Scroll / drag / long press → never navigate (fixes scroll-stop open) */
        if (tap.moved || saTapWasScroll(tap, touch)) {
          __saIgnoreSublinkClickUntil = Date.now() + 700;
          return;
        }
        var a = tap.el;
        if (!a || !a.isConnected) {
          a = saResolveDrawerLink(e.target);
        }
        /* Must be the SAME collection link that received touchstart */
        if (!a || a !== tap.el) {
          __saIgnoreSublinkClickUntil = Date.now() + 700;
          return;
        }
        saCommitDrawerNav(a, e);
        return;
      }

      var maxMove = 22;
      if (
        Math.abs(touch.clientX - tap.x) > maxMove ||
        Math.abs(touch.clientY - tap.y) > maxMove
      ) {
        return;
      }
      var link = tap.el;
      if (!link || !link.isConnected) {
        link = saResolveDrawerLink(e.target);
      }
      if (!link) {
        try {
          link = saResolveDrawerLink(
            document.elementFromPoint(touch.clientX, touch.clientY),
          );
        } catch (_ep) {}
      }
      if (!link) return;
      saCommitDrawerNav(link, e);
    },
    true,
  );

  document.addEventListener(
    "touchcancel",
    function () {
      __saDrawerNavTap = null;
      __saDrawerCloseTap = null;
    },
    true,
  );

  document.addEventListener(
    "pointerdown",
    function (e) {
      if (e.pointerType === "touch") return;
      if (!saDrawerNavActive()) return;
      var a = saResolveDrawerLink(e.target);
      if (!a) return;
      window.__saHamGhostUntil = 0;
    },
    true,
  );

  document.addEventListener(
    "click",
    function (e) {
      if (!window.__saHamGhostUntil || Date.now() > window.__saHamGhostUntil) return;
      var t = e.target;
      if (!t || !t.closest) return;
      var a = t.closest("a[href], area[href]");
      if (!a) return;
      if (!saHrefIsHome(a.getAttribute("href"))) return;
      try {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      } catch (_g) {}
    },
    true,
  );

  document.addEventListener(
    "click",
    function (e) {
      if (!saDrawerNavActive()) return;
      var a = saResolveDrawerLink(e.target);
      if (!a) return;
      if (
        saIsDrawerSublink(a) &&
        Date.now() < __saIgnoreSublinkClickUntil
      ) {
        try {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        } catch (_ig) {}
        return;
      }
      saCommitDrawerNav(a, e);
    },
    true,
  );
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var openDetails = document.querySelector(
      "details.menu-drawer-container[open], details.menu-drawer-container.menu-open",
    );
    if (!openDetails) return;
    e.preventDefault();
    saClearDeadDrawer(openDetails, null, "escape");
  });
  /* Expose for theme.liquid challenge path + re-open from other embeds */
  window.saSmoothOpen = saSmoothOpen;
  window.saSmoothClose = saSmoothClose;
  window.saCommitDrawerNav = saCommitDrawerNav;
  window.__saNavBootAlive = 1;
  /* Prefetch collections only — never portal/hydrate drawer shell on idle
     (portaling + paint on every page boot contributed to main-thread lockups). */
  (function warmDrawerIdle() {
    function warmNav() {
      try {
        saPrefetchDrawerCollections();
      } catch (_w) {}
    }
    saScheduleIdle(warmNav, 900);
    document.addEventListener(
      "pointerenter",
      function (ev) {
        var t = ev.target;
        if (!t || !t.closest) return;
        if (!t.closest("summary.header__icon--menu, summary.header__icon--summary")) return;
        warmNav();
      },
      true,
    );
  })();

  /* Mobile drawer must not stay open when viewport becomes desktop (≥900px) */
  (function saAutoCloseDrawerOnDesktop() {
    if (typeof window.matchMedia !== "function") return;
    var mq = window.matchMedia("(min-width: 900px)");
    function closeIfDesktop(ev) {
      var desktop = ev && typeof ev.matches === "boolean" ? ev.matches : mq.matches;
      if (!desktop) return;
      if (
        !__saDrawerWantOpen &&
        !document.documentElement.classList.contains("sa-menu-open")
      ) {
        return;
      }
      var details = document.querySelector("details.menu-drawer-container");
      if (details && typeof saSmoothClose === "function") {
        saSmoothClose(details, "responsive-desktop");
      }
    }
    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", closeIfDesktop);
    } else if (typeof mq.addListener === "function") {
      mq.addListener(closeIfDesktop);
    }
    window.addEventListener(
      "resize",
      function () {
        if (mq.matches) closeIfDesktop(mq);
      },
      { passive: true },
    );
  })();

  /* Only watch drawer attrs while intentionally open — closed-state sync caused churn */
  try {
    var menuDetails = document.querySelector("details.menu-drawer-container");
      if (menuDetails) {
      var menuMo = new MutationObserver(function () {
        if (__saDrawerPoseLock) return;
        if (!__saDrawerWantOpen) {
          try {
            syncMenuOpenClass();
          } catch (_sm) {}
          return;
        }
        var hasOpen = menuDetails.hasAttribute("open");
        var hasMenuOpen = menuDetails.classList.contains("menu-open");
          if (!hasOpen || !hasMenuOpen || !document.documentElement.classList.contains("sa-menu-open")) {
            var summaryEl = menuDetails.querySelector("summary");
            saAssertOpenAttrs(menuDetails, summaryEl);
          }
          saSuppressGhostDrawers();
      });
      menuMo.observe(menuDetails, {
      attributes: true,
      attributeFilter: ["class", "open"],
    });
    }
  } catch (eMenu) {}

  (function () {
    var seen = false;
    function onHeader() {
      if (seen) return;
      if (
        !document.querySelector(
          "#header-component header-actions, header-component header-actions, header-actions",
        )
      ) {
        return;
      }
      seen = true;
      /* Sync early swap + watch late-mounting search (was null on first early polish) */
      if (typeof window.__saWatchActionsEarlyPolish === "function") {
        window.__saWatchActionsEarlyPolish();
      } else if (typeof window.__saEarlyPolishIcons === "function") {
        window.__saEarlyPolishIcons();
      }
      window.__saOnNavIconsReady = function () {
        try {
          if (window.SelfAboutNavIcons && typeof window.SelfAboutNavIcons.polish === "function") {
            window.SelfAboutNavIcons.polish(document);
          }
        } catch (_pol) {}
        document.documentElement.classList.add("sa-icons-ready");
      };
      if (window.SelfAboutNavIcons) window.__saOnNavIconsReady();
    }
    try {
      var iconMo = new MutationObserver(onHeader);
      iconMo.observe(document.documentElement, { childList: true, subtree: true });
      onHeader();
    } catch (_mo) {}
  })();

  /* Soft PLP nav (Shop ↔ Bundles chips) — refresh underline without full reload */
  window.__saSyncNavActive = function (forcedKey) {
    try {
      if (forcedKey === "shop" || forcedKey === "bundles") {
        document.documentElement.setAttribute("data-sa-nav", forcedKey);
        try {
          if (forcedKey === "bundles") sessionStorage.setItem("sa-nav", "bundles");
          else if (sessionStorage.getItem("sa-nav") === "bundles") {
            sessionStorage.removeItem("sa-nav");
          }
        } catch (_ss) {}
      } else {
        pinNavKey();
      }
      var nav = document.getElementById("sa-fixed-nav");
      var drawer = document.getElementById("sa-fixed-drawer");
      if (nav) paintActive(nav);
      if (drawer) paintActive(drawer);
      paintRichDrawerNav();
      try {
        document.dispatchEvent(
          new CustomEvent("selfabout:nav-active", {
            detail: {
              key: document.documentElement.getAttribute("data-sa-nav") || "",
            },
          }),
        );
      } catch (_ev) {}
    } catch (_sync) {}
  };
})();
